import type { Dict } from '../types';

export const ko: Dict = {
  'chat.amrCard.switchTitle': '모델 호출 실패 — 이 작업이 일시중지되었습니다',
  'chat.amrCard.switchBody': 'Open Design Cloud 공식 모델 서비스로 전환하세요 — API 키 설정이 필요 없습니다. 로그인・인증・충전이 완료되면 이 작업이 자동으로 재시도됩니다.',
  'chat.amrCard.chipOfficial': '공식 호스팅',
  'chat.amrCard.chipNoKey': 'API 키 불필요',
  'chat.amrCard.chipAutoRetry': '로그인 후 자동 재시도',
  'chat.amrCard.switchCta': 'Open Design Cloud로 전환하고 재시도',
  'chat.amrError.authMessage': 'Open Design Cloud 계정이 아직 인증되지 않았습니다. 인증하면 이 작업이 자동으로 재시도됩니다.',
  'chat.amrError.balanceMessage': 'Open Design Cloud 잔액이 부족합니다. 충전하여 이 작업을 계속 진행하세요.',
  'chat.amrError.authorizeCta': '인증하고 재시도',
  'chat.amrError.rechargeCta': 'Open Design Cloud 충전',
  'chat.amrBalanceGate.title': '업그레이드하고 계속 만들기',
  'chat.amrBalanceGate.message': '크레딧이 부족합니다(현재 {balance}). 요금제 업그레이드 또는 충전 후 바로 시작할 수 있습니다.',
  'chat.amrBalanceGate.benefitsTitle': 'Open Design Cloud이 제공하는 것',
  'chat.amrBalanceGate.benefit1': 'API 키 없이 다양한 모델 사용',
  'chat.amrBalanceGate.benefit2': 'SOTA 디자인 에이전트 내장, 설정 불필요',
  'chat.amrBalanceGate.benefit3': '신뢰할 수 있는 공식 서비스',
  'chat.amrBalanceGate.benefit4': '계속 진화: 원클릭 배포·멀티모달·팀 버전 등',
  'chat.amrBalanceGate.laterCta': '나중에',
  'chat.amrBalanceGate.plansCta': '요금제 업그레이드',
  'chat.amrBalanceGate.signedOutTitle': '로그인하고 창작 시작하기',
  'chat.amrBalanceGate.signedOutMessage': 'Open Design Cloud 에이전트를 사용 중입니다. 로그인하면 이 작업을 바로 시작할 수 있습니다.',
  'chat.amrBalanceGate.signInCta': '로그인',
  'chat.amrBalanceGate.watchingWallet': '잔액이 반영되면 자동으로 계속됩니다.',
  'chat.amrLowBalance.title': '크레딧이 얼마 남지 않았습니다',
  'chat.amrLowBalance.message': '잔액이 {balance}만 남아 이 작업을 끝내기에 부족할 수 있습니다. 먼저 충전하거나 요금제를 업그레이드하세요.',
  'chat.amrLowBalance.rechargeCta': '충전하기',
  'chat.amrLowBalance.proceedCta': '그래도 시작',
  'chat.amrLowBalance.dontRemind': '다시 묻지 않기',
  'chat.antigravityError.launchTerminalCta': '터미널에서 로그인',
  'chat.antigravityError.launchSwitchModelCta': '터미널에서 모델 전환',
  'chat.connectionDropped': '응답이 끝나기 전에 모델 서비스 연결이 끊겼습니다. 대개 불안정한 네트워크나 프록시가 원인입니다. 다시 시도해 주세요.',
  'chat.runError.title.authRequired': '권한 부여 필요',
  'chat.runError.title.balance': '잔액 부족',
  'chat.runError.title.connectionDropped': '연결 끊김',
  'chat.runError.title.signInRequired': '로그인 필요',
  'chat.runError.title.rateLimited': '사용 한도 도달',
  'chat.runError.title.generic': '작업 실패',
  'chat.runError.signInMessage.amr': 'Open Design Cloud 에이전트가 아직 로그인되지 않았습니다. 로그인하여 사용을 시작하세요.',
  'chat.runError.signInMessage.other': '{agent}이(가) 로그인되지 않았습니다. 로컬에서 로그인 상태를 확인하세요. 더 안정적이고 경제적인 Open Design Cloud 에이전트를 추천합니다.',
  'chat.runError.agentFallback': '에이전트',
  'chat.runError.sourceLabel': '오류 소스',
  'chat.runError.sourceExpandAria': '오류 소스 펼치기',
  'chat.runError.sourceCollapseAria': '오류 소스 접기',
  'chat.runError.title.cliMissing': '에이전트가 설치되지 않음',
  'chat.runError.title.promptTooLarge': '입력이 너무 김',
  'chat.runError.title.modelUnavailable': '모델을 사용할 수 없음',
  'chat.runError.title.upstreamUnavailable': '서비스를 일시적으로 사용할 수 없음',
  'chat.runError.title.toolLoop': '루프에 갇힘',
  'chat.runError.title.outputInvalid': '잘못된 모델 출력',
  'chat.runError.title.runtimeConfig': '구성 오류',
  'chat.runError.cliMissingMessage': '{agent} 명령줄 도구를 찾을 수 없습니다. 설치한 뒤 PATH에 포함되어 있는지 확인하고 다시 시도하세요.',
  'chat.runError.promptTooLargeMessage': '이번 입력이 모델의 컨텍스트 한도를 초과했습니다. 프롬프트를 줄이거나 첨부를 제거하거나 새 대화를 시작한 뒤 다시 시도하세요.',
  'chat.runError.modelUnavailableMessage': '선택한 모델을 사용할 수 없거나 존재하지 않습니다. 설정에서 다른 모델로 전환한 뒤 다시 시도하세요.',
  'chat.runError.rateLimitedMessage': '모델 서비스의 사용 한도에 도달했습니다. 잠시 후 다시 시도하거나 다른 모델 또는 서비스로 전환하세요.',
  'chat.runError.upstreamUnavailableMessage': '모델 서비스를 일시적으로 사용할 수 없습니다. 대개 업스트림 불안정이나 네트워크/프록시 문제입니다. 잠시 후 다시 시도하세요.',
  'chat.runError.toolLoopMessage': '{agent}이(가) 같은 작업을 진전 없이 반복하여 중지되었습니다. 대상 파일이나 명령을 확인한 뒤 다시 시도하세요.',
  'chat.runError.outputInvalidMessage': '모델이 잘못된 출력을 생성하여 이번 실행이 중단되었습니다. 대개 다시 시도하면 복구됩니다.',
  'chat.runError.runtimeConfigMessage': '선택한 에이전트의 런타임 구성이 잘못되어 실행을 시작할 수 없습니다. 최신 버전으로 업데이트하거나 지원팀에 문의하세요.',
  'chat.runError.title.quotaExhausted': "사용 한도 소진",
  'chat.runError.quotaExhaustedMessage': "사용 중인 모델 서비스의 할당량 또는 청구 한도를 모두 사용해 재시도해도 복구되지 않습니다. 해당 서비스에서 충전하거나 다른 모델/서비스로 전환하세요.",
  'chat.runError.workspaceCreditsMessage': "워크스페이스 크레딧이 모두 소진되었습니다. 크레딧을 추가(또는 워크스페이스 관리자에게 충전 요청)하거나 다른 모델/서비스로 전환하세요.",
  'common.cancel': '취소',
  'chat.selectFromLibrary': '라이브러리에서 가져오기',
  'chat.importFigma': 'Figma에서 가져오기',
  'chat.plus.group.files': 'Files',
  'chat.plus.group.code': 'Code',
  'chat.plus.group.designs': 'Designs',
  'chat.plus.group.other': 'Other',
  'chat.plus.attachFiles': 'Attach files',
  'chat.plus.referenceProject': 'Reference another project',
  'chat.plus.linkLocalCode': 'Link local code',
  'chat.plus.uploadFig': 'Upload .fig file',
  'chat.plus.learnHow': 'Learn how',
  'chat.plus.designSystem': 'Design system',
  'chat.plus.skills': 'Skills',
  'chat.plus.noSkills': 'No skills available',
  'chat.plus.connectors': 'Connectors',
  'chat.plus.plugins': 'Plugins',
  'chat.plus.mcp': 'MCP',
  'chat.referenceProject.title': 'Reference another project',
  'chat.referenceProject.search': 'Search projects…',
  'chat.referenceProject.empty': 'No projects match “{query}”',
  'chat.referenceProject.emptyAll': 'No other projects yet',
  'chat.referenceProject.loadFailed': 'Could not load projects. Check that the daemon is running and try again.',
  'chat.referenceProject.confirm': 'Reference project',
  'chat.contextPrompt.referenceProject': 'Use the Open Design project “{name}” as reference context. Its local path is: {path}. Before designing or modifying anything, search and read this directory when useful.',
  'chat.contextPrompt.localCode': 'Use the local code folder “{name}” as code reference. Its absolute path is: {path}. Read relevant files when useful and stay consistent with the existing implementation.',
  'chat.figmaHelp.title': 'How to download a .fig file',
  'chat.figmaHelp.intro': 'From the Figma web or desktop app:',
  'chat.figmaHelp.step1': 'Open the file in Figma.',
  'chat.figmaHelp.step2': 'Go to File → Save local copy... (web: main menu → File).',
  'chat.figmaHelp.step3': 'Figma downloads a .fig file. Drop it onto the composer or upload it.',
  'chat.figmaHelp.note': 'The .fig file is parsed locally and is not uploaded to Figma.',
  'designFiles.library.label': '라이브러리에서 가져오기',
  'designFiles.library.title': '라이브러리에서 가져오기',
  'libraryPicker.title': '라이브러리에서 가져오기',
  'libraryPicker.searchPlaceholder': '라이브러리 검색…',
  'libraryPicker.empty': '라이브러리에 아직 에셋이 없습니다',
  'libraryPicker.allKinds': '전체',
  'libraryPicker.add': '가져오기',
  'libraryPicker.loading': '불러오는 중…',
  'common.save': '저장',
  'common.close': '닫기',
  'common.clear': '지우기',
  'common.delete': '삭제',
  'common.rename': '이름 변경',
  'common.edit': '편집',
  'common.preview': '미리보기',
  'common.share': '공유',
  'common.search': '검색',
  'common.searchEllipsis': '검색…',
  'common.loading': '불러오는 중…',
  'common.all': '전체',
  'common.none': '없음',
  'common.default': '기본값',
  'common.installed': '설치됨',
  'common.notInstalled': '설치되지 않음',
  'common.active': '활성',
  'common.offline': '오프라인',
  'common.selected': '선택됨',
  'common.create': '생성',
  'common.openPreview': '미리보기 열기',
  'common.exitFullscreen': '전체 화면 종료',
  'common.fullscreen': '전체 화면',
  'common.openInNewTab': '새 탭에서 열기',
  'common.exportPdf': 'PDF로 내보내기',
  'common.exportZip': '.zip으로 다운로드',
  'common.exportHtml': '독립 실행형 HTML로 내보내기',
  'common.exportImage': '이미지로 내보내기',
  'common.exportImageFailed': '이미지 캡처에 실패했습니다. 다시 시도하거나 브라우저의 스크린샷 도구를 사용하세요.',
  'common.justNow': '방금 전',
  'common.minutesAgo': '{n}분 전',
  'common.hoursAgo': '{n}시간 전',
  'common.daysAgo': '{n}일 전',
  'common.weeksAgo': '{n}주 전',
  'common.now': '지금',
  'common.minutesShort': '{n}분',
  'common.hoursShort': '{n}시간',
  'common.daysShort': '{n}일',
  'common.untitled': '제목 없음',
  'designBrowser.savePageBrief': 'Save page brief',
  'designBrowser.menu': 'Browser menu',
  'designBrowser.copyScreenshot': 'Copy screenshot',
  'designBrowser.hardReload': 'Hard reload',
  'designBrowser.copyUrl': 'Copy URL',
  'designBrowser.openExternal': 'Open externally',
  'designBrowser.downloadPage': 'Download page',
  'designBrowser.downloadPageBusy': 'Downloading page...',
  'designBrowser.clearHistory': 'Clear history',
  'designBrowser.clearCookies': 'Clear cookies',
  'designBrowser.clearAllData': 'Clear all browser data',
  'designBrowser.status.noUrlToCopy': 'No URL to copy.',
  'designBrowser.status.urlCopied': 'URL copied.',
  'designBrowser.status.openHttpFirst': 'Open an http or https page first.',
  'designBrowser.status.openBeforeScreenshot': 'Open a page before taking a screenshot.',
  'designBrowser.status.screenshotSaved': 'Screenshot saved.',
  'designBrowser.status.screenshotFailed': 'Screenshot failed.',
  'designBrowser.status.openBeforeBrief': 'Open a page before saving a brief.',
  'designBrowser.status.briefSaveFailed': 'Page brief save failed.',
  'designBrowser.status.openBeforeDownload': 'Open a page before saving a snapshot.',
  'designBrowser.status.pageSnapshotStarted': 'Saving page snapshot...',
  'designBrowser.status.pageSnapshotUnsupported': 'This page cannot be archived.',
  'designBrowser.status.pageSnapshotFailed': 'Page snapshot save failed.',
  'designBrowser.status.pageSnapshotSaved': 'Saved page snapshot (HTML + CSS).',
  'designBrowser.status.viewDesignFiles': 'View Design Files',
  'designBrowser.status.downloadAssistHint': 'Step 2: click Download Page here, wait for the saved snapshot success, then return to the left Next Step card and click Continue extraction.',
  'designBrowser.status.desktopDataUnavailable': 'Desktop browser data is unavailable here.',
  'designBrowser.status.browserDataCleared': 'Browser data cleared.',
  'designBrowser.status.browserDataClearFailed': 'Browser data clear failed.',
  'designBrowser.status.historyCleared': 'History cleared.',
  'plugins.availableDetails.provenance': '출처',
  'plugins.availableDetails.provenanceLine': '{source} · {trust} · {resolved}',
  'plugins.availableDetails.provenanceLineWithIntegrity': '{source} · {trust} · {resolved} · {integrity}',
  'plugins.availableDetails.install': '설치',
  'plugins.availableDetails.version': '버전',
  'plugins.availableDetails.pluginVersion': '플러그인 버전',
  'plugins.availableDetails.copyInstallCommand': '설치 명령어 복사',
  'plugins.availableDetails.copied': '복사됨',
  'plugins.availableDetails.deprecatedPrefix': '지원 중단됨: {message}',
  'plugins.availableDetails.deprecatedFallback': '이 버전은 지원 중단으로 표시되었습니다.',
  'plugins.availableDetails.yanked': '철회됨.',
  'plugins.availableDetails.yankedWithReason': '철회됨: {reason}',
  'plugins.availableDetails.versionDeprecatedSuffix': ' (지원 중단됨)',
  'plugins.availableDetails.versionYankedSuffix': ' (철회됨)',
  'plugins.availableDetails.ref': 'Ref',
  'plugins.availableDetails.integrity': 'Integrity',
  'plugins.availableDetails.permissions': '권한',
  'plugins.availableDetails.capabilitySummary': '기능 요약',
  'plugins.actions.copyInstallCommand': '설치 명령 복사',
  'plugins.actions.copyPluginId': '플러그인 ID 복사',
  'plugins.actions.copyReadmeBadge': 'README 배지 복사',
  'plugins.actions.openSourceGithub': 'GitHub에서 소스 열기',
  'plugins.actions.openSource': '소스 열기',
  'plugins.actions.openHomepage': '홈페이지 열기',
  'plugins.actions.openMarketplace': '마켓플레이스에서 열기',
  'app.brand': 'Open Design',
  'app.brandPill': '리서치 프리뷰',
  'app.brandSubtitle': 'by Nexu Labs',
  'app.welcomeLoading': '워크스페이스를 불러오는 중…',
  'settings.welcomeKicker': '',
  'settings.welcomeTitle': 'Open Design에 오신 것을 환영합니다',
  'settings.welcomeSubtitle': '',
  'settings.onboardingCreateTitle': '브리프로 시작하기',
  'settings.onboardingCreateBody': '원하는 사이트, 앱, 덱, 이미지 또는 동영상을 설명하세요. Open Design이 프로젝트를 생성하고 작업물을 편집 가능한 상태로 유지합니다.',
  'settings.onboardingMemoryTitle': '작업 컨텍스트 저장',
  'settings.onboardingMemoryBody': '환경 설정, 프로젝트 정보, 반복 규칙을 추가하여 이후 채팅에서 올바른 컨텍스트를 이어가도록 하세요.',
  'settings.onboardingMemoryCalloutTitle': '메모리에 저장됨',
  'settings.onboardingMemoryCalloutBody': '이 답변은 메모리 프로필의 기초가 됩니다. Open Design은 모든 작업에서 이를 재사용하며, 작업하는 동안 계속 학습합니다.',
  'settings.onboardingMemoryBenefitIntent': '짧은 요청만으로 의도를 이해합니다',
  'settings.onboardingMemoryBenefitFewerQuestions': '반복되는 설정 질문을 건너뜁니다',
  'settings.onboardingMemoryBenefitPersonalized': '역할, 대상, 취향에 맞게 결과물을 조정합니다',
  'settings.onboardingSystemsTitle': '디자인 시스템 가져오기',
  'settings.onboardingSystemsBody': '브랜드 시스템을 선택하거나 생성하여 생성된 작업물이 실제 색상, 타이포그래피, 제품 언어를 따르도록 하세요.',
  'settings.onboardingExecutionTitle': '생성 방식 선택',
  'settings.onboardingExecutionBody': '원클릭 설정과 즉시 사용 가능한 기본값을 갖춘 공식 CLI입니다. 하나의 키로 더 나은 가격의 다양한 모델 중에서 선택하세요.',
  'settings.onboardingAmrCloudBenefitOfficial': '공식 추천',
  'settings.onboardingAmrCloudBenefitReady': '배포 없이 사용',
  'settings.onboardingAmrCloudBenefitModels': 'Claude Opus 4.8 지원',
  'settings.onboardingAmrCloudBenefitPricing': 'SOTA 하네스',
  'settings.onboardingAmrCloudUpcomingLabel': '곧 지원',
  'settings.onboardingAmrCloudUpcomingImageVideo': '이미지/비디오',
  'settings.onboardingAmrCloudUpcomingSkills': '방대한 Skills',
  'settings.onboardingAmrCloudUpcomingRouting': '스마트 라우팅',
  'settings.onboardingAmrModelSourceLabel': 'Open Design Cloud',
  'settings.onboardingAmrCloudAuthorizeAction': 'Open Design Cloud 인증',
  'settings.onboardingAmrCloudAuthorizedAction': '인증됨',
  'settings.onboardingStepConnect': 'Connect',
  'settings.onboardingStepDesignSystem': '디자인 시스템 구축',
  'settings.onboardingStepProfile': 'About you',
  'settings.onboardingStepNewsletter': '업데이트 받기',
  'settings.onboardingNewsletterTitle': '소식 받아보기',
  'settings.onboardingNewsletterBody': '제품 업데이트, 새 템플릿, 디자인 시스템, 앰배서더 활동을 메일로 받아보세요. 선택 사항이며 건너뛸 수 있습니다.',
  'settings.onboardingConnectTitle': 'Choose a runtime',
  'settings.onboardingConnectBody': '',
  'settings.onboardingCloudTitle': 'Open Design에 로그인',
  'settings.onboardingCloudBody': '로그인하면 클라우드 AI로 바로 디자인을 시작할 수 있습니다. 복잡한 설정이 전혀 필요 없습니다.',
  'settings.onboardingCloudSignIn': 'Open Design에 로그인',
  'settings.onboardingCloudContinue': '계속 (로그인됨)',
  'settings.onboardingCloudAlternative': '로컬 CLI 또는 자체 API 키 사용',
  'settings.onboardingCloudRights': 'All rights reserved.',
  'settings.onboardingCloudOr': '또는',
  'settings.onboardingGateTooltipNoRuntime': '다음 단계는 AI로 실행됩니다 — 계속하려면 실행 방식을 선택하세요.',
  'settings.onboardingGateTooltipAmr': '다음 단계는 AI로 실행됩니다 — 계속하려면 Open Design Cloud에 로그인하세요.',
  'settings.onboardingGateTooltipLocal': '다음 단계는 AI로 실행됩니다 — 계속하려면 사용 가능한 로컬 CLI를 선택하세요.',
  'settings.onboardingGateTooltipByok': '다음 단계는 AI로 실행됩니다 — 계속하려면 모델 키를 추가하고 테스트하세요.',
  'settings.onboardingRecommended': 'Recommended',
  'settings.onboardingAmrCloudOfficialBadge': '공식',
  'settings.onboardingLocalTitle': 'Local coding agent',
  'settings.onboardingLocalBody': 'Use an installed CLI such as Claude Code, Codex, Cursor, Gemini, or OpenCode.',
  'settings.onboardingLocalAction': 'Open CLI settings',
  'settings.onboardingCliScanHint': 'This usually takes 5-10 seconds.',
  'settings.onboardingByokTitle': 'Bring your own key',
  'settings.onboardingByokBody': 'Use your own model provider credentials.',
  'settings.onboardingByokAction': 'Open BYOK settings',
  'settings.onboardingDesignTitle': 'Design system',
  'settings.onboardingDesignBody': 'Generate once, reuse everywhere.',
  'settings.onboardingDesignIntroGenerateTitle': 'Generate from existing work',
  'settings.onboardingDesignIntroGenerateBody': 'Upload your design system from GitHub or local code repositories, Figma files, images, and other content assets.',
  'settings.onboardingDesignIntroReuseTitle': 'Reuse in future work',
  'settings.onboardingDesignIntroReuseBody': 'Future prototypes, slides, and other content can reference your existing fonts, spacing, logo style, and color tone.',
  'settings.onboardingDesignIntroSkipTitle': 'Optional for now',
  'settings.onboardingDesignIntroSkipBody': 'Skip this step if you want to start without generating a design system.',
  'settings.onboardingGithubTitle': 'Import from GitHub',
  'settings.onboardingGithubBody': 'Use a frontend repository.',
  'settings.onboardingUploadTitle': 'Upload local files',
  'settings.onboardingUploadBody': 'Add project files, screenshots, CSS, docs, or assets.',
  'settings.onboardingPromptTitle': 'Generate from prompt',
  'settings.onboardingPromptBody': 'Describe the product or brand.',
  'settings.onboardingProfileTitle': '회원님 정보',
  'settings.onboardingProfileBody': '더 나은 기본값을 위한 선택 정보입니다.',
  'settings.onboardingRoleLabel': '직무',
  'settings.onboardingOrgSizeLabel': '조직 규모',
  'settings.onboardingUseCaseLabel': '활용 사례',
  'settings.onboardingSourceLabel': '저희를 어떻게 알게 되셨나요?',
  'settings.onboardingSourceX': '🐦 X / Twitter',
  'settings.onboardingSourceGithub': '🐙 GitHub',
  'settings.onboardingSourceYoutube': '▶️ YouTube',
  'settings.onboardingSourceTiktok': '🎵 TikTok',
  'settings.onboardingSourceReddit': '👽 Reddit',
  'settings.onboardingSourceLinkedin': '💼 LinkedIn',
  'settings.onboardingSourceMetaSocial': '📸 Instagram / Threads / Facebook',
  'settings.onboardingSourceSearch': '🔍 검색 (Google / Bing)',
  'settings.onboardingSourceAiTool': '🤖 AI 도구 (ChatGPT / Perplexity)',
  'settings.onboardingSourceFriend': '👥 친구 또는 동료',
  'settings.onboardingSourceCommunity': '💬 Discord / 커뮤니티',
  'settings.onboardingSourceEmail': '✉️ 이메일 / 뉴스레터',
  'settings.onboardingSourceBlog': '📝 블로그 / 아티클',
  'settings.onboardingSourceOther': '✨ 기타',
  'settings.onboardingSourceOtherPlaceholder': '어디서 알게 되셨는지 알려주세요 (선택)',
  'settings.onboardingSelectPlaceholder': '하나 선택',
  'settings.onboardingSelectMultiplePlaceholder': '하나 이상 선택',
  'settings.onboardingOrgSolo': '개인 (1)',
  'settings.onboardingOrgTeam': '소규모 팀 (2-10)',
  'settings.onboardingOrgStartup': '스타트업 / 중소기업 (11-50)',
  'settings.onboardingOrgGrowth': '성장 기업 (51-200)',
  'settings.onboardingOrgMidMarket': '중견기업 (201-1000)',
  'settings.onboardingOrgEnterprise': '대기업 (1000+)',
  'settings.onboardingRolePm': '📋 프로덕트 매니저',
  'settings.onboardingRoleDesigner': '🎨 디자이너',
  'settings.onboardingRoleEngineer': '💻 엔지니어',
  'settings.onboardingRoleMarketing': '📣 마케팅',
  'settings.onboardingRoleAgency': '📣 마케팅 에이전시',
  'settings.onboardingRoleGrowth': '📈 성장',
  'settings.onboardingRoleOps': '⚙️ 운영',
  'settings.onboardingRoleFounder': '🚀 창업자 / 경영진',
  'settings.onboardingRoleStudent': '🎓 학생 / 교육자',
  'settings.onboardingRoleOther': '✨ 기타',
  'settings.onboardingUseProduct': '🎨 제품 디자인',
  'settings.onboardingUseDesignSystem': '🧩 디자인 시스템',
  'settings.onboardingUsePrototype': '📱 프로토타입 / 앱 UI',
  'settings.onboardingUseLanding': '🌐 랜딩 페이지',
  'settings.onboardingUseAds': '📣 광고 / 소셜 콘텐츠',
  'settings.onboardingUseDashboard': '📊 대시보드 / 내부 도구',
  'settings.onboardingUseDeck': '🖥️ 프레젠테이션 / 슬라이드',
  'settings.onboardingUseMarketing': '📈 마케팅 / 성장',
  'settings.onboardingUseEngineering': '🤝 엔지니어링 핸드오프',
  'settings.onboardingUseAgency': '💼 에이전시 / 클라이언트 작업',
  'settings.onboardingBack': 'Back',
  'settings.onboardingContinue': 'Continue',
  'settings.onboardingFinish': 'Finish setup',
  'settings.kicker': '설정',
  'settings.title': '실행 모드',
  'settings.subtitle': '로컬 CLI와 BYOK 중에서 선택하세요.',
  'settings.modeAria': '실행 모드',
  'settings.protocolAria': 'API 프로토콜',
  'settings.modeDaemon': '로컬 CLI',
  'settings.modeDaemonHelp': '사용자 기기의 코드 에이전트 CLI를 통해 실행합니다',
  'settings.modeDaemonOffline': '데몬이 실행 중이 아닙니다',
  'settings.modeDaemonOfflineMeta': '데몬 오프라인',
  'settings.modeDaemonInstalledMeta': '{count}개 설치됨',
  'settings.modeApi': 'API 제공자',
  'settings.modeApiMeta': 'BYOK',
  'settings.byokNoFileToolsNotice': 'BYOK는 프로젝트 파일을 읽거나 쓰거나 편집할 수 없습니다. 코드 변경이 필요한 경우 Local CLI를 사용하세요.',
  'settings.codeAgent': '코드 에이전트',
  'settings.codeAgentHint': 'PATH 환경 변수 스캔을 통해 감지됩니다. 생성을 처리할 CLI를 선택하세요.',
  'settings.rescan': '↻ 다시 스캔',
  'settings.rescanTitle': 'PATH 다시 스캔',
  'settings.rescanRunning': '스캔 중...',
  'settings.rescanSuccess': '스캔 완료. {count}개 사용 가능.',
  'settings.designSystemRenameFailed': '이름 변경에 실패했습니다. 데몬을 확인한 후 다시 시도하세요.',
  'settings.rescanFailed': '스캔에 실패했습니다. 데몬을 확인한 후 다시 시도하세요.',
  'settings.test': '테스트',
  'settings.testTitle': '연결을 확인하기 위해 아주 작은 테스트 프롬프트를 전송합니다',
  'settings.testRunning': '연결 테스트 중…',
  'settings.byokReadyToTest': '테스트 준비됨',
  'settings.testCancel': '취소',
  'settings.testRetry': '테스트 재시도',
  'settings.required': '필수',
  'settings.testMissingFields': '연결을 테스트하려면 {fields}을(를) 입력하세요.',
  'settings.testSuccessApi': '연결됨. {ms} ms 만에 응답 — \'{sample}\'',
  'settings.testSuccessCli': '{agentName}이(가) {ms} ms 만에 응답 — \'{sample}\'',
  'settings.testAuthFailed': '인증 실패. API 키를 확인하세요.',
  'settings.testForbidden': '접근이 거부되었습니다. 계정, 지역 또는 조직을 확인하세요.',
  'settings.testNotFoundModel': '이 엔드포인트에서 모델 \'{model}\'을(를) 찾을 수 없습니다.',
  'settings.testInvalidModelId': '모델 ID \'{model}\'이(가) 잘못되었습니다. 사용자 지정 ID는 문자 또는 숫자로 시작하고 공백을 포함할 수 없습니다.',
  'settings.testInvalidBaseUrl': 'Base URL이 잘못되었거나 접속할 수 없습니다.',
  'settings.testRateLimited': '제공자가 테스트를 속도 제한했습니다. 구성은 유효해 보입니다.',
  'settings.testUpstream': '제공자가 {status}을(를) 반환했습니다. 잠시 후 다시 시도하세요.',
  'settings.testTimeout': '{ms} ms 후에 테스트가 시간 초과되었습니다.',
  'settings.testAgentMissing': '{agentName}이(가) 설치되어 있지 않거나 PATH에 없습니다.',
  'settings.testAgentSpawn': '{agentName}을(를) 시작할 수 없습니다: {detail}.',
  'settings.testUnknown': '테스트 실패: {detail}',
  'settings.agentInstall.install': '설치',
  'settings.agentInstall.docs': '문서',
  'settings.agentInstall.pathHint': 'npm 또는 Homebrew로 CLI를 설치했는데도 아직 미설치로 표시된다면, Open Design daemon이 상속받는 PATH에 도구의 bin 디렉터리가 포함되어 있는지 확인하세요(macOS에서는 Terminal과 GUI 앱의 PATH가 다를 수 있습니다). QUICKSTART.md("Local agent CLI and PATH" 섹션)를 참고하세요.',
  'settings.agentInstall.stepOpenLinks': '원하는 에이전트 카드에서 설치 또는 문서 링크를 여세요.',
  'settings.agentInstall.stepAuth': 'Open Design으로 돌아오기 전에 공급자 CLI에서 인증(로그인 또는 API 자격 증명 추가)을 완료하세요.',
  'settings.agentInstall.stepRescan': '이 섹션에서 다시 스캔을 클릭하세요.',
  'settings.agentInstall.stepSelect': '설치됨으로 표시되면 해당 에이전트 카드를 선택하세요.',
  'settings.noAgentsDetected': '에이전트가 감지되지 않았습니다. Claude Code, Codex, Devin for Terminal, OpenCode, Cursor Agent, Qwen 또는 GitHub Copilot CLI 중 하나를 설치한 후 다시 스캔을 클릭하세요.',
  'settings.agentInstalledGroup': '내 CLI ({count})',
  'settings.agentInstallGroup': '설치 가능 ({count})',
  'settings.agentAuthRequired': '인증 필요',
  'settings.agentAuthUnknown': '인증 상태를 알 수 없음',
  'settings.amrCloud': 'Open Design Cloud',
  'settings.amrAuthorize': '승인',
  'settings.amrBenefitOfficial': '공식',
  'settings.amrBenefitLowerPrice': '더 저렴한 비용',
  'settings.amrBenefitManyModels': '다양한 모델',
  'settings.amrPromoBonus': '한정 보너스: +100%',
  'settings.amrSignInToContinue': '계속하려면 로그인하세요',
  'settings.amrSignIn': '로그인',
  'settings.amrSignedIn': '로그인됨',
  'settings.amrWalletBalance': 'Wallet balance',
  'settings.amrWalletUnavailable': 'Balance temporarily unavailable',
  'settings.amrWalletUpdatedAt': 'Updated {time}',
  'settings.amrWalletCached': 'cached',
  'settings.amrWalletRefresh': 'Refresh',
  'settings.amrWalletRefreshTitle': 'Refresh Open Design Cloud wallet balance',
  'settings.amrNotSignedIn': '로그인되지 않음',
  'settings.amrSigningIn': '로그인 중…',
  'settings.amrActivationHint': '로그인 페이지가 열리지 않았나요? 아래 버튼을 눌러 다시 엽니다.',
  'settings.amrActivationBrowserFailed': '브라우저를 자동으로 열지 못했습니다. 아래 로그인 페이지를 열어 계속하세요.',
  'settings.amrActivationOpen': '로그인 페이지 열기',
  'settings.amrCancelSignIn': '로그인 취소',
  'settings.amrAccountStatus': 'Open Design Cloud 계정 상태',
  'settings.amrConsole': '관리',
  'settings.amrBalance': '잔액',
  'settings.amrPlan': '플랜',
  'settings.amrUpgrade': '업그레이드',
  'settings.amrModelUpgradeHint': '업그레이드 후 사용',
  'settings.amrLoginErrorCompact': 'Open Design Cloud 로그인에 실패했습니다.',
  'settings.advanced': '고급',
  'settings.amrLogin': '로그인',
  'settings.amrLogout': '로그아웃',
  'settings.amrLoggingIn': '로그인 중…',
  'settings.amrLoggingOut': '로그아웃 중…',
  'settings.amrLoggedInAs': '{email} 계정으로 로그인됨',
  'settings.amrLoggedInWithPlan': '{email}(으)로 로그인됨 · {plan}',
  'settings.amrLoggedInPill': '로그인됨',
  'settings.amrNotLoggedIn': '로그인되지 않음',
  'settings.apiSection': 'Anthropic API',
  'settings.quickFillProvider': '제공자 빠른 입력',
  'settings.providerPreset': '게이트웨이 프리셋',
  'settings.protocolGroupProtocols': '프로토콜',
  'settings.protocolGroupGateways': '게이트웨이',
  'settings.customProvider': '사용자 지정 제공자',
  'settings.apiKey': 'API 키',
  'settings.apiKeyGetLink': '키 받기 ↗',
  'settings.showKey': '키 표시',
  'settings.hideKey': '키 숨기기',
  'settings.show': '표시',
  'settings.hide': '숨기기',
  'settings.model': '모델',
  'settings.apiKeyInvalid': '잘못된 API key입니다.',
  'settings.apiKeyCleaned': 'API key에서 불필요한 공백을 제거했습니다.',
  'settings.modelsLoadedFromAccount': '✓ 계정에서 모델 {count}개를 불러왔습니다.',
  'settings.modelsLoadedCount': '✓ 모델 {count}개를 불러왔습니다.',
  'settings.modelSourceAccount': '계정에서 가져옴',
  'settings.modelSourceSuggested': '추천',
  'modelCapability.standard': 'Standard',
  'modelCapability.advanced': 'Advanced',
  'modelCapability.bestQuality': 'Best Quality',
  'modelCapability.standardDescription': 'Solid quality for regular tasks.',
  'modelCapability.advancedDescription': 'Stronger quality for more demanding tasks.',
  'modelCapability.bestQualityDescription': 'Best output quality for the most demanding work.',
  'modelCost.upToHalf': '낮은 비용',
  'modelCost.halfToOne': '중간 비용',
  'modelCost.oneToFour': '높은 비용',
  'modelCost.overFour': '최고 비용',
  'settings.fetchModels': '모델 가져오기',
  'settings.fetchModelsTitle': '이 공급자에서 사용 가능한 모델을 가져옵니다',
  'settings.fetchModelsRunning': '모델을 불러오는 중…',
  'settings.fetchModelsMissingFields': '모델을 가져오려면 {fields}을(를) 입력하세요.',
  'settings.fetchModelsInvalidBaseUrl': '모델을 가져오려면 유효한 Base URL을 입력하세요.',
  'settings.fetchModelsUnsupportedAzure': 'Azure OpenAI는 배포 이름을 사용하므로 여기에서는 모델 검색을 사용할 수 없습니다.',
  'settings.fetchModelsUnsupportedOllama': 'Ollama Cloud 모델 검색은 아직 사용할 수 없습니다. 모델을 선택하거나 입력하세요.',
  'settings.fetchModelsSuccess': '{count}개의 모델을 가져왔습니다.',
  'settings.fetchModelsEmpty': '호환되는 텍스트 모델이 반환되지 않았습니다.',
  'settings.fetchModelsUnsupported': '이 프로토콜에서는 모델 검색을 사용할 수 없습니다.',
  'settings.fetchModelsFailed': '모델을 가져올 수 없습니다: {detail}',
  'settings.suggestedModelsHint': '이 프로토콜에 대한 추천 모델입니다. 사용 중인 제공자는 다른 모델을 지원할 수 있습니다.',
  'settings.baseUrl': 'Base URL',
  'settings.baseUrlInvalid': '공개 http:// 또는 https:// URL을 사용하세요.',
  'settings.baseUrlCustomize': '사용자 지정',
  'settings.baseUrlDefaultHint': '기본 엔드포인트입니다. 보통 변경할 필요가 없습니다.',
  'settings.azureBaseUrlPlaceholder': 'Azure 엔드포인트 URL 붙여넣기',
  'settings.azureBaseUrlHint': 'Azure 포털 → 리소스 → Endpoint에서 확인할 수 있습니다.',
  'settings.azureDeploymentModel': '배포 이름',
  'settings.azureCustomDeploymentName': '사용자 지정 배포 이름',
  'settings.azureDeploymentModelHint': 'Azure OpenAI에서는 이 필드가 /openai/deployments/<model>의 배포 이름으로 사용됩니다. Azure에서 만든 배포 이름을 입력하세요.',
  'settings.azureModelFetchHint': 'Azure 리소스의 배포 이름을 입력하세요. Azure 배포는 자동으로 불러올 수 없습니다.',
  'settings.apiVersion': 'API 버전',
  'settings.byokImageModel': '이미지 생성 모델',
  'settings.byokVideoModel': '비디오 생성 모델',
  'settings.byokVideoI2vHint': '이미지→비디오 모델: 참조 이미지가 필요합니다(지정하지 않으면 프로젝트의 최신 이미지를 자동 사용)',
  'settings.byokSpeechModel': '음성 생성 모델',
  'settings.byokSpeechVoice': '음성(보이스)',
  'settings.byokModelDefaultOption': '기본값',
  'settings.maxTokens': '최대 토큰 수 (선택 사항)',
  'settings.maxTokensHint': '응답 길이 상한입니다. 각 모델에는 기본값이 미리 조정되어 있으며(placeholder로 표시됨), 비워 두면 그 값을 사용하고 숫자를 입력하면 덮어씁니다.',
  'settings.apiHint': '요청은 로컬 daemon 프록시를 통해 설정한 Base URL로 전송됩니다. 키는 이 브라우저에만 저장되며 제공자 요청과 함께 전송됩니다.',
  'settings.skipForNow': '지금은 건너뛰기',
  'settings.getStarted': '시작하기',
  'settings.envConfigure': '실행 모드',
  'settings.localCli': '로컬 CLI',
  'settings.anthropicApi': 'Anthropic API',
  'settings.noAgentSelected': '선택된 에이전트 없음',
  'settings.language': '언어',
  'settings.languageHint': '인터페이스 언어를 변경합니다. 이 브라우저에 저장됩니다.',
  'settings.appearance': '화면 모드',
  'settings.appearanceHint': '라이트, 다크 또는 시스템 설정에 따릅니다.',
  'settings.themeSystem': '시스템',
  'settings.themeLight': '라이트',
  'settings.themeDark': '다크',
  'settings.agentModelHead': '모델:',
  'settings.modelPicker': '모델',
  'settings.modelSourceLive': 'CLI에서 실시간 가져옴',
  'settings.modelSourceFallback': '내장 목록',
  'settings.reasoningPicker': '추론 (Reasoning)',
  'settings.modelPickerHint': 'CLI가 `models` 명령어를 지원할 때 가져옵니다. "Default"는 CLI 자체 설정을 따르며, "직접 입력…"을 선택하면 CLI가 허용하는 모델 ID를 입력할 수 있습니다.',
  'settings.modelPickerLiveHint': '설치된 CLI에서 모델을 새로 고쳤습니다. 기본값은 계속 CLI 구성을 사용합니다.',
  'settings.modelPickerLiveCatalogOnlyHint': '설치된 CLI에서 모델을 새로 고쳤습니다.',
  'settings.modelPickerFallbackHint': '내장 기본값을 표시 중입니다. CLI에서 실시간 모델을 가져오려면 다시 스캔을 클릭하세요.',
  'settings.cliEnvTitle': '고급: 프록시 및 사용자 지정 경로',
  'settings.cliEnvHint': '선택한 CLI 환경을 재정의할 때 사용하세요: API key, 프록시 base URL, 사용자 지정 home, 비표준 실행 파일 경로. base URL이 없으면 CLI는 자체 기본 endpoint를 사용합니다. 비밀 정보는 로컬 앱 설정에 저장되며 선택한 CLI만 볼 수 있습니다.',
  'settings.cliEnvClaudeConfigDir': 'Claude Code 설정 디렉터리',
  'settings.cliEnvClaudeBaseUrl': 'Claude 프록시 Base URL',
  'settings.cliEnvClaudeApiKey': 'Claude CLI API key',
  'settings.cliEnvCodexHome': 'Codex 홈',
  'settings.cliEnvCodexBin': 'Codex 실행 파일 경로',
  'settings.cliEnvCodexBaseUrl': 'Codex/OpenAI 프록시 Base URL',
  'settings.cliEnvCodexApiKey': 'Codex/OpenAI CLI API key',
  'settings.modelCustom': '직접 입력…',
  'settings.modelCustomLabel': '사용자 지정 모델 ID',
  'settings.modelCustomPlaceholder': '예: anthropic/claude-sonnet-4-6',
  'settings.mediaProviders': '미디어 프로바이더',
  'settings.mediaProvidersHint': '이미지, 비디오, 오디오 생성을 위한 API 키입니다. 로컬에 저장되며 로컬 데몬과 동기화됩니다.',
  'settings.mcpServerTitle': 'MCP 서버',
  'settings.mcpServerHint': 'Open Design을 코딩 에이전트용 MCP 서버로 노출합니다.',
  'settings.externalMcpTitle': '외부 MCP',
  'settings.externalMcpHint': '외부 서비스(Higgsfield, GitHub 등)의 MCP 도구를 추가합니다.',
  'settings.mediaProviderApiKey': 'API 키',
  'settings.mediaProviderBaseUrl': 'Base URL',
  'settings.mediaProviderConfigured': '설정됨',
  'settings.mediaProviderUnset': '설정 안됨',
  'settings.mediaProviderClear': '지우기',
  'settings.mediaProviderClearConfirm': '저장된 {name} 설정을 삭제하시겠습니까? {name}을(를) 사용하려면 다시 입력해야 합니다.',
  'settings.mediaProviderPlaceholder': 'API 키를 붙여넣으세요',
  'settings.mediaProviderBaseUrlPlaceholder': '기본 Base URL 재정의',
  'settings.mediaProviderReload': '데몬에서 다시 불러오기',
  'settings.mediaProviderReloadError': '로컬 데몬에서 미디어 제공자 설정을 다시 불러오지 못했습니다.',
  'settings.mediaProviderReloadSuccess': '로컬 데몬에서 미디어 제공자 설정을 다시 불러왔습니다.',
  'settings.mediaProviderLoadError': '로컬 데몬에서 미디어 제공자 설정을 불러오지 못했습니다. 지금은 브라우저에 저장된 설정을 사용합니다.',
  'settings.mediaProviderComingSoonHint': '로드맵에서 이를 추적하고 있습니다. 데몬이 아직 클라이언트를 제공하지 않으므로 구성할 항목이 없습니다.',
  'settings.privacy': '개인정보 보호',
  'settings.privacyHint': 'Open Design 팀과 공유되는 데이터',
  'settings.privacyConsentKicker': 'Open Design 개선에 참여하기',
  'settings.privacyConsentLead': '사용 데이터를 공유하면 Open Design이 실제 작업 흐름에서 어떻게 동작하는지 더 잘 이해하고, 경험에 가장 큰 영향을 주는 부분을 우선 개선할 수 있습니다.',
  'settings.privacyConsentFooter': '설정 → 개인정보 보호에서 언제든지 이 옵션을 변경할 수 있습니다.',
  'settings.privacyConsentShare': '공유',
  'settings.privacyConsentDecline': '공유 안 함',
  'settings.privacyConsentAccept': '이해했어요',
  'settings.privacyConsentBannerFooter': '데이터 공유는 기본적으로 켜져 있습니다. 설정 → 개인정보 보호에서 언제든지 끌 수 있습니다.',
  'settings.privacyConsentPolicyLink': '개인정보 처리방침 읽기',
  'settings.privacyMetrics': '익명 측정 지표',
  'settings.privacyMetricsHint': '실행 횟수, Token 사용량, 오류율, 소요 시간 같은 기본 사용 지표입니다.',
  'settings.privacyContent': '대화 및 도구 콘텐츠',
  'settings.privacyContentHint': '비밀 정보와 기타 민감한 정보를 제거한 뒤, 프롬프트, 어시스턴트 응답, 도구 입력/출력, 품질 검토에 필요한 컨텍스트를 사용합니다.',
  'settings.privacyInstallationId': '익명 ID',
  'settings.privacyOptedOut': '수신 거부됨',
  'settings.privacyDataDeletion': '내 데이터 삭제',
  'settings.privacyDataDeletionHint': '익명 ID를 교체하고 전송을 중단합니다. 기존 추적 데이터는 보관 정책에 따라 만료됩니다.',
  'settings.about': '정보',
  'settings.aboutHint': '버전 및 런타임 세부 정보',
  'settings.appVersion': '버전',
  'settings.appChannel': '채널',
  'settings.appRuntime': '런타임',
  'settings.appPlatform': '플랫폼',
  'settings.appArchitecture': '아키텍처',
  'settings.runtimePackaged': '패키징된 앱',
  'settings.runtimeDevelopment': '개발 (Development)',
  'settings.versionUnavailable': '데몬이 오프라인 상태일 때는 버전 세부 정보를 확인할 수 없습니다.',
  "settings.allowSilentUpdates": "자동 업데이트 허용",
  "settings.allowSilentUpdatesDesc": "시작 시 다운로드된 payload 업데이트를 자동으로 적용합니다. 설치 프로그램 업데이트는 계속 먼저 확인합니다.",
  'settings.installLatest': '최신 버전 설치',
  'settings.alreadyLatest': '최신 버전입니다',
  'settings.updateCheck': '업데이트 확인',
  'settings.updateNow': '지금 업데이트',
  'settings.updateRecheck': '다시 확인',
  'settings.updateRetry': '다시 시도',
  'settings.updateViewReleases': '릴리스 노트',
  'settings.updateActionFailed': '업데이트 작업을 완료할 수 없습니다.',
  'settings.updateQuitFailed': '설치 프로그램이 열렸지만 Open Design을 자동으로 종료할 수 없습니다.',
  'settings.updateStatusNotChecked': '아직 확인 안 됨',
  'settings.updateStatusDevelopment': '개발 빌드는 앱 내 업데이트를 지원하지 않습니다.',
  'settings.updateStatusUnsupported': '이 환경은 앱 내 업데이트를 지원하지 않습니다.',
  'settings.updateStatusChecking': '업데이트 확인 중...',
  'settings.updateStatusUpToDate': '이미 최신 버전입니다.',
  'settings.updateStatusAvailable': '버전 {version}을 찾았습니다. 다운로드 준비 중입니다.',
  'settings.updateStatusAvailableUnknown': '새 버전을 찾았습니다. 다운로드 준비 중입니다.',
  'settings.updateStatusDownloading': '업데이트 다운로드 중...',
  'settings.updateStatusDownloadingPercent': '업데이트 다운로드 중 {percent}%.',
  'settings.updateStatusReady': '버전 {version}을 설치할 준비가 되었습니다.',
  'settings.updateStatusReadyUnknown': '업데이트를 설치할 준비가 되었습니다.',
  'settings.updateStatusInstalling': '업데이트 설치 중...',
  'settings.updateStatusFailed': '확인에 실패했습니다. 다시 시도하세요.',
  'settings.mcpTitle': 'MCP 서버',
  'settings.mcpHint': '코딩 Agent(Cursor, Claude Code, VS Code…)가 Open Design 프로젝트를 직접 읽을 수 있도록 합니다.',
  'settings.mcpDaemonError': '설치 경로를 확인하기 위해 로컬 데몬에 연결하지 못했습니다 ({error}). Open Design이 실행 중인지 확인한 후 이 패널을 다시 열어 주세요.',
  'settings.mcpBuildDaemon': '먼저 데몬을 빌드하세요.',
  'settings.mcpNodeMissing': 'Node 바이너리가 없습니다.',
  'settings.mcpBuildHint': 'apps/daemon/dist/cli.js가 없습니다. `pnpm --filter @open-design/daemon build`를 실행한 후 새로고침하세요.',
  'settings.mcpMethodCli': 'CLI 명령어',
  'settings.mcpInstructionCli': '터미널에서 이것을 실행하세요.',
  'settings.mcpMethodToml': 'TOML 설정',
  'settings.mcpInstructionCodex': '이 테이블을 {path}에 추가하세요. 동일한 설정이 Codex CLI와 Codex IDE 확장 프로그램 간에 공유됩니다.',
  'settings.mcpMethodOneClick': '원클릭 설치',
  'settings.mcpInstructionCursor': '"Install in Cursor"를 클릭하여 승인 대화상자와 함께 설치하거나, 이 JSON을 {path}에 병합하세요.',
  'settings.mcpDeeplinkInstallCursor': 'Cursor에 설치',
  'settings.mcpMethodJson': 'JSON 설정',
  'settings.mcpInstructionCopilot': 'Command Palette({shortcut})를 열고 "MCP: Open User Configuration"을 실행한 후 이 JSON을 병합하세요. 도구가 표시되려면 Copilot Chat이 Agent 모드여야 합니다.',
  'settings.mcpInstructionAntigravity': 'Antigravity에서: Agent 패널 "..." 메뉴 → MCP Servers → Manage MCP Servers → View raw config. 이 JSON을 병합하세요.',
  'settings.mcpInstructionZed': 'Zed 설정({shortcut})을 열고 이것을 최상위 객체에 병합하세요. Zed는 "mcpServers"가 아닌 "context_servers"를 사용합니다.',
  'settings.mcpInstructionWindsurf': '{path}을(를) 열거나(또는 Cascade의 MCPs 아이콘 → Configure 사용) 다음을 병합하세요:',
  'settings.mcpCopyAria': 'MCP 설정 스니펫 복사',
  'settings.mcpResolvingFailed': '# 경로 확인에 실패했습니다. 위의 오류를 참고하세요',
  'settings.mcpLoadingPaths': '# 로컬 데몬에서 설치 경로를 불러오는 중…',
  'settings.mcpCopied': '복사됨',
  'settings.mcpCopy': '복사',
  'settings.mcpCursorApproval': 'Cursor는 설정을 작성하기 전에 승인 대화상자를 표시합니다.',
  'settings.mcpCodexOneClickInstall': 'Codex에 설치',
  'settings.mcpCodexOneClickUninstall': 'Codex에서 제거',
  'settings.mcpCodexOneClickUnavailable': 'PATH에서 Codex CLI를 찾을 수 없습니다 — Codex를 설치하거나 스니펫을 수동으로 붙여넣으세요.',
  'settings.mcpCodexInstallSuccess': '설치되었습니다. 새 서버를 불러오려면 Codex를 다시 시작하세요.',
  'settings.mcpCodexUninstallSuccess': 'Codex에서 제거되었습니다.',
  'settings.mcpCodexBusy': '작업 중…',
  'settings.mcpCodexInstallError': '작업 실패: {error}',
  'settings.mcpRestartNote': '새 서버를 인식하도록 클라이언트를 다시 시작하세요.',
  'settings.mcpRestartDetail': '대부분의 편집기는 시작할 때만 MCP 서버를 불러옵니다. Cursor / VS Code / Antigravity / Windsurf에서는 전체 재시작 대신 command palette에서 `Developer: Reload Window`를 실행할 수 있습니다. Zed와 Claude Code는 종료 후 다시 열어야 합니다.',
  'settings.mcpCapabilitiesTitle': 'Agent가 할 수 있는 일',
  'settings.mcpCapabilityRead': '프로젝트 내 모든 파일을 읽거나 검색합니다(HTML, JSX, CSS, JSON, SVG, Markdown).',
  'settings.mcpCapabilityPull': '한 번의 호출로 디자인 번들을 가져옵니다: 진입 파일과 그것이 참조하는 모든 CSS 변수, 컴포넌트, 폰트까지 함께 가져옵니다.',
  'settings.mcpCapabilityDefault': 'Open Design에서 열려 있는 프로젝트와 파일을 기본값으로 사용하므로, 어떤 디자인인지 다시 말하지 않고도 "이걸 내 앱에 만들어 줘"라고 말할 수 있습니다.',
  'settings.mcpRunningNote': 'MCP 도구 호출이 성공하려면 Open Design이 실행 중이어야 합니다. Open Design을 열기 전에 코딩 Agent를 시작했다면, 실행 중인 데몬에 연결할 수 있도록 Agent를 다시 시작하세요.',
  'entry.tabDesigns': '디자인',
  'entry.tabTemplates': '템플릿',
  'entry.tabDesignSystems': '디자인 시스템',
  'entry.tabConnectors': '커넥터',
  'entry.openSettingsTitle': '설정',
  'entry.openSettingsAria': '설정 열기',
  'entry.discordLabel': 'Discord 참여하기',
  'entry.discordAria': 'Open Design Discord 참여하기',
  'entry.discordAriaWithOnline': 'Open Design Discord 참여하기 - {online}',
  'entry.discordOnlineLabel': '{count}명 온라인',
  'entry.followXLabel': 'X에서 @OpenDesignHQ 팔로우하기',
  'entry.followThreadsLabel': 'Follow Open Design on Threads',
  'entry.youtubeLabel': 'Open Design on YouTube',
  'entry.followInstagramLabel': 'Instagram에서 @opendesign.ai 팔로우하기',
  'entry.followLinkedinLabel': 'LinkedIn에서 Open Design 팔로우하기',
  'entry.followXiaohongshuLabel': 'Xiaohongshu에서 Open Design 팔로우하기',
  'entry.resizeAria': '사이드바 크기 조절',
  'entry.loadingWorkspace': '워크스페이스를 불러오는 중…',
  'entry.useEverywhereTitle': '어디서나 사용',
  'entry.useEverywhereAria': '‘어디서나 사용’ 가이드 열기 (CLI, MCP, HTTP, Skills)',
  'entry.workspaceTeamsLabel': 'Teams',
  'entry.workspaceTeamsTitle': 'Workspace 팀 버전 — 팀에 필요한 것을 알려주세요',
  'entry.workspaceTeamsAria': 'Workspace 팀 버전 페이지 열기',
  'entry.navExpand': '사이드바 펼치기',
  'entry.navCollapse': '사이드바 접기',
  'entry.navNewProject': '새 프로젝트',
  'entry.navHome': '홈',
  'entry.navProjects': '프로젝트',
  'entry.navTasks': '자동화',
  'entry.navPlugins': '플러그인',
  'entry.navDesignSystems': '디자인 시스템',
  'entry.navBrands': '브랜드 키트',
  'entry.navIntegrations': '통합',
  'workspaceTabs.project': '프로젝트',
  'workspaceTabs.pluginDetails': '플러그인 세부 정보',
  'workspaceTabs.marketplace': '마켓플레이스',
  'homeHero.title': '오늘 무엇을 디자인하시겠어요?',
  'homeHero.startWithTemplate': '템플릿으로 시작하기…',
  'homeHero.startBlankProject': '…또는 빈 프로젝트로 시작',
  'homeHero.templatePicker.label': '템플릿',
  'homeHero.templatePicker.searchPlaceholder': '템플릿 검색',
  'homeHero.templatePicker.projectTypes': '프로젝트 유형',
  'homeHero.templatesScrollHint': '위로 스크롤하여 더 많은 템플릿 살펴보기',
  'homeHero.templatesCollapse': '템플릿 접기',
  'homeHero.subtitlePrefix': '오픈소스 Claude Design 대안.',
  'homeHero.placeholder': '생성하고 싶은 내용을 설명하세요…',
  'homeHero.placeholderActive': '예제 쿼리를 편집하거나 직접 작성하세요…',
  'homeHero.carousel.hint': '파일을 첨부하거나 디자인 시스템을 연결하거나, 만들고 싶은 것을 설명하세요',
  'homeHero.carousel.onePageBrief': '한 페이지짜리 프로젝트 개요 작성하기',
  'homeHero.carousel.notesToDeck': '메모를 프레젠테이션으로 만들기',
  'homeHero.carousel.signupFlow': '회원가입 플로우 목업 만들기',
  'homeHero.carousel.improveBrief': '기존 프로젝트 개요 개선하기',
  'homeHero.carousel.loadingAnimation': '로딩 애니메이션 만들기',
  'homeHero.carousel.teamUpdateSlides': '팀 업데이트용 슬라이드 디자인하기',
  'homeHero.carousel.ordersDashboard': '주문 추적 대시보드 프로토타입 만들기',
  'homeHero.carousel.productDetail': '제품 상세 페이지 레이아웃 잡기',
  'homeHero.carousel.caseStudy': '케이스 스터디 개요 작성하기',
  'homeHero.carousel.landingIntro': '랜딩 페이지의 짧은 인트로 디자인하기',
  'homeHero.carousel.pitchDeck': '신제품 피치덱 만들기',
  'homeHero.carousel.appIdea': '앱 아이디어 설명하기',
  'homeHero.carousel.landingLayout': '랜딩 페이지 레이아웃 스케치하기',
  'homeHero.skills': '스킬',
  'homeHero.addMenu': '컨텍스트 추가',
  'homeHero.addPlugin': '플러그인 추가',
  'homeHero.addConnectors': '커넥터 추가',
  'homeHero.addMcp': 'MCP 서버 추가',
  'homeHero.noPlugins': '설치된 플러그인 없음',
  'homeHero.noMcp': 'MCP 서버 없음',
  'homeHero.noConnectors': '연결된 커넥터 없음',
  'homeHero.applying': '적용 중…',
  'homeHero.pluginTitle': '플러그인: {title}',
  'homeHero.pluginPrefix': '플러그인: {title}',
  'homeHero.skillPrefix': '스킬: {title}',
  'homeHero.removePlugin': '플러그인 제거',
  'homeHero.removePluginAria': '{title} 플러그인 제거',
  'homeHero.clearActivePlugin': '활성 플러그인 지우기',
  'homeHero.clearActiveSkill': '활성 스킬 지우기',
  'homeHero.contextItemsResolved': '컨텍스트 항목 {n}개 확인됨',
  'homeHero.removeFile': '파일 제거',
  'homeHero.contextSearchResults': '컨텍스트 검색 결과',
  'homeHero.contextSurfaces': '컨텍스트 표면',
  'homeHero.loadingContext': '컨텍스트를 불러오는 중…',
  'homeHero.noResults': '"{query}"에 대한 결과가 없습니다.',
  'homeHero.searchPrompt': '파일, 플러그인, 스킬, MCP 서버 및 커넥터 검색.',
  'homeHero.parameters': '매개변수 {n}개',
  'homeHero.details': '세부 정보',
  'homeHero.toRun': '실행',
  'homeHero.forNewLine': '줄 바꿈',
  'homeHero.run': '실행',
  'homeHero.typeSomethingToRun': '실행할 내용을 입력하세요',
  'homeHero.promptExamples': '예시',
  'homeHero.footer.designSystem': '스타일',
  'homeHero.footer.autoDesignSystem': '자동',
  'homeHero.footer.autoDesignSystemSummary': '현재 프롬프트에 가장 알맞은 디자인 시스템과 비주얼 스타일을 자동으로 선택합니다.',
  'homeHero.footer.ratio': '비율',
  'homeHero.footer.duration': '길이',
  'homeHero.footer.resolution': '해상도',
  'homeHero.footer.speakerNotes': '메모',
  'homeHero.footer.noSpeakerNotes': '노트 없음',
  'homeHero.footer.availableCount': '{n}개 사용 가능',
  'homeHero.footer.noMatches': '일치 항목 없음',
  'homeHero.moreShortcuts': '더보기',
  'homeHero.railAria': '프로젝트 카테고리 또는 시작 단축키 선택',
  'homeHero.subTypeAria': '하위 유형 선택',
  'homeHero.subTypeMore': '더 보기',
  'homeHero.confirmReplaceTitle': '현재 프롬프트를 바꿀까요?',
  'homeHero.confirmReplaceBody': '{title}을(를) 사용하면 현재 입력란의 텍스트가 대체됩니다.',
  'homeHero.confirmReplace': '바꾸기',
  'homeHero.chip.prototype': '프로토타입',
  'homeHero.chip.webClone': '웹사이트 클론',
  'homeHero.chip.liveArtifact': '라이브 아티팩트',
  'homeHero.chip.deck': '슬라이드 덱',
  'homeHero.chip.image': '이미지',
  'homeHero.chip.video': '동영상',
  'homeHero.chip.hyperframes': 'HyperFrames',
  'homeHero.chip.webgl': 'WebGL 경험',
  'homeHero.chip.webglDesc': '셰이더, 3D, 제너러티브 GPU 비주얼',
  'homeHero.chip.worker': 'Worker 시각화',
  'homeHero.chip.workerDesc': '오프스레드 시뮬레이션, 파티클, 데이터 시각화',
  'homeHero.chip.audio': '오디오',
  'homeHero.chip.createBrandKit': '브랜드 키트 만들기',
  'homeHero.chip.createPlugin': '플러그인 만들기',
  'homeHero.chip.figma': 'Figma에서 가져오기',
  'homeHero.chip.folder': '폴더에서 가져오기',
  'homeHero.chip.template': '템플릿에서 가져오기',
  'homeHero.chip.liveArtifactHint': '실시간으로 미리 볼 수 있는 인터랙티브 HTML/CSS/JS 아티팩트를 만듭니다.',
  'homeHero.chip.hyperframesHint': 'HTML 기반 모션을 제작하세요: 캡션, 오디오 반응형 비주얼, 장면 전환.',
  'homeHero.chip.createBrandKitHint': '웹사이트에서 브랜드 키트를 추출하여 모든 채팅에 적용하세요.',
  'homeHero.chip.createPluginHint': '재사용 가능한 Open Design 플러그인을 제작하여 내 플러그인에 추가하세요.',
  'homeHero.chip.figmaHint': 'Figma 프레임을 활성 디자인 시스템으로 마이그레이션합니다.',
  'homeHero.chip.folderHint': '기존 로컬 폴더를 가져와 계속 편집합니다.',
  'homeHero.chip.templateHint': '번들 템플릿에서 시작합니다.',
  'homeHero.chip.wireframe': 'Wireframe',
  'homeHero.chip.mobile': 'Mobile app',
  'homeHero.chip.document': 'Document',
  'homeHero.chip.prototypeDesc': 'Interactive app mockups',
  'homeHero.chip.webCloneDesc': 'Source-first site reproduction',
  'homeHero.chip.wireframeDesc': 'Lo-fi screens & flows',
  'homeHero.chip.mobileDesc': 'iOS & Android screens',
  'homeHero.chip.deckDesc': 'Presentations & pitch decks',
  'homeHero.chip.documentDesc': 'Resumes, reports & PDFs',
  'homeHero.chip.imageDesc': 'Posters, graphics & art',
  'homeHero.chip.videoDesc': 'Clips, reels & promos',
  'homeHero.chip.audioDesc': 'Voiceovers, music & SFX',
  'homeHero.chip.hyperframesDesc': 'Motion graphics & loops',
  'homeHero.chip.liveArtifactDesc': 'Data-backed live dashboards',
  'homeHero.chip.createBrandKitDesc': 'Extract a brand design system',
  'homeHero.chip.prototypeNext': 'Open a chat that builds a high-fidelity, clickable web prototype you refine turn by turn.',
  'homeHero.chip.webCloneNext': 'Open a chat that asks for a target URL, reconstructs the site, and audits the clone.',
  'homeHero.chip.wireframeNext': 'Open a chat that sketches lo-fi screens and flows to validate structure first.',
  'homeHero.chip.mobileNext': 'Open a chat that lays out mobile screens for iOS and Android.',
  'homeHero.chip.deckNext': 'Open a chat that builds a slide deck you can present and export.',
  'homeHero.chip.documentNext': 'Open a chat that drafts a polished document — resume, report, or PDF.',
  'homeHero.chip.imageNext': 'Open a chat that generates on-brand images you can iterate on.',
  'homeHero.chip.videoNext': 'Open a chat that produces a short video you can refine.',
  'homeHero.chip.audioNext': 'Open a chat that creates voiceover, music, or sound effects.',
  'homeHero.chip.webClonePromptSeed': 'Website URL to clone: ',
  'homeWorkingDir.trigger': 'Select working directory',
  'homeWorkingDir.pick': 'Choose folder',
  'homeWorkingDir.replace': 'Change working directory',
  'homeWorkingDir.recent': 'Recent folders',
  'homeWorkingDir.recentEmpty': 'No recent folders',
  'homeWorkingDir.clear': 'Remove working directory',
  'homeWorkingDir.hint': 'Let the agent read this local folder (not imported into Design Files)',
  'homeWorkingDir.missing': 'This working folder no longer exists — pick another',
  'homeWorkingDir.applyFailed': 'Couldn\'t set the working directory — the folder may no longer exist',
  'workingDirPicker.title': '폴더',
  'workingDirPicker.homeTitle': '로컬 저장소에 저장됨 — 클릭하여 폴더 선택',
  'workingDirPicker.processing': '처리 중…',
  'workingDirPicker.select': '로컬 저장소',
  'workingDirPicker.clearAria': '작업 디렉터리 지우기',
  'workingDirPicker.replaceFailed': '작업 디렉터리를 바꿀 수 없습니다',
  'workingDirPicker.unavailable': '이 빌드에서는 폴더 선택기를 사용할 수 없습니다. 폴더를 선택하려면 데스크톱 앱을 실행하세요.',
  'workingDirPicker.openUnavailable': '폴더를 표시하려면 데스크톱 앱에서 이 프로젝트를 여세요.',
  'workingDirPicker.openFailed': '이 폴더를 표시할 수 없습니다',
  'workingDirPicker.showInFileManager': '파일 관리자에서 표시',
  'workingDirPicker.replace': '폴더 선택…',
  'workingDirPicker.recent': '최근 디렉터리',
  'workingDirPicker.defaultLabel': '로컬 저장소',
  'handoff.toTarget': '{target}(으)로 넘기기',
  'handoff.openInTarget': '{target}에서 열기',
  'handoff.openAction': '열기',
  'handoff.menuTitle': '어느 편집기에서 열까요?',
  'handoff.action': '넘기기',
  'handoff.fallbackTitle': '$PATH에서 편집기를 찾을 수 없음 - {target}에서 열림',
  'handoff.chooseTargetAria': '넘길 대상 선택',
  'handoff.optionsAria': '넘기기 옵션',
  'handoff.editorSection': '편집기에서 열기',
  'handoff.cliSection': 'CLI용으로 복사',
  'handoff.clickOpen': '클릭하여 열기',
  'handoff.framework': '코드 프레임워크',
  'handoff.framework.react': 'React',
  'handoff.framework.vue': 'Vue.js',
  'handoff.framework.svelte': 'Svelte',
  'handoff.framework.solid': 'SolidJS',
  'handoff.framework.next': 'Next.js',
  'handoff.framework.vanilla': 'JS',
  'handoff.frameworkPrompt.react': 'React',
  'handoff.frameworkPrompt.vue': 'Vue.js',
  'handoff.frameworkPrompt.svelte': 'Svelte',
  'handoff.frameworkPrompt.solid': 'SolidJS',
  'handoff.frameworkPrompt.next': 'Next.js / React',
  'handoff.frameworkPrompt.vanilla': '바닐라 JavaScript, HTML, CSS',
  'handoff.amrWebsite': 'Open Design Cloud 웹사이트 열기',
  'handoff.copyPrompt': '프롬프트 복사',
  'handoff.copyPromptForTarget': '{target}용 프롬프트 복사',
  'handoff.copied': '복사됨',
  'handoff.projectPathUnavailable': '프로젝트 경로를 아직 불러오는 중입니다. 잠시 후 다시 시도하세요.',
  'handoff.copyFailed': '클립보드 쓰기가 차단되었습니다. 잠시 후 다시 시도하세요.',
  'handoff.promptIntro': '이 로컬 Open Design 프로젝트 폴더에서 계속 진행하세요:',
  'handoff.promptTarget': '대상',
  'handoff.promptCli': 'CLI',
  'handoff.promptStepsLead': '{cli}에서 작업을 이어받습니다. 다음을 수행하세요:',
  'handoff.promptReadFiles': '먼저 이 디렉터리에 진입하거나 읽으세요. DESIGN.md, README, 기존 HTML/CSS/JS, 에셋, 그리고 있다면 package.json을 우선시하세요.',
  'handoff.promptKeepDesign': '현재의 시각적 디자인, 레이아웃, 인터랙션, 에셋을 유지하세요. 계획 단계에서 멈추지 마세요.',
  'handoff.promptProduceCode': '실제로 실행 가능한 {framework} 코드를 생성하거나 수정하세요. 프로젝트에 이미 더 명확한 스택이 있다면 충돌을 알리고 결과물이 실행 가능한 상태를 유지하세요.',
  'handoff.promptVerify': '마지막으로 실행, 미리보기, 검증 명령어를 알려주세요.',
  'handoff.promptCommandHint': '프로젝트 디렉터리에서 시작하려면 다음을 사용하세요:',
  'handoff.promptProject': '프로젝트',
  'handoff.promptProjectId': '프로젝트 ID',
  'handoff.notInstalled': '설치되지 않음',
  'handoff.notDetectedTitle': '{target} - $PATH에서 감지되지 않음',
  'designSystemPicker.select': '디자인 시스템 선택',
  'designSystemPicker.loading': '디자인 시스템을 불러오는 중…',
  'designSystemPicker.searchPlaceholder': '디자인 시스템 검색 (제목 / 카테고리 / 요약)',
  'designSystemPicker.searchCompactPlaceholder': '디자인 시스템 검색',
  'designSystemPicker.noneTitle': '디자인 시스템 없음',
  'designSystemPicker.noneSummary': '모델이 자유롭게 선택하도록 하기',
  'designSystemPicker.empty': '일치하는 디자인 시스템이 없습니다',
  'designSystemPicker.openPreview': '미리보기 열기',
  'designSystemPicker.loadingPreview': '미리보기를 불러오는 중…',
  'designSystemPicker.noPreview': '미리보기 페이지가 없습니다. 전체 미리보기를 보려면 디자인 시스템을 여세요.',
  'designSystemPicker.previewHint': '디자인 시스템 위에 마우스를 올려 미리보세요',
  'designSystemPicker.fullscreenAria': '{title} 전체 화면 미리보기',
  'designSystemPicker.closeFullscreen': '전체 화면 미리보기 닫기',
  'designSystemPicker.closeEsc': '닫기 (Esc)',
  'designSystemPicker.previewFrameTitle': '{title} 미리보기',
  'designSystemPicker.fullscreenFrameTitle': '{title} 전체 화면 미리보기',
  'recentProjects.title': '최근 프로젝트',
  'recentProjects.viewAll': '모두 보기',
  'recentProjects.empty': '아직 프로젝트가 없습니다 — 프롬프트를 입력해 시작하세요.',
  'pluginsHome.title': '커뮤니티',
  'pluginsHome.subtitle': '이 런타임에 번들로 제공되는 바로 사용 가능한 Open Design 워크플로입니다. 하나를 선택해 시작용 프롬프트를 불러오거나, 레지스트리에서 더 둘러보세요.',
  'pluginsHome.browseRegistry': '레지스트리 둘러보기',
  'pluginsHome.count': '{total}개 중 {filtered}개',
  'pluginsHome.loadingCatalog': '카탈로그 불러오는 중…',
  'pluginsHome.emptyCatalog': '카탈로그가 비어 있습니다. 번들 플러그인은 Open Design에 포함되어 있으며 여기에 자동으로 표시되어야 합니다 — 문제가 계속되면 데몬을 다시 시작해 보세요.',
  'pluginsHome.emptyFiltered': '현재 필터와 일치하는 플러그인이 없습니다.',
  'pluginsHome.clearFilters': '필터 지우기',
  'pluginsHome.modeAria': '플러그인 모드',
  'pluginsHome.featured': '저장됨',
  'pluginsHome.totalInCatalog': '카탈로그에 {n}개',
  'pluginsHome.categoryFilterAria': '카테고리 필터',
  'pluginsHome.subcategoryFilterAria': '{label} 하위 카테고리 필터',
  'pluginsHome.allCategory': '모든 {label}',
  'pluginsHome.searchPlaceholder': '플러그인 검색…',
  'pluginsHome.searchAria': '플러그인 검색',
  'pluginsHome.clearSearch': '검색 지우기',
  'pluginsHome.sortAria': '정렬 순서',
  'pluginsHome.sortHot': '인기',
  'pluginsHome.sortNewest': '최신',
  'pluginsHome.facet.import': '가져오기',
  'pluginsHome.facet.create': '만들기',
  'pluginsHome.facet.export': '내보내기',
  'pluginsHome.facet.share': '공유',
  'pluginsHome.facet.deploy': '배포',
  'pluginsHome.facet.refine': '다듬기',
  'pluginsHome.facet.extend': '확장',
  'pluginsHome.facet.figma': 'Figma',
  'pluginsHome.facet.github': 'GitHub',
  'pluginsHome.facet.codeFolder': '코드 / 폴더',
  'pluginsHome.facet.url': 'URL',
  'pluginsHome.facet.screenshot': '스크린샷',
  'pluginsHome.facet.pdf': 'PDF',
  'pluginsHome.facet.pptx': 'PPTX',
  'pluginsHome.facet.framer': 'Framer',
  'pluginsHome.facet.webflow': 'Webflow',
  'pluginsHome.facet.slides': '슬라이드',
  'pluginsHome.facet.publicLink': '공개 링크',
  'pluginsHome.facet.githubPr': 'GitHub PR',
  'pluginsHome.facet.githubGist': 'GitHub Gist',
  'pluginsHome.subfacet.business-dashboards': '대시보드',
  'pluginsHome.subfacet.app-prototypes': '앱',
  'pluginsHome.subfacet.landing-marketing': '랜딩 / 마케팅',
  'pluginsHome.subfacet.developer-tools': '개발자 도구',
  'pluginsHome.subfacet.docs-reports': '문서 / 보고서',
  'pluginsHome.subfacet.brand-design': '브랜드 / 디자인',
  'pluginsHome.subfacet.pitch-business': '피치 / 비즈니스',
  'pluginsHome.subfacet.course-training': '강의 / 교육',
  'pluginsHome.subfacet.reports-briefings': '보고서 / 브리핑',
  'pluginsHome.subfacet.product-sales': '제품 / 세일즈',
  'pluginsHome.subfacet.engineering-talks': '기술 발표',
  'pluginsHome.subfacet.creative-decks': '크리에이티브 덱',
  'pluginsHome.subfacet.ui-product-mockups': 'UI / 목업',
  'pluginsHome.subfacet.brand-visuals': '브랜드 / 로고',
  'pluginsHome.subfacet.storyboards-motion-refs': '스토리보드',
  'pluginsHome.subfacet.social-content': '소셜 / 콘텐츠',
  'pluginsHome.subfacet.avatar-portrait': '아바타 / 인물',
  'pluginsHome.subfacet.illustration-style': '일러스트 / 스타일',
  'pluginsHome.subfacet.motion-effects': '모션 / 이펙트',
  'pluginsHome.subfacet.social-short-form': '소셜 / 숏폼',
  'pluginsHome.subfacet.marketing-product': '마케팅 / 제품',
  'pluginsHome.subfacet.data-explainers': '데이터 / 설명',
  'pluginsHome.subfacet.cinematic-story': '시네마틱 / 스토리',
  'pluginsHome.commercialCategory.student-coursework': 'Student coursework',
  'pluginsHome.commercialCategory.corporate-strategy': 'Corporate strategy',
  'pluginsHome.commercialCategory.professional-training': 'Professional training',
  'pluginsHome.commercialCategory.b2b-sales': 'B2B sales',
  'pluginsHome.commercialCategory.academic-research': 'Academic research',
  'pluginsHome.commercialCategory.marketing-gtm': 'Marketing & GTM',
  'pluginsHome.commercialCategory.data-finance': 'Data & finance',
  'pluginsHome.commercialCategory.fundraising-pitch': 'Fundraising pitch',
  'pluginsHome.commercialCategory.government-policy': 'Government & policy',
  'pluginsHome.commercialCategory.product-management': 'Product management',
  'pluginsHome.commercialCategory.consulting': 'Consulting',
  'pluginsHome.commercialCategory.career': 'Career',
  'pluginsHome.commercialCategory.ai-literacy': 'AI literacy',
  'pluginsHome.commercialCategory.life': 'Life & story',
  'pluginsHome.commercialCategory.design-craft': 'Design craft',
  'pluginsView.lede': '설치된 워크플로를 둘러보고, 레지스트리 항목을 찾아보고, 소스를 관리하고, 팀 배포용 플러그인을 준비하세요.',
  'pluginsView.importPlugin': '플러그인 가져오기',
  'pluginsView.agentContext': 'Agent 컨텍스트',
  'pluginsView.summaryAria': '플러그인 요약',
  'pluginsView.areasAria': '플러그인 영역',
  'pluginsView.loading': '플러그인 불러오는 중…',
  'pluginsView.tab.installed': '설치됨',
  'pluginsView.tab.available': '사용 가능',
  'pluginsView.tab.sources': '소스',
  'pluginsView.tab.team': '팀',
  'pluginsView.tabHint.installed': '내 플러그인',
  'pluginsView.tabHint.available': '소스에서',
  'pluginsView.tabHint.sources': '카탈로그',
  'pluginsView.tabHint.team': '엔터프라이즈',
  'pluginsView.installedTitle': '설치된 플러그인',
  'pluginsView.installedSubtitle': '마켓플레이스 소스에서 가져오거나 설치한 플러그인입니다.',
  'pluginsView.installedEmpty': '아직 설치된 사용자 플러그인이 없습니다. 만들기 / 가져오기를 사용하거나 사용 가능 항목을 설치하세요.',
  'pluginsView.availableTitle': '소스에서 사용 가능',
  'pluginsView.availableSubtitle': '구성된 마켓플레이스에서 발견된 카탈로그 항목입니다.',
  'pluginsView.availableFiltersAria': '사용 가능한 플러그인 필터',
  'pluginsView.searchAvailableAria': '사용 가능한 플러그인 검색',
  'pluginsView.searchAvailablePlaceholder': '사용 가능한 플러그인 검색',
  'pluginsView.clearAvailableSearch': '사용 가능한 플러그인 검색 지우기',
  'pluginsView.source': '소스',
  'pluginsView.availableEmptyInstalled': '아직 사용 가능한 항목이 없습니다. 설치된 카탈로그 항목은 사용 가능에서 제거됩니다. 다시 사용 가능하게 하려면 항목을 제거하세요.',
  'pluginsView.availableEmptyFiltered': '필터와 일치하는 사용 가능한 항목이 없습니다.',
  'pluginsView.availableEmptyNoSources': '아직 사용 가능한 항목이 없습니다. Sources 탭에서 소스를 추가하세요.',
  'pluginsView.installing': '설치 중…',
  'pluginsView.install': '설치',
  'pluginsView.sourcesTitle': '레지스트리 소스',
  'pluginsView.sourcesSubtitle': '사용 가능한 플러그인 항목을 제공하는 마켓플레이스 카탈로그입니다.',
  'pluginsView.sourceUrl': '소스 URL',
  'pluginsView.defaultTrust': '기본 신뢰 수준',
  'pluginsView.trust.restricted': '제한됨',
  'pluginsView.trust.trusted': '신뢰됨',
  'pluginsView.trust.official': '공식',
  'pluginsView.adding': '추가 중…',
  'pluginsView.addSource': '소스 추가',
  'pluginsView.sourcesEmpty': '아직 구성된 레지스트리 소스가 없습니다.',
  'pluginsView.pluginsCount': '플러그인 {n}개',
  'pluginsView.catalogVersion': '카탈로그 v{version}',
  'pluginsView.trustFor': '{name}에 대한 신뢰 수준',
  'pluginsView.refreshing': '새로 고치는 중…',
  'pluginsView.removing': '제거 중…',
  'pluginsView.teamTitle': '비공개 팀 마켓플레이스',
  'pluginsView.teamBody': '이 영역은 엔터프라이즈 및 팀 카탈로그, 비공개 신뢰 정책, 공유 플러그인 수명 주기 제어를 위해 예약되어 있습니다.',
  'pluginCard.details': '세부 정보',
  'pluginCard.use': '사용',
  'pluginCard.useWithQuery': '쿼리와 함께 사용',
  'pluginCard.applying': '적용 중…',
  'pluginCard.duplicate': 'Remix',
  'pluginCard.duplicating': 'Remix 중…',
  'pluginCard.duplicateFailed': '이 템플릿을 Remix할 수 없습니다.',
  'pluginCard.saved': '저장됨',
  'pluginCard.publish': '게시',
  'pluginCard.contribute': '기여',
  'pluginCard.starting': '시작 중…',
  'pluginCard.detailsAria': '{title}의 세부 정보 보기',
  'pluginCard.chooseUseAria': '{title} 사용 방법 선택',
  'pluginCard.useOptionsAria': '{title} 사용 옵션',
  'pluginCard.duplicateAria': '{title}을(를) 새 프로젝트로 Remix',
  'pluginCard.saveAria': '{title} 저장',
  'pluginCard.savedAria': '{title} 저장됨',
  'pluginCard.shareAria': '{title} 공유',
  'pluginCard.publishAria': '{title}을(를) GitHub 저장소로 게시',
  'pluginCard.publishTitle': '플러그인을 GitHub 저장소로 게시',
  'pluginCard.contributeAria': '{title}을(를) Open Design에 기여',
  'pluginCard.contributeTitle': 'pull request로 플러그인을 Open Design에 기여',
  'skillPluginCandidate.createForMe': '플러그인/템플릿 만들기',
  'skillPluginCandidate.contributeToMain': 'open-design에 기여',
  'skillPluginCandidate.repoDescription': '이 저장소는 플러그인으로 사용할 수 있을 것 같습니다.',
  'integrations.kicker': '통합',
  'integrations.lede': '외부 시스템을 연결하고, MCP 도구를 Agent 루프에 가져오고, 다른 IDE, 스크립트, 자동화에서 Open Design을 사용하세요.',
  'integrations.agentReady': 'Agent 준비 완료',
  'integrations.areasAria': '통합 영역',
  'integrations.tabLabel.mcp': 'MCP',
  'integrations.tabLabel.skills': 'Skills',
  'integrations.tabHint.mcp': '외부 도구',
  'integrations.tabHint.connectors': '계정 및 API',
  'integrations.tabHint.useEverywhere': 'CLI, HTTP, MCP',
  'integrations.skillsTitle': 'Skills 통합',
  'integrations.skillsBody': 'Skill 수준의 통합 관리는 다른 브랜치에서 이전되고 있습니다. 이 탭은 MCP, Connectors, 향후 Skills 설정이 동일한 Integration 경로에 위치하도록 예약되어 있습니다.',
  'mcpClient.title': '외부 MCP 서버',
  'mcpClient.subtitle': '코딩 Agent를 위한 서드파티 도구입니다.',
  'mcpClient.addServer': '서버 추가',
  'mcpClient.emptyTitle': '구성된 MCP 서버가 없습니다.',
  'mcpClient.emptyBody': '"서버 추가"를 클릭해 시작하세요 — 템플릿(Higgsfield OpenClaw, Pollinations, Allyson, Imagician, EdgeOne Pages, GitHub, Filesystem…)을 선택하거나 사용자 지정 stdio / HTTP 서버를 설정하세요.',
  'mcpClient.saveChanges': '변경 사항 저장',
  'mcpClient.storedAt': '저장 위치',
  'mcpClient.daemonError': '로컬 데몬에 연결할 수 없습니다. Open Design이 실행 중인지 확인한 후 이 패널을 다시 여세요.',
  'mcpClient.saveFailed': '저장에 실패했습니다. 데몬이 실행 중인지 확인하고 다시 시도하세요.',
  'useEverywhere.modalAria': '어디서나 Open Design 사용',
  'useEverywhere.modalTitle': '어디서나 Open Design 사용',
  'useEverywhere.modalSubtitle': 'Open Design을 어떤 IDE, Agent, 스크립트에든 적용하세요 — CLI, HTTP, MCP, Skills. “Agent용 가이드 복사”를 사용해 Claude Code, Codex, Cursor, openclaw, hermes에 붙여 넣어 모든 것을 설정하세요.',
  'useEverywhere.closeAria': '어디서나 사용 닫기',
  'useEverywhere.closeTitle': '닫기 (Esc)',
  'useEverywhere.tabsAria': '통합 표면',
  'useEverywhere.footStrong': '원클릭 핸드오프.',
  'useEverywhere.footBody': 'Agent가 즉시 실행할 수 있는 구조화된 마크다운 가이드를 복사합니다 — 설치, 검증, 사용.',
  'useEverywhere.configureMcp': 'MCP 서버 구성',
  'useEverywhere.copyGuide': 'Agent용 가이드 복사',
  'useEverywhere.copy': '복사',
  'useEverywhere.copied': '복사됨',
  'useEverywhere.copyFailed': '복사 실패',
  'useEverywhere.copySnippetAria': '스니펫 복사: {label}',
  'useEverywhere.section.overview.tab': '개요',
  'useEverywhere.section.overview.heading': 'Open Design는 Agent가 작동하는 곳이라면 어디서든 작동합니다',
  'useEverywhere.section.overview.intro': 'Open Design은 단순한 창 이상입니다 — 로컬 권한 데몬(`od`)에 Skills + Design-Systems + Atoms 레지스트리를 더한 것입니다. 머신에서 실행되면 어떤 코드 Agent(Claude Code, Codex, Cursor, OpenCode/openclaw, Hermes, 직접 만든 스크립트)든 네 가지 호환 가능한 인터페이스를 통해 생성을 구동하고, 프로젝트를 검사하고, 디자인 아티팩트를 만들 수 있습니다.',
  'useEverywhere.section.overview.bullet1': 'CLI — 헤드리스 스크립트, CI, 셸 자동화를 위한 `od <command>`.',
  'useEverywhere.section.overview.bullet2': 'MCP 서버 — Open Design을 Model Context Protocol 서버로 연결해 MCP 지원 Agent가 skills를 나열하고, 시나리오를 실행하고, 아티팩트를 읽을 수 있게 합니다.',
  'useEverywhere.section.overview.bullet3': 'HTTP API — `http://127.0.0.1:7456/api/*` REST + SSE 엔드포인트, 웹 UI가 사용하는 것과 동일한 인터페이스입니다.',
  'useEverywhere.section.overview.bullet4': 'Skills — PATH에 이미 있는 어떤 Agent든 Open Design 없이도 호출할 수 있는 드롭인 `SKILL.md` 팩(Claude 호환).',
  'useEverywhere.section.overview.bullet5': '표준 아티팩트 — 데몬이 시작되기 전에 Skills, 번들 기본 플러그인, 커뮤니티 플러그인 예제로부터 실제 HTML 프로젝트를 시드합니다.',
  'useEverywhere.section.overview.snippet1': '데몬(및 웹 UI)을 로컬에서 시작',
  'useEverywhere.section.overview.snippet2': '연결 가능 여부 확인',
  'useEverywhere.section.overview.snippet3': '부팅 전에 표준 아티팩트 수집',
  'useEverywhere.section.overview.footer': '데몬은 기본적으로 `./.od/`(프로젝트 로컬)에 기록합니다. 프로젝트 간에 데이터를 공유하려면 `OD_DATA_DIR=~/.open-design`을 설정하세요.',
  'useEverywhere.section.cli.tab': 'CLI · od',
  'useEverywhere.section.cli.heading': '모든 셸에서 Open Design 구동',
  'useEverywhere.section.cli.intro': '`od` 바이너리는 데몬과 함께 제공되며, Claude Code / Codex가 생성을 실행할 때 사용하는 것과 동일한 바이너리입니다. 대부분의 하위 명령은 로컬 데몬에 POST하는 얇은 클라이언트이므로, `pnpm tools-dev`로 실행했든 패키징된 앱으로 실행했든 동일하게 작동합니다.',
  'useEverywhere.section.cli.bullet1': '`od` (인수 없음) — 데몬을 부팅하고 웹 UI를 엽니다.',
  'useEverywhere.section.cli.bullet2': '`od media generate ...` — 통합 미디어 프로토콜을 통해 이미지 / 비디오 / 오디오 바이트를 생성합니다.',
  'useEverywhere.section.cli.bullet3': '`od run ...` — 프롬프트 + skill로부터 프로젝트 실행을 시작합니다.',
  'useEverywhere.section.cli.bullet4': '`od plugin install <source>` / `od plugin apply <id>` — 커뮤니티 플러그인을 설치하고 적용합니다.',
  'useEverywhere.section.cli.bullet5': '`od skills list` / `od design-systems list` — 로컬에서 사용 가능한 것을 검사합니다.',
  'useEverywhere.section.cli.bullet6': '`od status` / `od doctor` — 데몬 상태를 확인하고 PATH의 Agent CLI를 감지합니다.',
  'useEverywhere.section.cli.snippet1': '이미지 생성(구성된 미디어 제공자에게 위임)',
  'useEverywhere.section.cli.snippet2': '시나리오 플러그인을 헤드리스로 실행하고 이벤트를 JSON 라인으로 스트리밍',
  'useEverywhere.section.cli.snippet3': '로컬에서 사용 가능한 스킬과 디자인 시스템 인벤토리',
  'useEverywhere.section.cli.snippet4': 'CLI를 통해 시드된 아티팩트 확인',
  'useEverywhere.section.cli.snippet5': '환경 + 감지된 Agent 검증 (Claude, Codex, Cursor, …)',
  'useEverywhere.section.cli.footer': '모든 하위 명령은 `--daemon-url http://127.0.0.1:<port>`를 받아 특정 실행 중인 데몬을 대상으로 지정할 수 있습니다 — 테스트용 샌드박스 두 번째 인스턴스를 실행할 때 유용합니다.',
  'useEverywhere.section.mcp.tab': 'MCP 서버',
  'useEverywhere.section.mcp.heading': 'Open Design를 MCP 서버로 모든 코딩 Agent에 노출',
  'useEverywhere.section.mcp.intro': 'Open Design에는 Model Context Protocol 서버(`od mcp`)가 포함되어 있어, MCP 지원 클라이언트 — Cursor, Claude Code, Antigravity, VS Code Copilot Chat, openclaw, hermes — 가 수동으로 셸을 거치지 않고도 Open Design 도구(skills 나열, 미리 보기 렌더링, 미디어 생성, 플러그인 실행)를 발견할 수 있습니다. 데몬은 각 주요 클라이언트에 대해 바로 붙여 넣을 수 있는 설치 스니펫을 `GET /api/mcp/install-info`를 통해 게시합니다.',
  'useEverywhere.section.mcp.bullet1': 'stdio 전송 — 추가 포트가 없으며, 클라이언트가 `od mcp`를 직접 생성합니다.',
  'useEverywhere.section.mcp.bullet2': '사이드카로 실행될 때 로컬 IPC 상태 소켓을 통해 실행 중인 데몬 URL을 자동으로 검색합니다.',
  'useEverywhere.section.mcp.bullet3': '일반 설치의 경우 `--daemon-url http://127.0.0.1:<port>`로 대체하여 MCP 프로세스가 항상 실행 중인 데몬을 찾을 수 있도록 합니다.',
  'useEverywhere.section.mcp.bullet4': '`OD_DATA_DIR`을 고정하여 생성된 MCP 프로세스가 데몬이 이미 사용 중인 위치와 동일한 곳에 기록하도록 합니다(패키징된 macOS 앱 번들에서 EPERM 방지).',
  'useEverywhere.section.mcp.snippet1': '범용 MCP 클라이언트 구성 (Cursor, Claude Code, Codex, …에서 작동)',
  'useEverywhere.section.mcp.snippet2': '또는: 설치 환경에 맞춘 스니펫을 데몬에 요청',
  'useEverywhere.section.mcp.snippet3': '라이브 아티팩트 MCP 변형(대시보드 읽기 및 새로 고침)',
  'useEverywhere.section.mcp.footer': 'Open Design 앱에서 설정 → 통합을 열어 JSON을 직접 편집하는 대신 클라이언트별 설치 명령(Cursor, Claude Code, Antigravity, VS Code)을 복사하세요.',
  'useEverywhere.section.http.tab': 'HTTP API',
  'useEverywhere.section.http.heading': '웹 UI가 사용하는 것과 동일한 REST + SSE 표면',
  'useEverywhere.section.http.intro': '로컬 데몬은 `http://127.0.0.1:7456`에서 HTTP API를 제공합니다(포트 구성 가능). 웹 UI가 호출하는 모든 엔드포인트는 스크립트에서도 마찬가지로 사용할 수 있습니다. 스트리밍 엔드포인트(채팅 턴, 프로젝트 실행)는 `@open-design/contracts`의 계약 타입과 함께 Server-Sent Events를 내보냅니다.',
  'useEverywhere.section.http.bullet1': '`GET /api/health` — 데몬 활성 상태.',
  'useEverywhere.section.http.bullet2': '`GET /api/skills` 및 `GET /api/design-systems` — 사용 가능한 레지스트리.',
  'useEverywhere.section.http.bullet3': '`GET /api/projects` 및 `POST /api/projects` — 프로젝트 나열 및 생성 (POST는 프로젝트 + 첫 대화를 반환합니다).',
  'useEverywhere.section.http.bullet4': '`GET /api/projects/:id/chat` — 대화에 대한 Agent 이벤트의 SSE 스트림.',
  'useEverywhere.section.http.bullet5': '`POST /api/plugins/:id/apply` — 설치된 플러그인을 바인딩하고 렌더링된 예제 쿼리 + 입력을 가져옵니다.',
  'useEverywhere.section.http.bullet6': '`GET /api/agents` — PATH에서 감지된 코드 Agent CLI.',
  'useEverywhere.section.http.snippet1': '설치된 스킬 목록 표시(Agent가 이를 템플릿으로 사용)',
  'useEverywhere.section.http.snippet2': '프롬프트로 프로젝트 생성(전체 서버 측 플로우)',
  'useEverywhere.section.http.snippet3': '채팅 턴 스트리밍 (SSE — 각 줄은 JSON-Lines 호환)',
  'useEverywhere.section.http.footer': '모든 요청/응답에 대한 순수 TypeScript 타입은 `@open-design/contracts`에 있습니다 — 생성기를 연결하지 않고도 완전한 자동 완성을 위해 스크립트에서 가져오세요.',
  'useEverywhere.section.skills.tab': '스킬 & 헤드리스',
  'useEverywhere.section.skills.heading': '어떤 Agent를 위한 드롭인 Skills — Open Design이 실행되고 있지 않아도',
  'useEverywhere.section.skills.intro': 'Skill은 Claude 호환 `SKILL.md`(YAML 프런트 매터 + 본문)를 포함하는 디렉터리입니다. Open Design은 `od:` 네임스페이스(`mode`, `preview`, `design_system`, `inputs`, …)로 형식을 확장하므로 동일한 아티팩트를 Open Design 내부와 Claude Code, Codex, openclaw, hermes 같은 일반 Agent 양쪽에서 사용할 수 있습니다. 발견은 우선순위 체인을 따르므로 프로젝트가 자체 skills를 재정의할 수 있습니다.',
  'useEverywhere.section.skills.bullet1': '발견: `./.claude/skills/` → `./skills/` → `~/.claude/skills/` (프로젝트 우선).',
  'useEverywhere.section.skills.bullet2': '하나의 스킬을 여러 프로젝트에 심볼릭 링크로 연결하여 복사 없이 공유하세요.',
  'useEverywhere.section.skills.bullet3': '각 스킬은 커넥터, 아톰, 디자인 시스템 요구 사항, 그리고 갤러리용 `preview` 예시 출력을 선언할 수 있습니다.',
  'useEverywhere.section.skills.bullet4': '헤드리스: PATH에 `od`가 있는 Agent는 `od skills list`를 호출한 다음 모든 스킬을 실행할 수 있습니다. 읽기 전용 플로우에서는 데몬이 선택 사항입니다.',
  'useEverywhere.section.skills.bullet5': '`pnpm seed:test-projects`는 기본 플러그인 예시와 커뮤니티 플러그인 예시로 동일한 아티팩트 형태를 실행한 다음, 결과로 나온 `index.html` 프로젝트를 재사용 가능한 테스트 데이터로 저장합니다.',
  'useEverywhere.section.skills.snippet1': '최소 SKILL.md (Claude 호환 front matter + Open Design 추가 항목)',
  'useEverywhere.section.skills.snippet2': '공유 스킬을 프로젝트에 심볼릭 링크로 연결(cc-switch 방식)',
  'useEverywhere.section.skills.snippet3': '헤드리스: 데몬이 지금 인식하는 스킬 목록 표시',
  'useEverywhere.section.skills.snippet4': '헤드리스 아티팩트 픽스처 번들',
  'useEverywhere.section.skills.footer': '명세: `docs/skills-protocol.md`와 `docs/agent-adapters.md`는 전체 어댑터 표면(Claude Code, Codex, Cursor, MCP 지원 Agent, BYOK API 폴백)과 어댑터별 스킬 주입 전략을 다룹니다.',
  'tasks.kicker': '자동화 워크스페이스',
  'tasks.comingSoon': '출시 예정',
  'tasks.lede': '자동화는 프롬프트를 지속적인 작업으로 전환합니다. Orbit가 이를 실행하고, 루틴이 이를 유지하며, 스케줄이 실행 시점을 결정하고, 라이브 아티팩트가 변경된 내용을 보여줍니다.',
  'tasks.newAutomation': '새 자동화',
  'tasks.previewNote': '미리 보기 표면 전용. Orbit 설정은 현재 사용 가능하며, 루틴, 스케줄, 라이브 아티팩트 연결은 백엔드 브랜치가 병합되면서 추가될 예정입니다.',
  'tasks.primitivesAria': '자동화 프리미티브',
  'tasks.primitive.orbit.title': 'Orbit',
  'tasks.primitive.orbit.body': '장시간 실행되거나 반복되는 Agent 작업을 위한 영구 런타임입니다.',
  'tasks.primitive.orbit.enabled': '일일 요약 활성화됨',
  'tasks.primitive.orbit.manualOnly': '수동 전용',
  'tasks.primitive.routines.title': '루틴',
  'tasks.primitive.routines.body': '단일 채팅이 끝난 후에도 유지되는 지속적인 작업 정의입니다.',
  'tasks.primitive.routines.meta': '제품 셸 준비됨',
  'tasks.primitive.schedules.title': '스케줄',
  'tasks.primitive.schedules.body': '루틴이 실행되어야 할 시점을 결정하는 시간 또는 이벤트 트리거입니다.',
  'tasks.primitive.schedules.meta': '브랜치 대기 중',
  'tasks.primitive.liveArtifacts.title': '라이브 아티팩트',
  'tasks.primitive.liveArtifacts.body': 'Agent가 작업하는 동안 계속 업데이트되는 보고서와 노트입니다.',
  'tasks.primitive.liveArtifacts.meta': '미리 보기 모델',
  'tasks.listAria': '자동화 목록',
  'tasks.routinesAndRuns': '루틴 및 실행 {n}개',
  'tasks.filtersAria': '자동화 필터',
  'tasks.filter.scheduled': '예약됨',
  'tasks.filter.running': '실행 중',
  'tasks.filter.done': '완료',
  'tasks.configurationAria': '자동화 구성',
  'tasks.slot.trigger': '트리거',
  'tasks.slot.pattern': '패턴',
  'tasks.slot.runtime': '런타임',
  'tasks.slot.output': '출력',
  'tasks.liveArtifact': '실시간 아티팩트',
  'tasks.viewProgress': '진행 상황 보기',
  'tasks.pause': '일시중지',
  'tasks.runNow': '지금 실행',
  'tasks.openArtifact': '아티팩트 열기',
  'tasks.status.dailyAt': '매일 · {time}',
  'tasks.status.pausedManual': '일시 중지됨 · 수동 전용',
  'tasks.sample.orbit.title': 'Orbit Daily 커넥터 요약',
  'tasks.sample.orbit.metaEnabled': '커넥터 다이제스트가 예약되었습니다',
  'tasks.sample.orbit.metaDisabled': '활성화하려면 Orbit 설정을 여세요',
  'tasks.sample.orbit.previewEnabled': 'orbit_daily.html · 실시간 아티팩트',
  'tasks.sample.orbit.previewDisabled': '예약된 실행 없음',
  'tasks.sample.orbit.triggerEnabled': '일정 · 매일 {time}',
  'tasks.sample.orbit.triggerDisabled': '수동 · 필요 시 실행',
  'tasks.sample.orbit.pattern': '루틴 · 커넥터 다이제스트',
  'tasks.sample.orbit.runtime': 'Orbit · 데몬 예약됨',
  'tasks.sample.orbit.output': '실시간 아티팩트 · 새로 고칠 수 있는 리포트',
  'tasks.sample.orbit.artifactMetaEnabled': '실행할 때마다 새로 고침됩니다',
  'tasks.sample.orbit.artifactMetaDisabled': '일정 대기 중',
  'tasks.sample.orbit.body1': '# Orbit Daily 활동 요약',
  'tasks.sample.orbit.body2': '커넥터 확인됨 · 성공, 건너뜀, 실패',
  'tasks.sample.orbit.body3': '하이라이트는 새로 고칠 수 있는 실시간 아티팩트가 됩니다.',
  'tasks.sample.mcp.title': 'MCP 대안 리서치',
  'tasks.sample.mcp.status': 'orbit에서 실행 중 · 2시간 14분',
  'tasks.sample.mcp.meta': '소스 14 / 30개 처리됨',
  'tasks.sample.mcp.preview': 'research_notes.md · 실시간',
  'tasks.sample.mcp.trigger': '수동 · 일회성',
  'tasks.sample.mcp.pattern': '심층 리서치 프롬프트',
  'tasks.sample.mcp.runtime': '원격 · 지속적',
  'tasks.sample.mcp.output': '실시간 리포트 · 자동 업데이트',
  'tasks.sample.mcp.artifactMeta': '12초 전 업데이트됨',
  'tasks.sample.mcp.body1': '# MCP 대안 - 중간 결과',
  'tasks.sample.mcp.body2': '14개 소스 검토됨 · 3개 후보 선정',
  'tasks.sample.mcp.body3': '## 후보 목록',
  'tasks.sample.mcp.body4': '- JSON-RPC를 통한 도구 호출 스키마...',
  'tasks.sample.mcp.body5': '- gRPC 기반 Agent 프로토콜...',
  'tasks.sample.weekly.title': '주간 팀 다이제스트',
  'tasks.sample.weekly.status': '다음: 월 오전 9:00',
  'tasks.sample.weekly.meta': '팀 주간 문서 업데이트',
  'tasks.sample.weekly.preview': 'team_weekly.md · 다음 아티팩트',
  'tasks.sample.weekly.trigger': '일정 · 주간',
  'tasks.sample.weekly.pattern': '루틴 · 팀 다이제스트',
  'tasks.sample.weekly.runtime': '원격 · 반복',
  'tasks.sample.weekly.output': '라이브 아티팩트 · markdown',
  'tasks.sample.weekly.artifactMeta': '4일 전 마지막 업데이트',
  'tasks.sample.weekly.body1': '# 팀 주간',
  'tasks.sample.weekly.body2': '## 진행 중',
  'tasks.sample.weekly.body3': '- 디자인 시스템 통합 작업',
  'tasks.sample.weekly.body4': '- 커넥터 품질 점검',
  'tasks.sample.weekly.body5': '## 리스크',
  'tasks.sample.pr.title': 'PR 리뷰 알림',
  'tasks.sample.pr.status': '새 PR 발생 시 · 23분 전 실행됨',
  'tasks.sample.pr.meta': 'Slack DM 전송',
  'tasks.sample.pr.preview': '마지막 전달 성공',
  'tasks.sample.pr.trigger': '이벤트 · 새 PR',
  'tasks.sample.pr.pattern': '루틴 · 알림',
  'tasks.sample.pr.runtime': '로컬 · 빠른 실행',
  'tasks.sample.pr.output': '메시지 · Slack DM',
  'tasks.sample.pr.artifactMeta': '23분 전 마지막 실행',
  'tasks.sample.pr.body1': '리뷰를 위해 PR #184을(를) 열었습니다',
  'tasks.sample.pr.body2': '매칭된 리뷰어: design-platform, web-runtime',
  'tasks.sample.pr.body3': '전달: Slack DM 전송됨',
  'tasks.sample.meeting.title': '회의 사전 준비',
  'tasks.sample.meeting.status': '내일 · 오전 10:00',
  'tasks.sample.meeting.meta': '단발 · 요약 전송',
  'tasks.sample.meeting.preview': 'meeting_brief.md · 대기 중',
  'tasks.sample.meeting.trigger': '일정 · 단발',
  'tasks.sample.meeting.pattern': '브리핑 프롬프트',
  'tasks.sample.meeting.runtime': '원격 · 제한됨',
  'tasks.sample.meeting.output': '아티팩트 + 메시지',
  'tasks.sample.meeting.artifactMeta': '생성 대기 중',
  'tasks.sample.meeting.body1': '# 회의 브리핑',
  'tasks.sample.meeting.body2': '안건 소스: 캘린더 이벤트 + 연결된 문서',
  'tasks.sample.meeting.body3': '출력에는 결정 사항, 블로커, 질문이 포함됩니다.',
  'tasks.sample.candidate.title': '후보자 추적',
  'tasks.sample.candidate.status': '실패 · 확인 필요',
  'tasks.sample.candidate.meta': '인증 만료됨',
  'tasks.sample.candidate.preview': '재개하려면 Greenhouse를 다시 연결하세요',
  'tasks.sample.candidate.trigger': '일정 · 매일',
  'tasks.sample.candidate.pattern': '루틴 · 지원자 동기화',
  'tasks.sample.candidate.runtime': '원격 · 반복',
  'tasks.sample.candidate.output': '라이브 아티팩트 · 테이블',
  'tasks.sample.candidate.artifactMeta': '인증이 복구될 때까지 일시중지됨',
  'tasks.sample.candidate.body1': '# 후보자 파이프라인',
  'tasks.sample.candidate.body2': '마지막 동기화 성공: 2일 전',
  'tasks.sample.candidate.body3': '조치 필요: 소스 계정을 다시 연결하세요.',
  'routines.title': '자동화',
  'routines.subtitle': '무인으로 실행되는 예약된 자동화입니다.',
  'routines.newAutomation': '새 자동화',
  'routines.loading': '로딩 중…',
  'routines.empty': '아직 자동화가 없습니다.',
  'routines.emptyHint': '새 자동화를 클릭하여 무인 Agent 실행을 예약하세요.',
  'routines.runHistoryLoading': '실행 기록 로딩 중…',
  'routines.runHistoryEmpty': '아직 실행 기록이 없습니다.',
  'routines.fieldName': '이름',
  'routines.fieldNamePlaceholder': '아침 브리핑',
  'routines.fieldPrompt': '프롬프트',
  'routines.fieldPromptPlaceholder': '어제의 GitHub + Linear 활동을 가져와 변경된 내용을 요약합니다.',
  'routines.fieldSchedule': '일정',
  'routines.fieldMinute': '매시 분',
  'routines.fieldTime': '시간',
  'routines.fieldTimezone': '시간대',
  'routines.fieldsetProject': '프로젝트',
  'routines.kind.hourly': '매시간',
  'routines.kind.daily': '매일',
  'routines.kind.weekdays': '평일',
  'routines.kind.weekly': '매주',
  'routines.weekday.short.0': '일',
  'routines.weekday.short.1': '월',
  'routines.weekday.short.2': '화',
  'routines.weekday.short.3': '수',
  'routines.weekday.short.4': '목',
  'routines.weekday.short.5': '금',
  'routines.weekday.short.6': '토',
  'routines.weekday.long.0': '일요일',
  'routines.weekday.long.1': '월요일',
  'routines.weekday.long.2': '화요일',
  'routines.weekday.long.3': '수요일',
  'routines.weekday.long.4': '목요일',
  'routines.weekday.long.5': '금요일',
  'routines.weekday.long.6': '토요일',
  'routines.timeAm': 'AM',
  'routines.timePm': 'PM',
  'routines.describe.hourly': '매시간 :{minute}에 실행',
  'routines.describe.daily': '매일 {time} {tz}에 실행',
  'routines.describe.weekdays': '월–금 {time} {tz}에 실행',
  'routines.describe.weekly': '매주 {day} {time} {tz}에 실행',
  'routines.modeCreate': '실행할 때마다 새 프로젝트 만들기',
  'routines.modeCreateHint': '실행할 때마다 새롭고 격리된 작업 공간을 만듭니다.',
  'routines.modeReuse': '기존 프로젝트 재사용',
  'routines.modeReuseHint': '각 실행은 프로젝트 내 새 대화로 생성됩니다.',
  'routines.pickProject': '— 프로젝트 선택 —',
  'routines.targetReuse': '→ {project}',
  'routines.targetCreate': '→ 실행마다 새 프로젝트',
  'routines.tagPaused': '일시중지됨',
  'routines.metaNext': '다음: {when}',
  'routines.metaLast': '마지막:',
  'routines.triggerManual': '수동',
  'routines.triggerScheduled': '예약됨',
  'routines.openProject': '프로젝트 열기',
  'routines.openProjectTitle': '이 실행이 작성한 프로젝트 열기',
  'routines.runNow': '지금 실행',
  'routines.edit': '편집',
  'routines.pause': '일시중지',
  'routines.resume': '재개',
  'routines.history': '기록',
  'routines.hideHistory': '기록 숨기기',
  'routines.delete': '삭제',
  'routines.deleteTitle': '이 자동화 삭제',
  'routines.cancel': '취소',
  'routines.save': '저장',
  'routines.saving': '저장 중…',
  'routines.create': '만들기',
  'routines.creating': '생성 중…',
  'routines.status.queued': '대기 중',
  'routines.status.running': '실행 중',
  'routines.status.succeeded': '성공',
  'routines.status.failed': '실패',
  'routines.status.canceled': '취소됨',
  'routines.confirmDelete': '이 자동화를 삭제할까요? 지난 실행 기록과 해당 프로젝트는 유지됩니다.',
  'routines.errorPickProject': '재사용할 프로젝트를 선택하거나 “실행마다 새로 생성”으로 전환하세요',
  'routines.errorAgentEmptyOutput': 'Agent가 출력 없이 완료되었습니다. 모델 또는 공급자가 빈 응답을 반환했을 수 있습니다 — 업스트림 오류는 Agent 로그를 확인하세요.',
  'entry.helpAria': '도움말',
  'entry.helpMenuAria': '도움말 메뉴',
  'entry.helpGetHelp': 'GitHub 에서 도움 받기',
  'entry.helpSubmitFeature': '기능 제안하기',
  'entry.helpWhatsNew': '새로운 소식',
  'entry.helpDownloadDesktop': '데스크탑 앱 다운로드',
  'entry.githubStarLabel': 'Star',
  'entry.githubStarTitle': 'GitHub 에서 별을 눌러주세요',
  'entry.githubStarAria': 'GitHub 에서 Open Design 에 별 누르기',
  'entry.tabImageTemplates': '이미지 템플릿',
  'entry.tabVideoTemplates': '비디오 템플릿',
  'promptTemplates.searchPlaceholder': '템플릿 검색…',
  'promptTemplates.countLabel': '{n}개 결과',
  'promptTemplates.emptyImage': '설치된 이미지 프롬프트 템플릿이 없습니다.',
  'promptTemplates.emptyVideo': '설치된 비디오 프롬프트 템플릿이 없습니다.',
  'promptTemplates.emptyNoMatch': '검색어와 일치하는 템플릿이 없습니다.',
  'promptTemplates.attributionFooter': '공개 프롬프트 라이브러리를 기반으로 합니다. 각 카드는 원작자 페이지로 연결됩니다.',
  'promptTemplates.openPreviewTitle': '프롬프트 열기 및 미리보기',
  'promptTemplates.sourcePrefix': '출처:',
  'promptTemplates.fetchError': '이 템플릿의 본문을 불러올 수 없습니다.',
  'promptTemplates.promptLabel': '프롬프트 본문',
  'promptTemplates.copyPrompt': '프롬프트 복사',
  'promptTemplates.copyDone': '복사 완료!',
  'promptTemplates.modelHint': '추천 모델: {model}',
  'promptTemplates.openSource': '원본 보기',
  'promptTemplates.openFullscreen': '전체 화면 미리보기 열기',
  'promptTemplates.closeFullscreen': '전체 화면 미리보기 닫기',
  'promptTemplates.allSources': '모든 출처',
  'promptTemplates.sourceFilterAria': '출처별 필터',
  'promptTemplates.retry': '다시 시도',
  'connectors.title': '커넥터',
  'connectors.subtitle': '라이브 아티팩트에 연결할 수 있는 로컬 및 향후 데이터 소스입니다.',
  'connectors.account': '계정',
  'connectors.noAccount': '연결되지 않음',
  'connectors.tools': '도구',
  'connectors.connect': '연결',
  'connectors.disconnect': '연결 해제',
  'connectors.authorizationPending': '권한 부여 대기 중...',
  'connectors.authorizationPendingHint': '열린 창에서 권한 부여를 완료하세요.',
  'connectors.cancelAuthorization': '취소',
  'connectors.configure': '설정',
  'connectors.unavailable': '사용 불가',
  'connectors.phaseStubTitle': '커넥터 API는 3단계에서 제공됩니다. 현재는 미리보기 화면입니다.',
  'connectors.statusAvailable': '사용 가능',
  'connectors.statusConnected': '연결됨',
  'connectors.statusError': '오류',
  'connectors.statusDisabled': '비활성화됨',
  'connectors.gateTitle': '계속하려면 Composio API 키를 추가하세요',
  'connectors.gateBody': '위에 키를 붙여넣고 키 저장을 클릭하면 사용 가능한 통합을 불러옵니다.',
  'connectors.aboutLabel': '정보',
  'connectors.detailsLabel': '세부 정보',
  'connectors.statusLabel': '상태',
  'connectors.category.aiAgents': 'AI 에이전트',
  'connectors.category.aiInfrastructure': 'AI 인프라',
  'connectors.category.accounting': '회계',
  'connectors.category.admin': '관리',
  'connectors.category.advertising': '광고',
  'connectors.category.analytics': '분석',
  'connectors.category.automation': '자동화',
  'connectors.category.cms': 'CMS',
  'connectors.category.crm': 'CRM',
  'connectors.category.calendar': '캘린더',
  'connectors.category.commerce': '커머스',
  'connectors.category.communication': '커뮤니케이션',
  'connectors.category.contacts': '연락처',
  'connectors.category.dataPlatform': '데이터 플랫폼',
  'connectors.category.database': '데이터베이스',
  'connectors.category.design': '디자인',
  'connectors.category.developer': '개발자 도구',
  'connectors.category.documentation': '문서',
  'connectors.category.erp': 'ERP',
  'connectors.category.education': '교육',
  'connectors.category.email': '이메일',
  'connectors.category.events': '이벤트',
  'connectors.category.fieldService': '현장 서비스',
  'connectors.category.finance': '재무',
  'connectors.category.fitness': '피트니스',
  'connectors.category.forms': '폼',
  'connectors.category.gaming': '게임',
  'connectors.category.hr': 'HR',
  'connectors.category.hospitality': '호스피탈리티',
  'connectors.category.itsm': 'ITSM',
  'connectors.category.integration': '통합',
  'connectors.category.localization': '현지화',
  'connectors.category.logistics': '물류',
  'connectors.category.maps': '지도',
  'connectors.category.marketing': '마케팅',
  'connectors.category.media': '미디어',
  'connectors.category.meetings': '회의',
  'connectors.category.nonprofit': '비영리',
  'connectors.category.observability': '옵저버빌리티',
  'connectors.category.payments': '결제',
  'connectors.category.personal': '개인',
  'connectors.category.presentations': '프레젠테이션',
  'connectors.category.procurement': '조달',
  'connectors.category.product': '제품',
  'connectors.category.productivity': '생산성',
  'connectors.category.projectManagement': '프로젝트 관리',
  'connectors.category.recruiting': '채용',
  'connectors.category.research': '리서치',
  'connectors.category.salesIntelligence': '영업 인텔리전스',
  'connectors.category.scheduling': '일정 예약',
  'connectors.category.search': '검색',
  'connectors.category.security': '보안',
  'connectors.category.signing': '서명',
  'connectors.category.social': '소셜',
  'connectors.category.spreadsheets': '스프레드시트',
  'connectors.category.storage': '스토리지',
  'connectors.category.support': '지원',
  'connectors.category.surveys': '설문',
  'connectors.category.tasks': '작업',
  'connectors.category.timeTracking': '시간 추적',
  'connectors.category.video': '비디오',
  'connectors.category.whiteboard': '화이트보드',
  'connectors.categoryLabel': '카테고리',
  'connectors.providerLabel': '제공자',
  'connectors.toolsSection': '도구',
  'connectors.toolsLoading': '도구 불러오는 중…',
  'connectors.noToolsAvailable': '아직 사용 가능한 도구가 없습니다. 연결 후 이 통합의 기능이 표시됩니다.',
  'connectors.toolDetailsUnavailable': '도구 세부 정보를 확인할 수 없지만, 이 커넥터는 {n}개의 도구를 보고합니다.',
  'connectors.loadMoreTools': '도구 더 불러오기',
  'connectors.openDetailsAria': '{name} 세부 정보 열기',
  'connectors.toolsBadgeNone': '도구 없음',
  'connectors.toolsBadgeOne': '{n}개 도구',
  'connectors.toolsBadgeMany': '{n}개 도구',
  'connectors.searchPlaceholder': '커넥터 검색…',
  'connectors.searchAriaLabel': '이름, 제공자 또는 도구 기준으로 커넥터 검색',
  'connectors.searchClear': '검색 지우기',
  'connectors.emptyNoMatchTitle': '“{query}”와 일치하는 커넥터가 없습니다',
  'connectors.emptyNoMatchBody': '다른 키워드를 시도하거나 검색을 지워 전체 목록을 확인하세요.',
  'connectors.emptyNoMatchAction': '검색 지우기',
  'newproj.tabPrototype': '프로토타입',
  'newproj.tabLiveArtifact': '라이브 아티팩트',
  'newproj.tabDeck': '슬라이드 덱',
  'newproj.tabTemplate': '템플릿에서 시작',
  'newproj.tabMedia': '미디어',
  'newproj.tabOther': '기타',
  'newproj.titlePrototype': '새 프로토타입',
  'newproj.titleLiveArtifact': '새 라이브 아티팩트',
  'newproj.titleDeck': '새 슬라이드 덱',
  'newproj.titleTemplate': '템플릿에서 시작',
  'newproj.titleImage': '새 이미지',
  'newproj.titleVideo': '새 비디오',
  'newproj.titleAudio': '새 오디오',
  'newproj.titleMedia': '새 미디어',
  'newproj.titleOther': '새 프로젝트',
  'newproj.namePlaceholder': '프로젝트 이름',
  'newproj.fidelityLabel': '피델리티 (Fidelity)',
  'newproj.fidelityWireframe': '와이어프레임',
  'newproj.fidelityHigh': '하이 피델리티 (High fidelity)',
  'newproj.toggleSpeakerNotes': '발표자 노트 사용',
  'newproj.toggleSpeakerNotesHint': '슬라이드 텍스트를 줄이고 주요 내용을 노트에 보관합니다.',
  'newproj.toggleAnimations': '애니메이션 포함',
  'newproj.toggleAnimationsHint': '템플릿에 모션 (등장, 호버, 전환 효과)을 추가합니다.',
  'newproj.targetPlatformsLabel': '대상 플랫폼',
  'newproj.targetPlatformsHint': '하나 이상 선택하세요. 반응형 웹은 브라우저 중단점만 지원합니다. 네이티브 크로스 플랫폼 버전을 위해 iOS, Android, 태블릿 앱 또는 데스크톱 앱을 추가하세요.',
  'newproj.platform.responsive.label': '반응형 웹',
  'newproj.platform.responsive.hint': '데스크톱, 태블릿, 모바일 브라우저에 맞게 조정된 하나의 웹 경험',
  'newproj.platform.webDesktop.label': '데스크톱 웹',
  'newproj.platform.webDesktop.hint': '브라우저 우선 제품 또는 랜딩 페이지',
  'newproj.platform.mobileIos.label': 'iOS 앱',
  'newproj.platform.mobileIos.hint': 'iPhone 프레임 및 iOS 인터랙션 규칙',
  'newproj.platform.mobileAndroid.label': 'Android 앱',
  'newproj.platform.mobileAndroid.hint': 'Pixel 프레임 및 Material 인터랙션 규칙',
  'newproj.platform.tablet.label': '태블릿 앱',
  'newproj.platform.tablet.hint': '분할 보기를 갖춘 네이티브 스타일 태블릿 경험',
  'newproj.platform.desktopApp.label': '데스크톱 앱',
  'newproj.platform.desktopApp.hint': 'macOS/Windows 앱 크롬',
  'newproj.surfaceOptionsLabel': '보조 화면',
  'newproj.includeLandingPage': '랜딩 페이지 포함',
  'newproj.includeLandingPageHint': '광고, 대기자 명단, 출시 캠페인, 앱 다운로드 또는 제품 설명을 위한 반응형 마케팅 페이지를 추가하세요.',
  'newproj.includeOsWidgets': 'OS 위젯 포함',
  'newproj.includeOsWidgetsHint': '모바일/태블릿 앱을 위한 플랫폼 네이티브 홈 화면, 잠금 화면 또는 빠른 액세스 위젯을 추가하세요.',
  'newproj.includeOsWidgetsDisabledHint': 'iOS, Android 또는 태블릿 앱이 대상 플랫폼으로 선택된 경우 사용할 수 있습니다.',
  'newproj.templateLabel': '템플릿',
  'newproj.noTemplatesTitle': '아직 템플릿이 없습니다',
  'newproj.noTemplatesBody': '프로젝트를 열고 파일 뷰어 안의 공유(Share) 메뉴를 사용하여 템플릿으로 변환하세요. 생성된 템플릿이 여기에 표시됩니다.',
  'newproj.savedTemplate': '저장된 템플릿',
  'newproj.fileSingular': '파일',
  'newproj.filePlural': '파일들',
  'newproj.create': '생성',
  'newproj.locationLabel': '저장 위치',
  'newproj.locationDefault': 'Open Design 프로젝트',
  'newproj.locationExternalBase': '외부 베이스',
  'newproj.createLiveArtifact': '라이브 아티팩트 만들기',
  'newproj.createFromTemplate': '템플릿으로 생성',
  'newproj.createDisabledTitle': '먼저 프로젝트를 템플릿으로 저장하세요 (프로젝트 내 공유 메뉴 이용).',
  'newproj.importClaudeZip': 'Claude Design ZIP 가져오기',
  'newproj.importClaudeZipTitle': 'Claude Design .zip 내보내기 파일 가져오기',
  'newproj.importingClaudeZip': '가져오는 중…',
  'newproj.privacyFooter': '기본적으로 프로젝트는 나만 볼 수 있습니다.',
  'newproj.designSystem': '디자인 시스템',
  'newproj.dsNoneFreeform': '없음 — 자유 양식',
  'newproj.dsNoneSubtitleEmpty': '시스템 토큰 없이 자체 팔레트를 선택합니다.',
  'newproj.dsNoneSubtitleSelected': '시스템 토큰을 건너뜁니다. 에이전트가 팔레트를 알아서 선택합니다.',
  'newproj.dsCategoryFallback': '디자인 시스템',
  'newproj.dsSearch': '디자인 시스템 검색…',
  'newproj.dsModeAria': '선택 모드',
  'newproj.dsModeSingle': '단일',
  'newproj.dsModeMulti': '다중',
  'newproj.dsNoneTitle': '없음 — 자유 양식',
  'newproj.dsNoneSub': '시스템 토큰을 건너뜁니다. 에이전트가 팔레트를 알아서 선택합니다.',
  'newproj.dsEmpty': '“{query}”와(과) 일치하는 디자인 시스템이 없습니다.',
  'newproj.dsFootSingular': '은(는) 참고용입니다.',
  'newproj.dsFootPlural': '은(는) 참고용입니다.',
  'newproj.dsFootClear': '지우기',
  'newproj.dsBadgeDefault': '기본 (DEFAULT)',
  'newproj.dsPrimaryFallback': '기본색 (Primary)',
  'newproj.surfaceImage': '이미지',
  'newproj.surfaceVideo': '비디오',
  'newproj.surfaceAudio': '오디오',
  'newproj.modelLabel': '모델',
  'newproj.modelSearch': '모델 검색…',
  'newproj.modelEmpty': '일치하는 모델이 없습니다.',
  'newproj.modelRecommended': '추천',
  'newproj.modelMissingTitle': '모델 선택',
  'newproj.modelMissingSub': '이 화면에 사용할 모델을 선택하세요.',
  'newproj.aspectLabel': '비율 (Aspect)',
  'newproj.videoLengthLabel': '길이',
  'newproj.videoLengthSeconds': '{n}초',
  'newproj.audioKindLabel': '오디오 유형',
  'newproj.audioKindMusic': '음악',
  'newproj.audioKindSpeech': '음성 / TTS',
  'newproj.audioKindSfx': '효과음 (SFX)',
  'newproj.audioDurationLabel': '길이',
  'newproj.audioDurationSeconds': '{n}초',
  'newproj.voiceLabel': '목소리',
  'newproj.voicePlaceholder': '프로바이더 보이스 ID (선택 사항)',
  'newproj.connectorsLabel': '커넥터',
  'newproj.connectorsHint': '이 아티팩트가 가져올 수 있는 데이터 소스입니다.',
  'newproj.connectorsEmptyTitle': '설정된 커넥터가 없습니다',
  'newproj.connectorsEmptyBody': '데이터 소스를 연결해 라이브 아티팩트가 자리표시자 대신 실제 데이터를 사용하도록 하세요.',
  'newproj.connectorsEmptyCta': '커넥터 설정 →',
  'newproj.connectorsLoading': '커넥터 불러오는 중…',
  'newproj.connectorsCountOne': '{n}개 연결됨',
  'newproj.connectorsCountMany': '{n}개 연결됨',
  'newproj.connectorsManage': '관리',
  'newproj.promptTemplateLabel': '참조 템플릿',
  'newproj.promptTemplateNoneTitle': '없음 — 직접 작성',
  'newproj.promptTemplateNoneSub': '갤러리를 건너뛰고 직접 브리프를 작성합니다.',
  'newproj.promptTemplateRefSub': '참조 템플릿',
  'newproj.promptTemplateSearch': '템플릿 검색…',
  'newproj.promptTemplateEmpty': '이 유형에 설치된 템플릿이 없습니다.',
  'newproj.promptTemplateBodyLabel': '프롬프트 (수정 가능)',
  'newproj.promptTemplateOptimizeHint': '내용을 수정할 수 있습니다. 변경된 내용은 에이전트의 브리프에 반영됩니다.',
  'newproj.promptTemplateBodyEmpty': '본문이 비어있습니다 — 에이전트에게 전달될 템플릿 참조가 없습니다.',
  'newproj.deleteTemplateTitle': '템플릿 삭제',
  'newproj.deleteTemplateConfirm': '"{name}" 템플릿을 삭제하시겠습니까? 이 작업은 취소할 수 없습니다.',
  'newproj.deleteTemplateConfirmCta': '템플릿 삭제',
  'newproj.deleteTemplateError': '템플릿을 삭제할 수 없습니다. 다시 시도해 주세요.',
  'designs.subRecent': '최근 항목',
  'designs.subYours': '내 디자인',
  'designs.filterAria': '프로젝트 필터링',
  'designs.searchPlaceholder': '검색…',
  'designs.emptyNoProjects': '아직 프로젝트가 없습니다.',
  'designs.emptyNoMatch': '검색어와 일치하는 프로젝트가 없습니다.',
  'designs.deleteTitle': '프로젝트 삭제',
  'designs.deleteConfirm': '"{name}" 프로젝트를 삭제하시겠습니까?',
  'designs.cardFreeform': '자유 양식',
  'designs.badgeLive': '라이브',
  'designs.liveArtifactBadgesAria': '라이브 아티팩트 배지',
  'designs.liveCount': '{n}개 라이브',
  'designs.statusLive': '라이브 아티팩트',
  'designs.statusArchived': '보관됨',
  'designs.statusError': '오류',
  'designs.statusRefreshing': '새로고침 중…',
  'designs.statusRefreshFailed': '새로 고침 실패',
  'designs.statusRefreshed': '새로 고침됨',
  'designs.status.notStarted': '시작되지 않음',
  'designs.status.queued': '대기 중',
  'designs.status.running': '실행 중',
  'designs.status.awaitingInput': '입력 대기 중',
  'designs.status.succeeded': '완료됨',
  'designs.status.published': '게시됨',
  'designs.status.failed': '실패',
  'designs.status.canceled': '취소됨',
  'designs.viewToggleAria': '보기 모드',
  'designs.viewGrid': '그리드 보기',
  'designs.viewKanban': '보드 보기',
  'designs.kanbanEmptyColumn': '디자인 없음',
  'designs.deleteAria': '프로젝트 삭제 {name}',
  'designs.menuMore': '추가 작업',
  'designs.menuRename': '이름 바꾸기',
  'designs.menuDuplicate': 'Duplicate project',
  'designs.menuDelete': '삭제',
  'designs.renamePrompt': '"{name}"의 새 이름',
  'designs.selectMode': '선택',
  'designs.cancelSelect': '취소',
  'designs.deleteSelected': '선택 항목 삭제',
  'designs.selectedCount': '{n}개 선택됨',
  'designs.deleteSelectedConfirm': '프로젝트 {n}개를 삭제할까요?',
  'designs.deleteSelectedSuccess': '프로젝트 {n}개를 삭제했습니다.',
  'designs.deleteSelectedPartial': '프로젝트 {deleted}개를 삭제했으며, {failed}개는 실패했습니다.',
  'designs.tagPrototype': '프로토타입',
  'designs.tagLiveArtifact': '라이브 아티팩트',
  'designs.tagSlide': '슬라이드',
  'designs.tagMedia': '미디어',
  'designs.renameTitle': '프로젝트 이름 바꾸기',
  'designs.renameSave': 'OK',
  'designs.renameCancel': '취소',
  'examples.typeLabel': '유형',
  'examples.surfaceLabel': '대상 표면 (Surface)',
  'examples.surfaceWeb': '웹',
  'examples.surfaceImage': '이미지',
  'examples.surfaceVideo': '비디오',
  'examples.surfaceAudio': '오디오',
  'examples.scenarioLabel': '시나리오',
  'examples.modeAll': '전체',
  'examples.modePrototypeDesktop': '프로토타입 · 데스크탑',
  'examples.modePrototypeMobile': '프로토타입 · 모바일',
  'examples.modeDeck': '슬라이드',
  'examples.modeDocument': '문서 및 템플릿',
  'examples.modeOrbit': 'Orbit',
  'examples.modeLive': '라이브',
  'examples.scenarioGeneral': '일반',
  'examples.scenarioEngineering': '엔지니어링',
  'examples.scenarioProduct': '제품',
  'examples.scenarioDesign': '디자인',
  'examples.scenarioMarketing': '마케팅',
  'examples.scenarioSales': '영업',
  'examples.scenarioFinance': '재무',
  'examples.scenarioHr': '인사 (HR)',
  'examples.scenarioOperations': '운영',
  'examples.scenarioSupport': '고객 지원',
  'examples.scenarioLegal': '법무',
  'examples.scenarioEducation': '교육',
  'examples.scenarioPersonal': '개인',
  'examples.searchPlaceholder': '예제 검색…',
  'examples.searchAria': '이름으로 예제 검색',
  'examples.emptyNoSkills': '사용 가능한 스킬이 없습니다. 데몬이 실행 중인지 확인하세요.',
  'examples.emptyNoMatch': '필터와 일치하는 예제가 없습니다.',
  'examples.openPreview': '⤢ 미리보기 열기',
  'examples.loadingPreview': '미리보기 불러오는 중…',
  'examples.hoverPreview': '마우스를 올려 미리보기',
  'examples.usePrompt': '이 프롬프트 사용하기',
  'examples.previewModalTitle': '전체 미리보기 열기 (모달)',
  'examples.shareTitle': '이 예제 공유하기',
  'examples.shareLoadFirst': '마우스를 올려 미리보기를 먼저 로드하세요',
  'examples.unavailablePlaceholder': '함께 제공된 {kind} 미리보기 없음 — 자세히 보려면 열기',
  'examples.shareUnavailable': '공유할 {kind} 미리보기가 함께 제공되지 않음',
  'examples.shareMenu': '공유 ▾',
  'examples.exportPdfAllSlides': 'PDF로 내보내기 (모든 슬라이드)',
  'examples.exportPptxLocked': 'PPTX로 내보내기… (템플릿을 먼저 여세요)',
  'examples.tagSlideDeck': '슬라이드 덱',
  'examples.tagTemplate': '템플릿',
  'examples.tagDesignSystem': '디자인 시스템',
  'examples.tagMobilePrototype': '모바일 프로토타입',
  'examples.tagDesktopPrototype': '데스크탑 프로토타입',
  'examples.tagImage': '이미지',
  'examples.tagVideo': '비디오',
  'examples.tagAudio': '오디오',
  'examples.previewLabel': '미리보기',
  'ds.surfaceLabel': '대상 표면 (Surface)',
  'ds.surfaceWeb': '웹',
  'ds.surfaceImage': '이미지',
  'ds.surfaceVideo': '비디오',
  'ds.surfaceAudio': '오디오',
  'ds.searchPlaceholder': '디자인 시스템 검색…',
  'ds.emptyNoMatch': '검색어와 일치하는 디자인 시스템이 없습니다.',
  'ds.badgeDefault': '기본 (DEFAULT)',
  'ds.preview': '미리보기',
  'ds.previewTitle': '디자인 시스템 미리보기',
  'ds.categoryAll': '전체',
  'ds.categoryUncategorized': '미분류',
  'ds.showcase': '쇼케이스',
  'ds.tokens': '토큰',
  'ds.specToggle': 'DESIGN.md',
  'ds.specLoading': 'DESIGN.md 불러오는 중…',
  'avatar.title': '계정 및 설정',
  'avatar.localCli': '로컬 CLI',
  'avatar.anthropicApi': 'Anthropic API',
  'avatar.useLocal': '로컬 CLI 사용',
  'avatar.useApi': 'API · BYOK 사용',
  'avatar.codeAgent': '코드 에이전트',
  'avatar.rescan': 'PATH 다시 스캔',
  'avatar.amrConsole': 'Open Design Cloud 계정',
  'avatar.amrConsoleMeta': '잔액 및 충전',
  'avatar.settings': '설정',
  'avatar.backToProjects': '프로젝트 목록으로 돌아가기',
  'avatar.metaActive': '활성',
  'avatar.metaOffline': '오프라인',
  'avatar.metaSelected': '선택됨',
  'avatar.noAgentSelected': '선택된 에이전트 없음',
  'avatar.modelSection': '모델',
  'avatar.modelLabel': '모델',
  'avatar.reasoningLabel': '추론 (Reasoning)',
  'avatar.customSuffix': '(직접 입력)',
  'socialShare.openDesignSection': 'Open Design 공유',
  'socialShare.openDesignTitle': 'GitHub의 Open Design',
  'socialShare.openDesignText': 'Open Design은 디자인 아티팩트를 생성, 편집, 배포 및 인수인계하기 위한 오픈소스 워크스페이스입니다.',
  'socialShare.openDesignCopyText': '{text}\n{url}',
  'socialShare.projectSection': '소셜 공유',
  'socialShare.publishPageTitle': '공유 페이지 게시',
  'socialShare.publishPageSubtitle': '소셜 플랫폼에 공유할 수 있도록 이 미리보기를 게시합니다.',
  'socialShare.projectTitle': '{title} · Open Design',
  'socialShare.projectText': 'Open Design으로 제작: {title}. 배포된 아티팩트를 확인하고 저장소에 스타를 남겨주세요: {repo}',
  'socialShare.projectCopyText': 'Open Design으로 제작: {title}\n{url}\nOpen Design 저장소: {repo}',
  'socialShare.deployFirst': '배포 후 공유…',
  'socialShare.copied': '복사됨',
  'socialShare.platform.x': 'X',
  'socialShare.platform.linkedin': 'LinkedIn',
  'socialShare.platform.facebook': 'Facebook',
  'socialShare.platform.reddit': 'Reddit',
  'socialShare.platform.telegram': 'Telegram',
  'socialShare.platform.whatsapp': 'WhatsApp',
  'socialShare.platform.weibo': 'Weibo',
  'socialShare.platform.line': 'LINE',
  'socialShare.platform.instagram': 'Instagram',
  'socialShare.platform.xiaohongshu': '샤오훙수',
  'inlineSwitcher.chipTitle': 'CLI / 모델 전환',
  'inlineSwitcher.chipCli': '로컬 CLI',
  'inlineSwitcher.chipByok': 'BYOK',
  'inlineSwitcher.modelDefault': '기본값',
  'inlineSwitcher.noAgent': '에이전트 없음',
  'inlineSwitcher.modeLabel': '모드',
  'inlineSwitcher.agentLabel': '에이전트',
  'inlineSwitcher.providerLabel': '제공자',
  'inlineSwitcher.modelLabel': '모델',
  'inlineSwitcher.useCli': '로컬 CLI 사용',
  'inlineSwitcher.useByok': '자체 API 키 사용',
  'inlineSwitcher.daemonOffline': '데몬 오프라인 — 설정 열기',
  'inlineSwitcher.noAgentsDetected': 'PATH에서 CLI를 찾을 수 없습니다',
  'inlineSwitcher.openSettingsForModel': '설정에서 제공자를 구성하세요',
  'inlineSwitcher.missingApiKey': 'API 키 미설정 — 설정에서 추가하세요.',
  'inlineSwitcher.openFullSettings': '실행 설정 열기',
  'inlineSwitcher.customSuffix': '(직접 입력)',
  'project.backToProjects': '프로젝트 목록으로 돌아가기',
  'project.brandReadyTitle': '{name} 디자인 시스템이 준비되었습니다',
  'project.brandReadyTitleGeneric': '디자인 시스템이 준비되었습니다',
  'project.brandReadyCta': '디자인 시스템에서 미리보기',
  'project.brandReadyDismiss': '닫기',
  'project.brandReadyRefineHint': 'Automatic extraction can miss details. Refine it before using this system broadly.',
  'project.brandReadyAiOptimize': 'AI Optimize',
  'project.brandReadyEditManually': 'Edit manually',
  'project.brandReadyPreviewOpened': '디자인 시스템 미리보기를 열었습니다.',
  'project.metaFreeform': '자유 양식',
  'project.typePrototype': '프로토타입',
  'project.typeDeck': '슬라이드',
  'project.typeTemplate': '템플릿',
  'project.typeImage': '이미지',
  'project.typeVideo': '비디오',
  'project.typeAudio': '오디오',
  'project.customInstructions': '프로젝트 지침',
  'project.customInstructionsPlaceholder': '이 프로젝트에 대한 지침(모든 메시지에 주입됨)…',
  'project.resizeChatPanel': '채팅 패널 크기 조절',
  'project.instructionsActive': '활성 — 모든 메시지에 포함됨',
  'project.missing': 'This project has been deleted or no longer exists.',
  'chat.tabChat': '채팅',
  'chat.tabComments': '댓글',
  'chat.commentsSoon': '댓글 — 곧 지원될 예정입니다.',
  'chat.comments.attached': '채팅에 첨부됨',
  'chat.comments.emptyAttached': '첨부된 댓글이 없습니다.',
  'chat.comments.saved': '저장된 댓글',
  'chat.comments.emptySaved': '저장된 댓글이 없습니다.',
  'chat.comments.add': '추가',
  'chat.comments.addAll': '모두 추가',
  'chat.comments.remove': '제거',
  'chat.comments.placeholder': '이 요소에 댓글 달기…',
  'chat.comments.addSend': '추가 후 전송',
  'chat.comments.updateSend': '업데이트 후 전송',
  'chat.comments.removeAttachment': '댓글 첨부 제거',
  'chat.comments.removeAttachmentAria': '{name}의 댓글 첨부 제거',
  'chat.comments.comment': '댓글',
  'chat.comments.sendToChat': '채팅으로 보내기',
  'chat.comments.sending': '전송 중…',
  'chat.comments.edit': '편집',
  'chat.comments.select': '선택',
  'chat.comments.selectAll': '모두 선택',
  'chat.comments.deselect': '선택 해제',
  'chat.comments.nSelected': '{n}개 선택됨',
  'chat.comments.pin': '고정',
  'chat.comments.addNote': '메모 추가',
  'chat.comments.savedToast': '댓글 저장됨',
  'chat.comments.pinSavedToast': '고정됨',
  'chat.comments.pinAtCoords': 'at {x}, {y}',
  'chat.comments.capturedItems': '캡처된 항목 {n}개',
  'chat.comments.clear': '지우기',
  'chat.comments.targetImage': '이미지',
  'chat.comments.targetControl': '컨트롤',
  'chat.comments.targetLink': '링크',
  'chat.comments.targetText': '텍스트',
  'chat.comments.targetSection': '섹션',
  'chat.comments.targetPage': '페이지',
  'chat.comments.targetArea': '영역',
  'chat.annotationNotePlaceholder': '이 마크에 메모 추가',
  'chat.annotationAttachImage': '이미지 첨부',
  'chat.annotationAttachedImages': '첨부된 이미지',
  'chat.annotationAttachedRemove': '마지막 이미지 제거',
  'chat.annotationAddToInput': '입력란에 추가',
  'chat.annotationAddingToInput': '추가 중...',
  'chat.annotationQueue': '대기열',
  'chat.annotationQueueing': '대기열에 추가 중...',
  'chat.annotationSubmitOptions': '제출 옵션',
  'chat.annotationSending': '전송 중...',
  'chat.annotationSendDisabledReason': '현재 작업이 실행 중입니다',
  'chat.annotationPreviewMissing': '미리보기를 캡처할 수 없습니다. 다시 시도해 주세요.',
  'chat.annotationPreviewMissingInk': '미리보기를 캡처할 수 없습니다. 잉크만 전송되지 않도록 다시 시도해 주세요.',
  'chat.annotationSentWithoutScreenshot': '미리보기를 캡처하지 못했습니다. 주석은 스크린샷 없이 전송되었습니다.',
  'chat.annotationTimeout': '주석 전송 시간이 초과되었습니다. 다시 시도해 주세요.',
  'chat.annotationFailed': '주석 전송에 실패했습니다. 다시 시도해 주세요.',
  'chat.annotationProjectCreateFailed': '프로젝트를 생성할 수 없어 주석이 전송되지 않았습니다.',
  'chat.annotationUploadFailed': '첨부 파일 업로드에 실패했습니다. 다시 시도해 주세요.',
  'chat.conversationsTitle': '대화 목록',
  'chat.conversationsAria': '대화 내역',
  'chat.newConversation': '새 대화 시작',
  'chat.newConversationsTitle': '새 대화',
  'chat.conversationsHeading': '대화 목록',
  'chat.new': '새로 만들기',
  'chat.emptyConversations': '아직 대화가 없습니다.',
  'chat.deleteConversation': '대화 삭제',
  'chat.renameConversationLabel': '"{title}" 이름 변경',
  'chat.deleteConversationConfirm': '"{title}" 대화를 삭제하시겠습니까? 관련 메시지가 모두 삭제됩니다.',
  'chat.untitledConversation': '제목 없는 대화',
  'chat.forkedConversationTitle': '{title} 포크',
  'chat.forkConversationFailed': '이 대화를 포크할 수 없습니다.',
  'chat.startTitle': '대화 시작하기',
  'chat.startHint': '생성하고 싶은 내용을 설명하거나 아래 예시에서 시작하세요:',
  'chat.brandBrowserAssistDesktopOnly': 'Browser assist needs the desktop app so Open Design can read the live browser page.',
  'chat.brandBrowserAssistReadFailed': 'Could not read the browser page. Make sure the brand site is open and fully loaded.',
  'chat.brandBrowserAssistMessage': 'Open Design needs browser assist to finish this brand extraction. Use the card below to open Browser, then click More, choose Download Page, wait for the success message, and use the left Next Step card to continue extraction.',
  'chat.brandBrowserLocalSnapshotMissing': 'No saved page snapshot is available for this URL.',
  'chat.brandBrowserLocalSnapshotReadFailed': 'Could not read the saved page snapshot.',
  'chat.brandBrowserSnapshotSaveFailed': 'Could not save a page snapshot from the browser.',
  'chat.brandBrowserAssistDownloadGuideTitle': 'Browser opened',
  'chat.brandBrowserAssistDownloadGuideDetails': 'Step 1: Browser is open. Step 2: click More, then Download Page. Step 3: wait for the saved snapshot success message. Step 4: return to the left Next Step card and click Continue extraction to continue the programmatic extraction.',
  'brandEnrichment.title': "AI 최적화",
  'brandEnrichment.body': "Open Design이 백그라운드에서 더 깊은 추출을 실행하고 적절한 디자인 시스템 skills를 자동으로 적용해 이 시스템을 제자리에서 업데이트합니다. 10-20분 정도 걸릴 수 있으며, 계속 작업할 수 있습니다.",
  'brandEnrichment.cta': "AI 최적화",
  'brandEnrichment.busy': "AI 최적화 시작 중...",
  'brandExtractionTranscript.sourceDesignMd': '붙여 넣은 DESIGN.md',
  'brandExtractionTranscript.user': '{source}에서 디자인 시스템을 추출합니다.',
  'brandExtractionTranscript.doneTitle': '{name}의 프로그램 추출이 완료되었습니다.',
  'brandExtractionTranscript.doneBody': '{source}에서 {designSystemId} 디자인 시스템을 만들고 등록했습니다. 이제 미리 볼 수 있고 새 디자인에 사용할 수 있습니다.',
  'brandExtractionTranscript.next': '다음으로 AI Optimize를 실행해 더 깊게 추출하거나, 이 시스템으로 새 디자인을 만들 수 있습니다.',
  'chat.fillInputTitle': '클릭하여 입력창에 채우기',
  'chat.jumpToLatest': '최신 내용으로 이동',
  'chat.scrollToLatest': '최신 내용으로 스크롤',
  'chat.you': '나',
  'chat.openFile': '{name} 열기',
  'chat.copyPrompt': '프롬프트 복사',
  'chat.copyErrorDiagnostic': '오류 진단 복사',
  'chat.copyDone': '복사됨!',
  'chat.inspect.noEditableTargets': '편집 가능한 텍스트 또는 스타일 대상을 찾을 수 없습니다.',
  'chat.inspect.noCommentTargets': '댓글을 달 수 있는 텍스트 또는 시각적 대상을 찾을 수 없습니다.',
  'chat.inspect.editHint': '편집하려면 미리 보기에서 텍스트 또는 스타일 대상을 선택하세요.',
  'chat.inspect.commentHint': '댓글을 달려면 미리 보기에서 텍스트 또는 영역을 선택하세요.',
  'chat.composerPlaceholder': '생성하고 싶은 내용을 설명하세요…',
  'chat.activeFileEditingLabel': '편집 중',
  'chat.activeFilePlaceholder': 'Open Design에 {file} 변경 요청...',
  'chat.designArtifactsShowMore': '디자인 파일 {count}개 더 보기',
  'chat.mode.chat.label': '질문',
  'chat.mode.chat.title': 'Ask 모드',
  'chat.mode.chat.summary': '디자인 산출물 생성을 전제로 하지 않고 빠른 답변, 수정, 계획, 토론에 사용합니다.',
  'chat.mode.chat.solves': '아이디어 정리, 프롬프트 개선, 옵션 비교, 기존 작업에 대한 질문에 적합합니다.',
  'chat.mode.chat.query1': '이 초안을 요약하고 부족한 점을 짚어줘.',
  'chat.mode.chat.query2': '이 랜딩 페이지에 가장 좋은 구조를 정하는 것을 도와줘.',
  'chat.mode.chat.query3': '이 디자인을 검토하고 구체적인 개선안을 제안해줘.',
  'chat.mode.plan.label': "Plan",
  'chat.mode.plan.title': "Plan mode",
  'chat.mode.plan.summary': "Creates an editable plan document first, then hands off to Design after you review it.",
  'chat.mode.plan.solves': "Use it for PRDs, slide outlines, prototype briefs, wireframes, storyboards, and any broad request that needs confirmation before generation.",
  'chat.mode.plan.query1': "Create a slide-by-slide PPT outline first.",
  'chat.mode.plan.query2': "Draft a PRD before generating the prototype.",
  'chat.mode.plan.query3': "Turn this idea into an editable design plan.",
  'chat.mode.design.label': '디자인',
  'chat.mode.design.title': 'Design 모드',
  'chat.mode.design.summary': '페이지, 프로토타입, 라이브 아티팩트, 슬라이드, 이미지, 비디오, HyperFrames, 오디오, 대시보드, 프로젝트 파일 같은 구체적인 결과물을 만들거나 변경합니다.',
  'chat.mode.design.solves': 'Open Design이 파일을 생성하고 workspace를 업데이트하거나 brief를 멀티모달 deliverable로 바꿔야 할 때 사용합니다.',
  'chat.mode.design.query1': '이 brief로 제품 출시 랜딩 페이지와 HyperFrames 프로토타입을 만들어줘.',
  'chat.mode.design.query2': '발표자 노트가 있는 10장짜리 투자자 덱을 만들어줘.',
  'chat.mode.design.query3': '이 캠페인을 위한 이미지, 비디오, 오디오 콘셉트를 생성해줘.',
  'chat.mode.cardBestFor': '적합한 작업',
  'chat.mode.cardTry': '이렇게 물어보세요',
  'chat.mode.cardCost': '예상 사용량',
  'chat.mode.chat.cost': '낮음',
  'chat.mode.chat.costNote': '대화만 하고 아무것도 생성하지 않으므로 사용량이 가장 적습니다.',
  'chat.mode.plan.cost': '표준',
  'chat.mode.plan.costNote': '생성에 앞서 편집 가능한 계획 문서를 먼저 만듭니다.',
  'chat.mode.design.cost': '높음',
  'chat.mode.design.costNote': '파일과 멀티모달 결과물을 생성하므로 한 번 실행에 사용량이 가장 많을 수 있습니다.',
  'chat.composerHint': '⌘/Ctrl + Enter로 보내기 · 목표, 내용, 스타일, 형식을 포함하세요',
  'chat.cliSettingsTitle': 'CLI 및 모델 설정',
  'chat.cliSettingsAria': 'CLI 및 모델 설정 열기',
  'chat.attachTitle': '파일 첨부 (또는 붙여넣기 / 끌어놓기)',
  'chat.addContextTitle': 'Add context',
  'chat.attachAria': '파일 첨부',
  'chat.importTitle': '소스 가져오기 (곧 지원 예정)',
  'chat.importLabel': '가져오기',
  'chat.importComingSoon': '곧 지원될 예정입니다',
  'chat.importSoon': '예정',
  'chat.importFig': '.fig 파일 업로드',
  'chat.importGitHub': 'GitHub 연결',
  'chat.importWeb': '웹 요소 가져오기',
  'chat.importFolder': '코드 폴더 연결',
  'chat.importSkills': '스킬 및 디자인 시스템',
  'chat.importProject': '다른 프로젝트 참조',
  'chat.importDesignSystemHeader': '디자인 시스템 선택',
  'chat.importDesignSystemBack': '뒤로',
  'chat.importDesignSystemSearch': '디자인 시스템 검색…',
  'chat.importDesignSystemEmpty': '"{query}"와 일치하는 디자인 시스템이 없습니다',
  'chat.importDesignSystemNone': '없음 — 자유 형식',
  'chat.importDesignSystemNoneSub': '이번 턴은 어떤 시스템도 고정하지 않습니다',
  'chat.importDesignSystemActive': '현재',
  'chat.importDesignSystemSwitched': '디자인 시스템을 {title}(으)로 전환했습니다',
  'chat.importDesignSystemFailed': '디자인 시스템을 전환할 수 없습니다. 다시 시도해주세요.',
  'chat.importDesignSystemLoadFailed': '디자인 시스템을 불러올 수 없습니다.',
  'browserUse.title': '영감',
  'browserUse.summary': '{count}개의 웹 작업으로, 에셋 추출, 디자인 언어, 모션, 시각적 검사, 컴포넌트 구조를 우선합니다.',
  'browserUse.searchAria': '영감 검색',
  'browserUse.searchPlaceholder': '스크린샷, 글꼴, 색상, 접근성 검색...',
  'browserUse.empty': '일치하는 영감 없음',
  'browserUse.unavailable': '여기서는 영감을 사용할 수 없습니다',
  'browserUse.added': '작성기에 추가됨',
  // Design Browser
  'designBrowser.aria': 'Design Browser',
  'designBrowser.goBack': 'Go Back',
  'designBrowser.goForward': 'Go Forward',
  'designBrowser.reload': 'Reload',

  'designBrowser.stopLoading': '로딩 중지',
  'designBrowser.viewportAria': 'Browser viewport',
  'designBrowser.addressPlaceholder': 'Enter URL or search...',
  'designBrowser.addressAria': 'Browser address',
  'designBrowser.suggestion.reference': 'Reference',
  'designBrowser.suggestion.history': 'History',
  'designBrowser.menu.copyScreenshot': 'Copy Screenshot',
  'designBrowser.menu.hardReload': 'Hard Reload',
  'designBrowser.menu.copyUrl': 'Copy URL',
  'designBrowser.menu.openInBrowser': 'Open in Browser',
  'designBrowser.menu.savePageBrief': 'Save Page Brief',
  'designBrowser.menu.clearBrowsingHistory': 'Clear Browsing History',
  'designBrowser.menu.clearCookies': 'Clear Cookies',
  'designBrowser.menu.clearAllData': 'Clear All Data',
  'designBrowser.status.openHttpUrlFirst': 'Open an http URL first',
  'designBrowser.status.openPageBeforeScreenshot': 'Open a page before taking a screenshot',
  'designBrowser.status.screenshotCopied': 'Screenshot copied to clipboard',
  'designBrowser.status.openPageBeforeBrief': 'Open a page before saving a brief',
  'designBrowser.status.openPageBeforeTools': 'Open a page before using browser tools',
  'designBrowser.status.clickElementToComment': 'Click an element to comment',
  'designBrowser.status.clickElementToTune': 'Click an element to tune',
  'designBrowser.status.noElementSelected': 'No browser element selected',
  'designBrowser.status.addBrowserComment': 'Add a browser comment',
  'designBrowser.status.tuneElementThenSaveHtml': 'Tune the element, then save HTML',
  'designBrowser.status.tuneLiveOnly': 'Tune is live only for non-project pages',
  'designBrowser.status.pickerFailed': 'Browser element picker failed',
  'designBrowser.status.applyStyleFailed': 'Could not apply style in browser page',
  'designBrowser.status.editTextFailed': 'Could not edit text in browser page',
  'designBrowser.status.onlyProjectHtmlCanSave': 'Only project-local HTML pages can be saved',
  'designBrowser.status.htmlSaved': 'HTML changes saved',
  'designBrowser.status.htmlSaveFailed': 'HTML save failed',
  'designBrowser.status.commentSavingUnavailable': 'Comment saving is unavailable',
  'designBrowser.status.commentSaved': 'Browser comment saved',
  'designBrowser.status.commentSendingUnavailable': 'Comment sending is unavailable',
  'designBrowser.comments.aria': 'Browser comments',
  'designBrowser.comments.openFor': 'Open browser comment for {label}',
  'designBrowser.comment.dialog': 'Browser comment',
  'designBrowser.comment.elementFallback': 'Browser element',
  'designBrowser.comment.close': 'Close browser comment',
  'designBrowser.comment.noteAria': 'Browser comment note',
  'designBrowser.comment.placeholder': 'Describe the change or issue...',
  'designBrowser.comment.addNote': 'Add note',
  'designBrowser.comment.saveComment': 'Save comment',
  'designBrowser.comment.sending': 'Sending...',
  'designBrowser.comment.sendToChat': 'Send to chat',
  'designBrowser.inspect.editTitle': 'Edit HTML element',
  'designBrowser.inspect.tuneTitle': 'Tune browser element',
  'designBrowser.inspect.closeTune': 'Close browser tune',
  'designBrowser.inspect.colors': 'Colors',
  'designBrowser.inspect.text': 'Text',
  'designBrowser.inspect.fill': 'Fill',
  'designBrowser.inspect.type': 'Type',
  'designBrowser.inspect.size': 'Size',
  'designBrowser.inspect.weight': 'Weight',
  'designBrowser.inspect.spacing': 'Spacing',
  'designBrowser.inspect.pad': 'Pad',
  'designBrowser.inspect.radius': 'Radius',
  'designBrowser.inspect.content': 'Content',
  'designBrowser.inspect.elementText': 'Element text',
  'designBrowser.inspect.saving': 'Saving...',
  'designBrowser.inspect.saveHtml': 'Save HTML',
  'designBrowser.inspect.liveOnly': 'Live only',
  'designBrowser.reference.kicker': 'Open Design browser',
  'designBrowser.reference.title': 'Reference Board',
  'designBrowser.reference.subtitle': 'A curated set of references across inspiration, real product UI, motion, color, type, assets, and design systems. Open one to browse it live while gathering design language for the next artifact.',
  'designBrowser.reference.categoryAria': 'Reference category',
  'designBrowser.reference.searchPlaceholder': 'Search references...',
  'designBrowser.reference.searchAria': 'Search references',
  'designBrowser.reference.clearSearch': 'Clear search',
  'designBrowser.reference.noMatches': 'No references match “{query}”.',
  'designBrowser.reference.clearFilters': 'Clear filters',
  'designBrowser.reference.open': 'Open',
  'designBrowser.reference.group.inspiration': 'Inspiration',
  'designBrowser.reference.group.interfaces': 'Real Interfaces',
  'designBrowser.reference.group.motion': 'Motion',
  'designBrowser.reference.group.color': 'Color',
  'designBrowser.reference.group.type': 'Typography',
  'designBrowser.reference.group.icons': 'Icons',
  'designBrowser.reference.group.illustration': 'Illustration',
  'designBrowser.reference.group.photography': 'Photography',
  'designBrowser.reference.group.3d': '3D & Graphics',
  'designBrowser.reference.group.mockups': 'Mockups',
  'designBrowser.reference.group.systems': 'Design Systems',
  'designBrowser.reference.group.components': 'Components',
  'designBrowser.reference.group.guidelines': 'Guidelines & A11y',
  'designBrowser.reference.group.tools': 'Tools & Resources',
  'designBrowser.reference.site.dribbble.detail': 'Design shots and UI inspiration.',
  'designBrowser.reference.site.behance.detail': 'Creative portfolios and case studies.',
  'designBrowser.reference.site.awwwards.detail': 'Award-winning website design.',
  'designBrowser.reference.site.godly.detail': 'Curated modern web design.',
  'designBrowser.reference.site.land_book.detail': 'Landing page gallery and patterns.',
  'designBrowser.reference.site.mobbin.detail': 'Real app screens and UI patterns.',
  'designBrowser.reference.site.screenlane.detail': 'Latest UI design patterns from apps.',
  'designBrowser.reference.site.pageflows.detail': 'Real product user flows and onboarding.',
  'designBrowser.reference.site.uisources.detail': 'Interaction patterns from top apps.',
  'designBrowser.reference.site.collectui.detail': 'Daily UI collection by category.',
  'designBrowser.reference.site.gsap.detail': 'Production animation engine and examples.',
  'designBrowser.reference.site.animations.detail': 'Animation patterns and interaction examples.',
  'designBrowser.reference.site.transitions.detail': 'Transition patterns for modern interfaces.',
  'designBrowser.reference.site.motionsites.detail': 'High-end motion and interaction references.',
  'designBrowser.reference.site.motion.detail': 'Scroll and timeline animation inspiration.',
  'designBrowser.reference.site.animography.detail': 'Animated type and kinetic lettering.',
  'designBrowser.reference.site.reactbits.detail': 'React text animation reference for shiny kinetic type.',
  'designBrowser.reference.site.coolors.detail': 'Fast color palette generator.',
  'designBrowser.reference.site.colorhunt.detail': 'Curated color palettes.',
  'designBrowser.reference.site.realtimecolors.detail': 'Preview palettes on a real UI.',
  'designBrowser.reference.site.color_adobe.detail': 'Color wheel and harmony rules.',
  'designBrowser.reference.site.happyhues.detail': 'Palettes shown in real context.',
  'designBrowser.reference.site.fonts_google.detail': 'Open-source font library.',
  'designBrowser.reference.site.fontshare.detail': 'Quality fonts free for commercial use.',
  'designBrowser.reference.site.typewolf.detail': 'Fonts in use and pairing guidance.',
  'designBrowser.reference.site.fontpair.detail': 'Font pairing suggestions.',
  'designBrowser.reference.site.fontsinuse.detail': 'Typography in real-world design.',
  'designBrowser.reference.site.thesvg.detail': 'SVG assets and vector references.',
  'designBrowser.reference.site.svglogos.detail': 'Clean SVG logos for product and brand mocks.',
  'designBrowser.reference.site.icons_lobehub.detail': 'Product and AI-brand icons for interfaces.',
  'designBrowser.reference.site.icon_sets_iconify.detail': '200k+ open-source icons in one place.',
  'designBrowser.reference.site.lucide.detail': 'Clean, consistent open icon set.',
  'designBrowser.reference.site.heroicons.detail': 'Tailwind-made SVG icons.',
  'designBrowser.reference.site.svgrepo.detail': 'Free SVG vectors and icons.',
  'designBrowser.reference.site.storyset.detail': 'Customizable vector illustrations.',
  'designBrowser.reference.site.undraw.detail': 'Open-source MIT illustrations.',
  'designBrowser.reference.site.blush.detail': 'Mix-and-match illustrations.',
  'designBrowser.reference.site.lummi.detail': 'Free AI-generated visuals.',
  'designBrowser.reference.site.whirrls.detail': 'Hand-drawn image references.',
  'designBrowser.reference.site.worldindots.detail': 'Dot-map and data-viz references.',
  'designBrowser.reference.site.unsplash.detail': 'Free high-resolution photos.',
  'designBrowser.reference.site.pexels.detail': 'Free stock photos and video.',
  'designBrowser.reference.site.pixabay.detail': 'Royalty-free images and media.',
  'designBrowser.reference.site.cosmos.detail': 'Visual discovery and mood boards.',
  'designBrowser.reference.site.spline.detail': 'Browser-based 3D design.',
  'designBrowser.reference.site.threejs.detail': 'WebGL 3D references and demos.',
  'designBrowser.reference.site.womp.detail': 'Easy in-browser 3D creation.',
  'designBrowser.reference.site.pixcap.detail': '3D icons, mockups, and scenes.',
  'designBrowser.reference.site.shots.detail': 'Device and browser mockups.',
  'designBrowser.reference.site.mockuuups.detail': 'Drag-and-drop device mockups.',
  'designBrowser.reference.site.angle.detail': '3D device mockup library.',
  'designBrowser.reference.site.rotato.detail': 'Animated 3D product mockups.',
  'designBrowser.reference.site.impeccable.detail': 'High-quality style and interface references.',
  'designBrowser.reference.site.styles_refero.detail': 'Design style references and visual systems.',
  'designBrowser.reference.site.brandfetch.detail': 'Brand assets, logos, and identity.',
  'designBrowser.reference.site.designsystemsrepo.detail': 'Gallery of public design systems.',
  'designBrowser.reference.site.startups.detail': 'Top startup product and brand references.',
  'designBrowser.reference.site.base_ui.detail': 'Unstyled accessible primitives for custom systems.',
  'designBrowser.reference.site.ui_shadcn.detail': 'Composable React components built on Radix and Tailwind.',
  'designBrowser.reference.site.heroui.detail': 'Modern React component library and design system.',
  'designBrowser.reference.site.radix_ui.detail': 'Accessible low-level UI primitives.',
  'designBrowser.reference.site.react_spectrum_adobe.detail': 'Accessible behavior primitives from Adobe.',
  'designBrowser.reference.site.headlessui.detail': 'Unstyled accessible components for Tailwind projects.',
  'designBrowser.reference.site.mui.detail': 'Material-based React component ecosystem.',
  'designBrowser.reference.site.mantine.detail': 'Full-featured React components and hooks.',
  'designBrowser.reference.site.chakra_ui.detail': 'Accessible React components with theme tokens.',
  'designBrowser.reference.site.ant.detail': 'Enterprise component system and patterns.',
  'designBrowser.reference.site.ark_ui.detail': 'Headless components across modern frameworks.',
  'designBrowser.reference.site.daisyui.detail': 'Tailwind CSS component classes and themes.',
  'designBrowser.reference.site.developer_apple.detail': 'Apple platform design guidelines.',
  'designBrowser.reference.site.m3_material.detail': 'Google\'s Material Design 3.',
  'designBrowser.reference.site.lawsofux.detail': 'UX principles and heuristics.',
  'designBrowser.reference.site.webaim.detail': 'Color contrast checker.',
  'designBrowser.reference.site.a11yproject.detail': 'Accessibility checklist and patterns.',
  'designBrowser.reference.site.toolfolio.detail': 'Design tools, resources, and collections.',
  'designBrowser.reference.site.getdesign.detail': 'Curated design resources.',
  'designBrowser.reference.site.tasteskill.detail': 'Design taste training and critique references.',
  'designBrowser.reference.site.uigoodies.detail': 'Hand-picked design resources.',
  'designBrowser.reference.site.sidebar.detail': 'Five design links, every day.',
  'designBrowser.reference.site.github.detail': 'Reference implementation for embedded browser workflows.',
  'browserUse.category.assets': '에셋 추출',
  'browserUse.category.tokens': '디자인 언어',
  'browserUse.category.motion': '모션',
  'browserUse.category.visual': '시각적 검사',
  'browserUse.category.structure': '컴포넌트',
  'browserUse.category.project': '프로젝트 실행',
  'browserUse.category.general': '일반',
  'browserUse.input.none': '입력 없음',
  'browserUse.input.assetKind': 'kind: images | svgs | media | fonts, limit=200',
  'browserUse.input.optionalSelector': '선택적 선택자',
  'browserUse.input.requirementSelector': '요구 사항, 선택적 선택자',
  'browserUse.input.selectorOptional': '선택적 선택자',
  'browserUse.input.scaleOne': 'scale=1',
  'browserUse.input.selectorScaleTwo': '선택자, scale=2',
  'browserUse.input.gridOverlay': '12개 열, 최대 1200, 간격 24',
  'browserUse.input.bodySelector': 'selector=\'body\'',
  'browserUse.input.navigate': 'URL, 도메인 또는 검색어',
  'browserUse.input.selector': '선택자',
  'browserUse.input.selectorText': '선택자 및 텍스트',
  'browserUse.input.scroll': '픽셀, 위쪽, 아래쪽 또는 페이지',
  'browserUse.input.terminalRun': '명령, 제한 시간 120초',
  'browserUse.input.command': '명령',
  'browserUse.input.maxChars': 'maxChars=8000',
  'browserUse.input.custom': '{input}',
  'browserUse.action.extract_logo.output': '헤더, 내비게이션, 클래스 이름, 위치, OG 이미지 및 파비콘 대체에서 추출한 최적의 로고 후보.',
  'browserUse.action.list_images.output': '치수와 대체 텍스트가 포함된 모든 img, srcset, source 및 CSS 배경 이미지.',
  'browserUse.action.download_assets.output': '다운로드된 에셋 폴더와 referer 및 쿠키를 지원하는 _manifest.json.',
  'browserUse.action.extract_svgs.output': '개별 SVG 파일로 저장된 인라인 SVG 및 연결된 .svg 파일.',
  'browserUse.action.optimize_svgs.output': '최적화된 SVG 파일과 압축률.',
  'browserUse.action.extract_colors.output': '가중 팔레트와 :root CSS 색상 변수를 palette.json 및 palette.html로 저장.',
  'browserUse.action.extract_fonts.output': '상위 글꼴 패밀리, 크기, 굵기 및 @font-face 규칙을 typography.json으로 저장.',
  'browserUse.action.extract_design_tokens.output': '반경, 그림자, 간격 및 CSS 변수를 tokens.json으로 저장.',
  'browserUse.action.extract_type_scale.output': '크기, 굵기, 줄 높이 및 비율을 포함한 제목, 본문, 버튼 타입 스케일.',
  'browserUse.action.extract_buttons.output': '중복 제거된 버튼 스타일 라이브러리를 buttons.html 및 buttons.json으로 저장.',
  'browserUse.action.extract_grid_system.output': '그리드 및 플렉스 컨테이너, 방향, 간격, 열, 최대 너비를 layout.json으로 저장.',
  'browserUse.action.extract_breakpoints.output': '반응형 미디어 쿼리 중단점을 breakpoints.json으로 저장.',
  'browserUse.action.extract_gradients.output': 'CSS 그라데이션을 gradients.css, gradients.json 및 미리보기 HTML로 저장.',
  'browserUse.action.extract_shadows.output': '박스 그림자, 텍스트 그림자, 드롭 그림자를 shadows.json과 미리보기로 저장.',
  'browserUse.action.extract_easings.output': '전환 및 애니메이션 이징 함수를 easings.json으로 저장.',
  'browserUse.action.export_tokens.output': 'tokens.css, tokens.scss, tailwind.theme.js 및 style-dictionary.tokens.json.',
  'browserUse.action.extract_animations.output': '@keyframes, 전환 및 변환 규칙, 감지된 모션 라이브러리, motion.css 및 motion.json.',
  'browserUse.action.validate_view.output': '스크린샷 경로와 구조화된 시각적 및 레이아웃 문제.',
  'browserUse.action.audit_layout.output': '오버플로, 경계, 겹침, 잘린 텍스트를 포함한 레이아웃 결함을 audit.json으로 저장.',
  'browserUse.action.audit_accessibility.output': '선택자, 레이블, 역할, 포커스, 대비 및 유용한 경우 스크린샷이 포함된 접근성 문제.',
  'browserUse.action.responsive_screenshots.output': '모바일 390, 태블릿 834, 데스크톱 1440 스크린샷.',
  'browserUse.action.screenshot_full.output': '뷰포트를 넘어서는 전체 페이지 스크린샷.',
  'browserUse.action.screenshot_element.output': '기본 2배 배율의 단일 요소 스크린샷.',
  'browserUse.action.screenshot_with_grid.output': '레이아웃 그리드 오버레이가 포함된 스크린샷.',
  'browserUse.action.screenshot_dark_mode.output': 'prefers-color-scheme: dark 적용 스크린샷.',
  'browserUse.action.generate_styleguide.output': '색상, 타입 스케일, 모서리 반경, 그림자가 포함된 한 페이지 스타일 가이드.',
  'browserUse.action.extract_html.output': 'script, noscript, 인라인 이벤트 속성이 없는 깔끔한 자체 완결형 HTML.',
  'browserUse.action.extract_component_inventory.output': '반복되는 컴포넌트 패턴, 셀렉터, 개수, 스크린샷.',
  'browserUse.action.extract_copy.output': '제목, CTA, 본문, 설명을 copy.md 및 copy.json으로.',
  'browserUse.action.extract_nav.output': '기본 내비게이션 및 푸터 링크를 sitemap.md 및 nav.json으로.',
  'browserUse.action.extract_forms.output': '폼 필드, 레이블, 유효성 검사 힌트, 제출 액션을 forms.json으로.',
  'browserUse.action.run_project.output': 'Browser 탭에서 열린, 감지된 개발 서버 URL.',
  'browserUse.action.detect_project.output': '프레임워크, 패키지 매니저, 설치 명령, 개발 명령, 포트.',
  'browserUse.action.page_info.output': 'URL, 제목, 설명, OG 이미지, 테마 색상, 파비콘, 뷰포트.',
  'browserUse.action.snapshot.output': '태그, 레이블, href, 좌표가 포함된 최대 120개의 표시되는 인터랙티브 및 텍스트 요소.',
  'browserUse.action.navigate.output': '페이지를 열고 page_info를 반환합니다.',
  'browserUse.action.click.output': '화면에 보이도록 스크롤한 후 처음 일치하는 요소를 클릭합니다.',
  'browserUse.action.type_text.output': '입력란을 채우고 input 및 change 이벤트를 발생시킵니다.',
  'browserUse.action.scroll.output': '현재 및 최대 스크롤 위치.',
  'browserUse.action.extract_og_metadata.output': '메타 제목, 설명, 표준 URL, OG/Twitter 카드, 소셜 이미지, 테마 색상.',
  'browserUse.action.terminal_run.output': 'stdout, stderr, 종료 코드.',
  'browserUse.action.terminal_run_background.output': '백그라운드 작업 id 및 최근 출력.',
  'browserUse.action.terminal_read.output': '최근 공유된 터미널 출력.',
  'chat.designToolbox.title': '디자인 도구상자',
  'chat.designToolbox.tooltip': '디자인 도구상자',
  'chat.designToolbox.aria': '디자인 도구상자 열기',
  'chat.designToolbox.searchPlaceholder': '스킬 / MCP / 플러그인 / 커넥터 / 디자인 파일 검색...',
  'chat.designToolbox.searchAria': '디자인 도구상자 리소스 검색',
  'chat.designToolbox.followupSection': '후속 작업',
  'chat.designToolbox.resourcesSection': '전역 리소스',
  'chat.designToolbox.selected': '선택됨',
  'chat.designToolbox.noResources': '"{query}"에 대한 리소스를 찾을 수 없습니다.',
  'chat.designToolbox.badge.video': '비디오',
  'chat.designToolbox.badge.image': '이미지',
  'chat.designToolbox.badge.motion': '모션',
  'chat.designToolbox.badge.polish': '다듬기',
  'chat.designToolbox.action.auto-match.title': '다음 단계에 맞추기',
  'chat.designToolbox.action.auto-match.badge': '맞추기',
  'chat.designToolbox.action.auto-match.description': '먼저 취향 기준을 정한 다음, 스킬, MCP, 플러그인, 커넥터, 파일을 매칭하세요.',
  'chat.designToolbox.action.asset-search.title': 'Find images / references',
  'chat.designToolbox.action.asset-search.badge': 'Assets',
  'chat.designToolbox.action.asset-search.description': 'Search for usable images, reference screenshots, moodboards, and source candidates for the current design.',
  'chat.designToolbox.action.icon-workflow.title': 'Find / replace icons',
  'chat.designToolbox.action.icon-workflow.badge': 'Icons',
  'chat.designToolbox.action.icon-workflow.description': 'Find, generate, or swap iconography, SVGs, Lucide icons, and visual symbols with a consistent style.',
  'chat.designToolbox.action.image-replace.title': 'Replace page images',
  'chat.designToolbox.action.image-replace.badge': 'Swap',
  'chat.designToolbox.action.image-replace.description': 'Audit current imagery and replace weak hero, section, background, or card images with better assets.',
  'chat.designToolbox.action.reference-extract.title': 'Extract visual references',
  'chat.designToolbox.action.reference-extract.badge': 'Refs',
  'chat.designToolbox.action.reference-extract.description': 'Analyze a reference screenshot or site for palette, typography, layout posture, motion, and asset direction.',
  'chat.designToolbox.action.motion.title': '애니메이션 / 모션 추가',
  'chat.designToolbox.action.motion.badge': '모션',
  'chat.designToolbox.action.motion.description': '현재 HTML 또는 페이지 요소에 등장, 스크롤, 상태 전환, 마이크로 인터랙션 모션을 추가합니다.',
  'chat.designToolbox.action.motion-polish.title': '모션 다듬기',
  'chat.designToolbox.action.motion-polish.badge': '타이밍',
  'chat.designToolbox.action.motion-polish.description': '기존 모션의 타이밍, 이징, 성능, 모션 감소 대체 동작을 검토합니다.',
  'chat.designToolbox.action.transition-motion.title': 'Design transitions',
  'chat.designToolbox.action.transition-motion.badge': 'Transition',
  'chat.designToolbox.action.transition-motion.description': 'Design page, scene, loading, and state transitions with restrained timing and reduced-motion fallbacks.',
  'chat.designToolbox.action.threejs-scene.title': '3D / Three.js scene',
  'chat.designToolbox.action.threejs-scene.badge': '3D',
  'chat.designToolbox.action.threejs-scene.description': 'Add or plan Three.js, Spline, Vanta, particle, WebGL, map, or deck.gl-style interactive visuals.',
  'chat.designToolbox.action.anti-ai-polish.title': 'AI 느낌 제거',
  'chat.designToolbox.action.anti-ai-polish.badge': '취향',
  'chat.designToolbox.action.anti-ai-polish.description': '템플릿 느낌, AI 그라데이션, 저렴한 카드 스택, 모호한 카피를 제거합니다.',
  'chat.designToolbox.action.visual-polish.title': '디자인 다듬기 / 출시 준비 완료',
  'chat.designToolbox.action.visual-polish.badge': '다듬기',
  'chat.designToolbox.action.visual-polish.description': '시각적 위계, 타이포그래피, 간격, 반응형 동작, 접근성, 전달 품질을 점검합니다.',
  'chat.designToolbox.action.image-gen.title': '이미지 / 시각 레퍼런스 생성',
  'chat.designToolbox.action.image-gen.badge': '이미지',
  'chat.designToolbox.action.image-gen.description': '현재 페이지를 위한 섹션 레퍼런스, 에셋, 아이콘, 소셜 이미지, 무드보드를 생성합니다.',
  'chat.designToolbox.action.chart-gen.title': 'Generate charts / diagrams',
  'chat.designToolbox.action.chart-gen.badge': 'Charts',
  'chat.designToolbox.action.chart-gen.description': 'Generate ECharts, React Flow, diagrams, dashboards, relationship maps, or data-visualization assets.',
  'chat.designToolbox.action.logo-gen.title': 'Generate logo / identity',
  'chat.designToolbox.action.logo-gen.badge': 'Logo',
  'chat.designToolbox.action.logo-gen.description': 'Create logo routes, wordmarks, lockups, marks, and identity-system prompts for the current brand.',
  'chat.designToolbox.action.plan-outline.title': "Generate PPT outline from idea",
  'chat.designToolbox.action.plan-outline.badge': "Plan",
  'chat.designToolbox.action.plan-outline.description': "Turn a rough idea into an editable Markdown deck outline before creating slides.",
  'chat.designToolbox.action.video-gen.title': '비디오 / 모션 스크립트 생성',
  'chat.designToolbox.action.video-gen.badge': '비디오',
  'chat.designToolbox.action.video-gen.description': '디자인을 짧은 비디오, Remotion / Hyperframes 스토리보드, 또는 생성 가능한 프롬프트로 변환합니다.',
  'chat.designToolbox.kind.skill': '스킬',
  'chat.designToolbox.kind.plugin': '플러그인',
  'chat.designToolbox.kind.mcp': 'MCP',
  'chat.designToolbox.kind.mcpTemplate': 'MCP 템플릿',
  'chat.designToolbox.kind.connector': '커넥터',
  'chat.designToolbox.kind.designFile': '디자인 파일',
  'chat.designToolbox.context.browser': '브라우저',
  'chat.designToolbox.context.designFiles': '디자인 파일',
  'chat.designToolbox.context.designSystem': '디자인 시스템',
  'chat.designToolbox.context.folder': '폴더',
  'chat.designToolbox.context.terminal': '터미널',
  'chat.designToolbox.context.sideChat': '사이드 채팅',
  'chat.designToolbox.context.liveArtifact': '라이브 아티팩트',
  'chat.designToolbox.context.file': '파일',
  'chat.designToolbox.prompt.contextGeneric': '현재 대상: 현재 열려 있는 HTML / 디자인 파일 / 웹 요소.',
  'chat.designToolbox.prompt.contextSpecific': '현재 대상: {kind} · {label}.',
  'chat.designToolbox.prompt.preserveDraft': '작성기에 이미 담긴 의도를 유지하세요: {draft}',
  'chat.designToolbox.prompt.selectedSkill': '선택된 skill: {skill}. 이번 턴의 기본 워크플로로 사용하세요.',
  'chat.designToolbox.prompt.noSkill': '특정 skill이 일치하지 않으면, 먼저 사용 가능한 skill, MCP, 플러그인, 커넥터, 디자인 파일에서 최적의 조합을 선택하세요.',
  'chat.designToolbox.prompt.autoMatchIntro': 'Creative Director 오케스트레이터로서 디자인 워크플로를 완료하세요:',
  'chat.designToolbox.prompt.autoMatchStep1': '1. 먼저 “보기 좋은 디자인”이 무엇인지 정의하세요: 대상, 비즈니스 목표, 브랜드 느낌, 스타일 레퍼런스, 정보 밀도, 색상/타이포/모션/에셋 기준, 그리고 피해야 할 AI/템플릿 패턴.',
  'chat.designToolbox.prompt.autoMatchStep2': '2. 위의 전체 리소스 인덱스를 검색하고 매칭하세요. 디자인 툴박스 추천만 사용하지 말고, 유용할 때 skill, MCP, 플러그인, 커넥터, 디자인 파일을 결합하세요.',
  'chat.designToolbox.prompt.autoMatchStep3': '3. If the target or aesthetic bar is still unclear, guide me with a structured question-form, include recommended defaults, and make each finite-choice question editable with a custom answer field. If it is clear enough, execute the next step directly.',
  'chat.designToolbox.prompt.autoMatchStep4': '4. 다음 순서로 플로를 완료하세요: 진단 -> 스타일 방향 -> 리소스 선택 -> 구체적 편집/생성 -> 검증. 각 단계에서 이 리소스를 선택한 이유와 다음에 무엇을 확인해야 하는지 설명하세요.',
  'chat.designToolbox.prompt.assetSearch': 'Find the best image/reference assets for the current design. Search available files, connectors, MCPs, browser captures, and generation tools. Return concrete candidates with usage notes, licensing/source caveats when relevant, and a fallback generation prompt if no usable asset exists.',
  'chat.designToolbox.prompt.iconWorkflow': 'Improve the icon system for the current design: find missing icons, replace weak icons, keep stroke/fill/radius/weight consistent, prefer existing icon libraries when available, and generate SVG/icon prompts only when a library icon is insufficient.',
  'chat.designToolbox.prompt.imageReplace': 'Audit every visible image slot in the current design, identify weak or placeholder imagery, then replace or specify better hero, section, background, card, and social images. Preserve layout and provide exact file/prompt/source choices.',
  'chat.designToolbox.prompt.referenceExtract': 'Use the current reference image/site/design file as visual input. Extract palette, type scale, layout rhythm, component posture, motion cues, and asset style, then apply those findings to the current design without copying protected brand assets verbatim.',
  'chat.designToolbox.prompt.motion': 'Add high-quality motion to the current HTML / page element: choose the most useful 1-2 entrance, scroll, state-transition, transition, Rive/Lottie-style icon motion, or GSAP/Motion micro-interaction moments. Keep it restrained, prefer transform / opacity, and include prefers-reduced-motion fallbacks.',
  'chat.designToolbox.prompt.planOutline': "Create or update a Markdown planning document for a PPT/deck outline from this idea. Do not generate the final deck yet. Include slide-by-slide titles, goals, content bullets, visual direction, required data/assets, and open questions. Save it as a `.md` file in Design Files and tell me which file to review.",
  'chat.designToolbox.prompt.motionPolish': '기존 모션의 타이밍, 이징, 성능, 접근성을 검토하고 다듬으세요. 갑작스럽거나 조잡하거나 가독성을 해치는 애니메이션을 제거하고, 필요할 때 더 정교한 타임라인을 사용하세요.',
  'chat.designToolbox.prompt.transitionMotion': 'Design high-quality transitions for the current design: page/scene changes, loading bridges, state changes, and section handoffs. Use GSAP/Motion/CSS where appropriate, keep it performant, and include reduced-motion behavior.',
  'chat.designToolbox.prompt.threejsScene': 'Plan or implement a focused Three.js/WebGL visual for the current design. Consider Three.js, Spline-style scenes, Vanta backgrounds, particle systems, Mapbox/deck.gl data layers, or browser portal effects, but keep the scene useful and verify it renders.',
  'chat.designToolbox.prompt.antiAiPolish': 'AI 느낌 제거 폴리싱을 한 차례 수행하세요: 틀에 박힌 레이아웃, 조잡한 그라데이션/글로우, 의미 없는 카드 스택, 모호한 카피를 제거하세요. 정보는 유지하고 실제 디자이너가 만든 것처럼 느껴지게 하세요.',
  'chat.designToolbox.prompt.visualPolish': '이 디자인을 출시 준비가 될 때까지 다듬으세요: 위계, 타이포그래피, 간격, 반응형 동작, 버튼 상태, 빈/로딩/오류 상태, 접근성을 점검하고, 가장 중요한 문제를 바로 수정하세요.',
  'chat.designToolbox.prompt.imageGen': '이 디자인의 다음 비주얼 에셋 계획을 만드세요: 섹션 레퍼런스, 히어로 에셋, 일러스트레이션, 아이콘, 소셜 이미지 또는 무드보드. 먼저 어떤 종류의 이미지가 부족한지 결정한 다음, 실행 가능한 생성 프롬프트 / 파일 계획을 제공하세요.',
  'chat.designToolbox.prompt.chartGen': 'Generate the right chart, diagram, or data-visualization for the current design. Choose between ECharts, React Flow, SVG/CSS diagrams, radar charts, relationship maps, dashboards, or deck.gl/map visualizations based on the data and user goal.',
  'chat.designToolbox.prompt.logoGen': 'Create logo and identity directions for the current brand. Produce multiple routes for wordmark, symbol, lockup, palette, usage rules, and generation prompts; make sure the result is original and usable in the current artifact.',
  'chat.designToolbox.prompt.videoGen': '이 디자인을 영상으로 전환하세요: 숏폼 스토리보드, Hyperframes / Remotion 프레임 구조 또는 Sora/fal에 바로 쓸 수 있는 프롬프트를 만드세요. 기존 HTML / 페이지 콘텐츠가 자연스럽게 샷이 되도록 하는 것을 우선하세요.',
  'chat.designToolbox.prompt.useSkill': '현재 디자인에 {skill}을(를) 사용하세요.',
  'chat.designToolbox.prompt.skillInstruction': '먼저 최적의 후속 목표를 결정한 다음, 구체적인 작업을 한 차례 완료하세요. 외부 에셋이나 API에 의존하는 경우, 실행 가능한 폴백을 제공하거나 제가 무엇을 제공해야 하는지 명시하세요.',
  'chat.designToolbox.prompt.selectedResource': '선택된 리소스: {kind} · {title} ({id}).',
  'chat.designToolbox.prompt.resourceDescription': '리소스 설명: {description}',
  'chat.designToolbox.prompt.pluginResource': '이 플러그인을 현재 디자인 플로의 주요 컨텍스트로 사용하세요. 입력이나 GenUI를 노출하는 경우 필요할 때 선택하도록 안내하고, 대상에 맞지 않으면 더 나은 전역 리소스를 선택하고 이유를 설명하세요.',
  'chat.designToolbox.prompt.mcpResource': '다음 디자인 단계에서는 이 MCP 기능을 우선하세요. 외부 에셋, 웹 캡처, 이미지/영상 생성 또는 데이터가 필요할 때, 먼저 이 기능으로 처리할 수 있는지 판단한 다음 실행 가능한 계획을 제시하세요.',
  'chat.designToolbox.prompt.mcpTemplateResource': '이 MCP는 구성 가능한 템플릿입니다. 이 디자인 단계에서 가장 유용한 도구라면 먼저 설정을 안내하고, 구성된 대안이 있으면 그 대안으로 계속 진행하세요.',
  'chat.designToolbox.prompt.connectorResource': '실제 데이터, 에셋, 계정 콘텐츠 또는 외부 워크플로 접근이 필요할 때 이 커넥터를 사용하세요. 사용하기 전에 무엇을 읽거나 쓸지 설명하고, 적절한 경우 확인을 요청하세요.',
  'chat.designToolbox.prompt.fileResource': '이 디자인 파일을 현재 디자인 대상 또는 참조 에셋으로 사용하여 다음 단계를 완료하세요. 다른 파일과 비교해야 하는 경우, 모든 디자인 파일에서 계속 검색하세요.',
  'chat.designToolbox.prompt.resourceIndex': '전역 리소스 인덱스: skill({skills}), 플러그인({plugins}), MCP(활성화 {mcpEnabled}개 / 템플릿 {mcpTemplates}개), 커넥터(연결 {connectors}개), 디자인 파일({files}).',
  'chat.designToolbox.prompt.searchableSkills': '검색 가능한 skill',
  'chat.designToolbox.prompt.searchablePlugins': '검색 가능한 플러그인',
  'chat.designToolbox.prompt.availableMcp': '사용 가능한 MCP',
  'chat.designToolbox.prompt.connectedConnectors': '연결된 커넥터',
  'chat.designToolbox.prompt.referenceDesignFiles': '참조 디자인 파일',
  'chat.designToolbox.prompt.mcpTemplateName': '{name} 템플릿',
  'chat.designToolbox.prompt.processRule': 'Workflow rule: define the aesthetic goal and constraints first, then search and match resources; when user choice is needed, generate a structured question-form with editable custom answers and continue after confirmation.',
  'chat.designToolbox.prompt.moreSuffix': ', +{count}개 더',
  'chat.designToolbox.prompt.compactLine': '{label}: {values}{suffix}.',
  'chat.mentionTabsAria': '멘션 표면',
  'chat.mentionTabAll': '전체',
  'chat.mentionTabTabs': '탭',
  'chat.mentionTabPlugins': '플러그인',
  'chat.mentionTabSkills': 'Skill',
  'chat.mentionTabMcp': 'MCP',
  'chat.mentionTabConnectors': '커넥터',
  'chat.mentionTabFiles': '디자인 파일',
  'chat.mentionNoResults': '“{query}”에 대한 결과가 없습니다.',
  'chat.mentionSearchPrompt': '디자인 파일, 탭, 플러그인, skill, MCP 서버, 커넥터를 검색하세요.',
  'chat.mentionSectionTabs': '탭',
  'chat.mentionSectionPlugins': '플러그인',
  'chat.mentionSectionSkills': 'Skill',
  'chat.mentionSectionMcp': 'MCP',
  'chat.mentionSectionConnectors': '커넥터',
  'chat.mentionSectionFiles': '디자인 파일',
  'chat.mentionActiveSkill': '활성',
  'chat.mentionUseMcpTitle': '{name} 사용',
  'chat.mentionUseConnectorTitle': '{name} 사용',
  'chat.mentionPluginOfficial': '공식',
  'chat.mentionPluginMine': '내 플러그인',
  'chat.linkedFolderRemoveAria': '연결된 폴더 {path} 제거',
  'chat.linkedFolderNotFound': '폴더가 존재하지 않습니다',
  'chat.linkedFolderAlready': '이미 연결된 폴더입니다',
  'chat.linkedFolderPickError': '폴더 선택기를 열 수 없습니다',
  'chat.queuedHeader': '대기 중',
  'chat.queuedToSend': '보내기',
  'chat.queuedEditQueuedTaskAria': '대기 중인 작업 편집',
  'chat.queuedSave': '저장',
  'chat.queuedCancel': '취소',
  'chat.queuedReorder': '드래그하여 순서 변경',
  'chat.queuedEdit': '편집',
  'chat.queuedMore': '개 더 대기 중',
  'chat.queuedFollowUpFallback': '대기 중인 후속 작업',
  'chat.send': '전송',
  'chat.stop': '중지',
  'chat.removeAria': '{name} 제거',
  'chat.example1Title': '에디토리얼 피치 덱',
  'chat.example1Tag': '매거진',
  'chat.example1Prompt': '디자인 스튜디오의 시드 라운드 투자 유치를 위한 10장짜리 에디토리얼 피치 덱을 만들어 주세요. 스위스 스타일의 그리드 레이아웃, 볼드한 드롭 캡이 있는 크고 굵은 세리프체 헤드라인, 고정폭 폰트의 섹션 번호, 넉넉한 여백, 텍스트가 많은 슬라이드와 대비되는 꽉 찬 이미지 슬라이드를 조합해 주세요. 커버, 비전, 시장, 제품, 트랙션, 팀 구성, 투자 요청액, 연락처를 포함해 주세요.',
  'chat.example2Title': 'SaaS 애널리틱스 대시보드',
  'chat.example2Tag': '데이터',
  'chat.example2Prompt': '개발자 도구 SaaS를 위한 정보가 밀집된 애널리틱스 대시보드를 만들어 주세요. 전주 대비 변화량을 보여주는 주요 KPI 스트립, 두 개의 누적 선 그래프 (MRR 및 활성 워크스페이스), 사용량 기준 전 세계 히트맵, 코호트 리텐션 그리드, 상위 고객 리더보드, 그리고 실시간 이벤트 피드가 포함되어야 합니다. 다크 테마를 기반으로, 가독성을 위한 고정폭 숫자를 사용하고 스파크라인 포인트 색상으로 강조해 주세요.',
  'chat.example3Title': '연례 보고서 롱 스크롤 페이지',
  'chat.example3Tag': '에디토리얼',
  'chat.example3Prompt': '기후 변화 관련 비영리 단체의 인터랙티브 연례 보고서를 제작해 주세요. 큰 인용구 블록이 특징인 긴 스크롤 기반 에디토리얼 레이아웃과 함께, 누적 막대 그래프, 움직이는 카운터, 프로젝트 사이트 분포를 보여주는 코로플레스 맵 등 데이터 시각화를 섞어 주세요. 텍스트 중간중간 사진을 삽입하고, 기부자 명단과 마지막 결론 부분(CTA)을 포함해 주세요. 본문은 모던 세리프 폰트를, 차트 라벨은 산세리프 폰트를 사용하며 전체적으로 따뜻한 색감의 팔레트를 적용해 주세요.',
  'home.recommendation.eyebrow': '추천 콘텐츠',
  'home.recommendation.primaryCta': '만들기 시작',
  'home.recommendation.change': '다른 것 시도하기',
  'home.recommendation.browseAll': '전체 유형',
  'home.recommendation.defaultProjectName': '새 프로젝트',
  'home.recommendation.startFailed': '생성을 시작할 수 없습니다. 다시 시도해 주세요.',
  'studio.firstArtifactHint.title': '첫 번째 디자인이 준비되었습니다',
  'studio.firstArtifactHint.body': '바로 편집하고 주석을 달아 보세요. 마음에 들면 언제든 내보내거나 공유할 수 있어요.',
  'studio.firstArtifactHint.dismiss': '확인',
  'home.starter.product_ui_prototype.title': '편집 가능한 제품 프로토타입으로 시작하기',
  'home.starter.product_ui_prototype.desc': '목표에 맞춰, 다듬을 수 있는 클릭 가능한 인터페이스로 시작하세요.',
  'home.starter.product_ui_prototype.firstPrompt': '[내 제품]을 위한 편집 가능한 제품 프로토타입을 주요 화면과 명확한 기본 흐름과 함께 디자인해 줘.',
  'home.starter.product_ui_component.title': '재사용 가능한 컴포넌트로 시작하기',
  'home.starter.product_ui_component.desc': '먼저 컴포넌트 하나를 만든 다음, 이를 조합해 전체 화면을 구성하세요.',
  'home.starter.product_ui_component.firstPrompt': '주요 상태와 변형을 갖춘 재사용 가능한 [컴포넌트 이름] 컴포넌트를 디자인해 줘.',
  'home.starter.product_ui_lowfi.title': '로우파이 프로토타입으로 시작하기',
  'home.starter.product_ui_lowfi.desc': '먼저 구조를 스케치한 다음, 완성도를 높여 가세요.',
  'home.starter.product_ui_lowfi.firstPrompt': '[내 제품]의 주요 화면에 대한 로우파이 와이어프레임을 만들어 줘.',
  'home.starter.marketing_landing.title': '랜딩 페이지로 시작하기',
  'home.starter.marketing_landing.desc': '캠페인을 바로 출시할 수 있는 랜딩 페이지로 만들어 보세요.',
  'home.starter.marketing_landing.firstPrompt': '[내 제품]을 위한 랜딩 페이지를 히어로, 핵심 이점, 명확한 콜 투 액션과 함께 디자인해 줘.',
  'home.starter.marketing_multivariant.title': '여러 랜딩 페이지 변형으로 시작하기',
  'home.starter.marketing_multivariant.desc': '결정하기 전에 비교할 수 있도록 여러 버전을 생성하세요.',
  'home.starter.marketing_multivariant.firstPrompt': '[내 제품]을 위한 랜딩 페이지 변형 3개를 서로 다른 히어로 메시지로 만들어 비교할 수 있게 해 줘.',
  'home.starter.internal_dashboard.title': '내부 대시보드로 시작하기',
  'home.starter.internal_dashboard.desc': '워크플로에 맞는 대시보드 레이아웃으로 시작하세요.',
  'home.starter.internal_dashboard.firstPrompt': '[핵심 지표]를 보여주고 필터와 데이터 테이블을 갖춘 내부 대시보드를 디자인해 줘.',
  'home.starter.internal_report.title': '리포트로 시작하기',
  'home.starter.internal_report.desc': '보고 싶은 데이터와 필드를 설명해 주세요.',
  'home.starter.internal_report.firstPrompt': '[보고 싶은 데이터, 필드, 지표를 설명해 주세요]를 요약한 리포트 페이지를 만들어 줘.',
  'home.starter.general_menu.title': '첫 번째 프로젝트로 시작하기',
  'home.starter.general_menu.desc': '만들고 싶은 것을 설명해 주시면 편집 가능한 첫 번째 버전을 생성해 드립니다.',
  'home.starter.general_menu.firstPrompt': '[만들고 싶은 것을 설명해 주세요]의 편집 가능한 첫 번째 버전을 만들어 줘.',
  'chat.example4Title': '제품 모션 비디오',
  'chat.example4Tag': '모션',
  'chat.example4Prompt': '생산성 앱 출시를 위한 15초 모션 비디오 스토리보드를 만들어 주세요. 오프닝 훅, UI 클로즈업, 키네틱 타이포그래피, 기능 전환, 엔딩 로고와 CTA를 포함하고 타이밍, 장면 설명, 카메라 움직임, 화면 문구를 정리해 주세요.',
  'preview.usePlugin': '플러그인 사용',
  'preview.usePluginOnly': '프롬프트 없이 사용',
  'preview.usePluginOnlyDesc': '예시 프롬프트를 불러오지 않고 플러그인 구조 사용',
  'preview.replicateContent': '사용',
  'preview.replicateContentDesc': '예시 프롬프트로 미리보기 재현',
  'preview.duplicateTemplate': 'Remix',
  'preview.duplicateTemplateDesc': '이 예시를 편집 가능한 새 프로젝트로 Remix',
  'preview.shareMenu': '공유',
  'preview.exportMenu': '내보내기',
  'preview.shareTemplateBadge': '템플릿',
  'preview.shareToX': 'X / Twitter',
  'preview.shareToReddit': 'Reddit',
  'preview.shareToFacebook': 'Facebook',
  'preview.shareToLinkedIn': 'LinkedIn',
  'preview.shareToInstagram': 'Instagram',
  'preview.shareToXiaohongshu': '小红书',
  'preview.copyTemplateLink': '템플릿 링크 복사',
  'preview.copyShareText': '공유 텍스트 복사',
  'preview.shareSocialGroup': '소셜에 공유',
  'preview.shareCopyGroup': '복사',
  'preview.shareExportGroup': '파일 내보내기',
  'preview.shareCopied': '복사됨',
  'preview.shareCopyFailed': '복사 실패',
  'preview.shareTextDefault': 'Open Design 템플릿: {title}',
  'preview.openInNewTab': '새 탭에서 열기',
  'preview.exit': '⤓ 나가기',
  'preview.fullscreen': '⤢ 전체 화면',
  'preview.closeTitle': '닫기 (Esc)',
  'preview.loading': '{label} 불러오는 중…',
  'preview.errorTitle': '이 예제를 불러오지 못했습니다.',
  'preview.errorBody': '예제 HTML을 가져오지 못했습니다. Open Design이 실행 중인지 확인하고 다시 시도하세요.',
  'preview.retry': '다시 시도',
  'preview.unavailableTitle': '{noun}에는 함께 제공되는 미리보기가 없습니다.',
  'preview.unavailableBody': '채팅에서 프롬프트를 실행해 {kind} 출력을 생성하세요.',
  'preview.nounSkill': '이 스킬',
  'preview.nounPlugin': '이 플러그인',
  'preview.nounTemplate': '이 템플릿',
  'preview.showSidebar': '{label} 표시',
  'preview.hideSidebar': '{label} 숨기기',
  'misc.savedTemplate': '저장된 템플릿',
  'misc.primary': '기본색 (Primary)',
  'misc.designSystem': '디자인 시스템',
  'workspace.designFiles': '디자인 파일',
  'workspace.focusMode': '워크스페이스 집중',
  'workspace.showChat': '채팅 표시',
  'workspace.closeTab': '탭 닫기',
  'workspace.deleteFileConfirm': '프로젝트 폴더에서 "{name}" 파일을 삭제하시겠습니까?',
  'workspace.deleteSelectedFilesConfirm': '프로젝트 폴더에서 선택한 {n}개 파일을 삭제하시겠습니까?',
  'workspace.deleteSelectedFilesPartial': '{n}개 파일을 삭제하지 못했습니다.',
  'workspace.openFromDesignFiles': '디자인 파일 열기',
  'workspace.designFilesLink': '디자인 파일',
  'workspace.loadingSketch': '스케치 불러오는 중…',
  'workspace.newTab': '새 탭',
  'workspace.searchFilesPlaceholder': '파일 검색…',
  'workspace.openTabs': '열린 탭',
  'workspace.openFile': '파일 열기',
  'workspace.noFilesMatch': '일치하는 파일 없음',
  'workspace.allFiles': '전체',
  'workspace.createNew': '새로 만들기',
  'workspace.tabOpen': '열림',
  'workspace.sideChatContextBanner': '현재 대화의 컨텍스트를 통합했습니다',
  'workspace.sideChatDefaultTitle': '사이드 채팅',
  'workspace.newTerminal': '새 터미널',
  'workspace.newTerminalDescription': '새 탭에서 프로젝트 디렉터리의 셸 열기',
  'workspace.newBrowser': '새 브라우저',
  'workspace.newBrowserDescription': '참고 사이트 및 브라우저 작업을 위한 내장 브라우저 탭 열기',
  'workspace.newSketchDescription': '대략적인 레이아웃과 메모를 그려 에이전트의 디자인 맥락으로 사용',
  'workspace.terminalStarting': '터미널을 시작하는 중…',
  'workspace.terminalStartingDescription': '프로젝트 셸을 준비하고 있습니다. 보통 몇 초 정도 걸립니다.',
  'workspace.terminalSessionEnded': '세션이 종료되었습니다',
  'workspace.terminalReconnecting': '다시 연결하는 중…',
  'workspace.terminalStartFailed': '터미널 세션을 시작할 수 없습니다',
  'workspace.terminalRestart': '다시 시작',
  'designFiles.title': '디자인 파일',
  'designFiles.upload': '파일 업로드',
  'designFiles.pasteText': '텍스트 파일로 붙여넣기',
  'designFiles.newSketch': '새 스케치',
  'designFiles.empty': '여기에 작업물이 표시됩니다',
  'designFiles.refresh': '새로고침',
  'designFiles.delete': '삭제',
  'designFiles.searchPlaceholder': '파일 검색…',
  'designFiles.up': '위로',
  'designFiles.back': '뒤로',
  'designFiles.crumbs': '프로젝트',
  'designFiles.rowMenu': '항목 메뉴',
  'designFiles.openInTab': '탭에서 열기',
  'designFiles.download': '다운로드',
  'designFiles.downloadSelected': '{n}개를 ZIP으로 다운로드',
  'designFiles.deleteSelected': '{n}개 삭제',
  'designFiles.clearSelection': '선택 해제',
  'designFiles.selectPage': '페이지에서 모두 선택',
  'designFiles.selectAll': '모두 선택',
  'designFiles.dropTitle': '⤓ 여기에 파일을 놓으세요',
  'designFiles.dropDesc': '이미지, 문서, 참조 자료, 폴더 등을 놓아주세요. 에이전트가 문맥으로 활용합니다.',
  'designFiles.dropLabel': '여기에 파일을 놓으세요',
  'designFiles.upload.title': '파일 업로드',
  'designFiles.paste.title': "Create document",
  'designFiles.upload.label': '업로드',
  'designFiles.paste.label': "Create document",
  'designFiles.documentTemplate.titleFallback': 'Document',
  'designFiles.documentTemplate.goalHeading': 'Goal',
  'designFiles.documentTemplate.goalBody': 'Describe what Open Design should generate, edit, or decide from this document.',
  'designFiles.documentTemplate.capabilitiesHeading': 'How to use this document',
  'designFiles.documentTemplate.capabilityMarkdown': 'Use any Markdown format: headings, tables, checklists, links, quotes, code blocks, and images.',
  'designFiles.documentTemplate.capabilityAgent': 'The Open Design agent can read, edit, and use this file as project context.',
  'designFiles.documentTemplate.capabilityImages': 'Paste images, or drag image files onto the editor; uploaded images are inserted at the cursor.',
  'designFiles.documentTemplate.scenarioHeading': 'Scenario guide',
  'designFiles.documentTemplate.scenario.prototype': 'For prototypes, outline the product goal, target users, flows, screens, modules, interaction states, responsive breakpoints, and design tokens such as color, type, spacing, radius, and motion.',
  'designFiles.documentTemplate.scenario.wireframe': 'For wireframes, describe the user flow, screen list, layout hierarchy, content blocks, low-fidelity constraints, and the questions the structure should answer before visual design.',
  'designFiles.documentTemplate.scenario.mobile': 'For mobile apps, list target platforms, screens, navigation model, gestures, native patterns, device sizes, states, and mobile design tokens.',
  'designFiles.documentTemplate.scenario.slideDeck': 'For slides, write a paginated PPT outline: one section per slide with title, purpose, key message, evidence, visual direction, speaker notes, and export needs.',
  'designFiles.documentTemplate.scenario.document': 'For documents, define audience, tone, section structure, source material, citations or data, layout expectations, and PDF/export requirements.',
  'designFiles.documentTemplate.scenario.image': 'For images, specify subject, aspect ratio, composition, visual style, brand tokens, reference files, and negative constraints.',
  'designFiles.documentTemplate.scenario.video': 'For video, draft a storyboard with scenes, timing, captions, motion, assets, audio notes, and output format.',
  'designFiles.documentTemplate.scenario.hyperframes': 'For HyperFrames, describe the HTML motion piece: scenes, timeline, captions, audio-reactive moments, transitions, and capture/export requirements.',
  'designFiles.documentTemplate.scenario.audio': 'For audio, define voice or music direction, duration, mood, script or copy, pacing, pronunciation notes, and final use.',
  'designFiles.documentTemplate.scenario.liveArtifact': 'For live artifacts, describe data sources, refresh cadence, widgets, filters, interactions, empty/loading/error states, and any alerts or automations.',
  'designFiles.documentTemplate.scenario.designSystem': 'For design systems, list brand goals, tokens, typography, color, spacing, components, assets, references, and rules to follow or avoid.',
  'designFiles.documentTemplate.scenario.default': 'Describe the audience, deliverable, required content, references, constraints, and what done should look like.',
  'designFiles.documentTemplate.nextHeading': 'Next step',
  'designFiles.documentTemplate.nextBody': 'Review and edit this document, then ask Open Design to generate, revise, or operate from it.',

  'designFiles.projectMenu': 'Project actions',
  'designFiles.createDesignSystemFromProject': 'Create design system from this project',
  'designFiles.duplicateProject': 'Duplicate project',

  'designFiles.previewOpen': '열기',
  'designFiles.previewClose': '미리보기 닫기',
  'designFiles.modified': '{time} 수정됨 · {size}',
  'designFiles.weeksAgo': '{n}주 전',
  'designFiles.groupBy': '그룹 기준',
  'designFiles.groupByKind': '종류',
  'designFiles.groupByModified': '수정일',
  'designFiles.filterBy': '종류별 필터',
  'designFiles.filterClear': '지우기',
  'designFiles.filterCount': '{n}개 종류',
  'designFiles.expandGroup': '펼치기',
  'designFiles.collapseGroup': '접기',
  'designFiles.sectionPages': '페이지',
  'designFiles.sectionScripts': '스크립트',
  'designFiles.sectionImages': '이미지',
  'designFiles.sectionSketches': '스케치',
  'designFiles.sectionLiveArtifacts': '라이브 아티팩트',
  'designFiles.sectionOther': '기타',
  'designFiles.modifiedToday': '오늘',
  'designFiles.modifiedYesterday': '어제',
  'designFiles.modifiedPrevious7Days': '지난 7일',
  'designFiles.modifiedPrevious30Days': '지난 30일',
  'designFiles.modifiedOlder': '이전',
  'designFiles.showMore': '+{n}개 더 보기',
  'designFiles.kindHtml': 'HTML 페이지',
  'designFiles.kindImage': '이미지',
  'designFiles.kindSketch': '스케치',
  'designFiles.kindText': '텍스트',
  'designFiles.kindCode': '스크립트',
  'designFiles.kindPdf': 'PDF 문서',
  'designFiles.kindDocument': '문서',
  'designFiles.kindPresentation': '프레젠테이션',
  'designFiles.kindSpreadsheet': '스프레드시트',
  'designFiles.kindLiveArtifact': '라이브 아티팩트',
  'designFiles.kindBinary': '바이너리 파일',
  'designFiles.kindFolder': '폴더',
  'designFiles.folderCount': '{n}개 파일',
  'designFiles.newFolderTitle': '새 폴더',
  'designFiles.newFolderLabel': '폴더 이름',
  'designFiles.moveTitle': '폴더로 이동',
  'designFiles.moveLabel': '대상 폴더',
  'designFiles.moveRoot': '프로젝트 루트',
  'designFiles.moveNewFolder': '새 폴더…',
  'designFiles.move': '이동',
  'designFiles.copyPath': '경로 복사',
  'designFiles.copiedPath': '경로가 복사됨',
  'designFiles.copyLocalPath': '로컬 파일 경로 복사',
  'designFiles.copiedLocalPath': '로컬 파일 경로가 복사됨',
  'designFiles.deleteFolderConfirm': '폴더 "{name}" 및 모든 내용을 삭제하시겠습니까?',
  'designFiles.folderCreated': '폴더 "{name}"이(가) 생성됨',
  'designFiles.folderDeleted': '폴더 "{name}"이(가) 삭제됨',
  'designFiles.filesMoved': '{n}개를 {dest}(으)로 이동함',
  'designFiles.colName': '이름',
  'designFiles.colKind': '종류',
  'designFiles.colModified': '수정일',
  'designFiles.perPage': '표시',
  'designFiles.all': '모두',
  'designFiles.prev': '이전',
  'designFiles.next': '다음',
  'designFiles.jumpToPage': '페이지로 이동',
  'designFiles.pageInfo': '{start}–{end} / {total}',
  'designFiles.sectionFolders': '폴더',
  'designFiles.sectionStylesheets': '스타일시트',
  'designFiles.sectionDocuments': '문서',
  'designFiles.kindStylesheet': '스타일시트',
  'designFiles.modifiedExt': '수정됨 {time} · {size} · {ext}',
  'designFiles.usefulInfoLabel': '유용한 정보',
  'designFiles.usefulInfoTip': '파일을 더블클릭하면 전체 탭에서 열립니다.',
  'designFiles.usefulInfoTip2': '채팅에서 @를 입력해 파일을 컨텍스트로 참조하세요.',
  'designFiles.usefulInfoTip4': '디자인 시스템을 선택하면 브랜드 스타일에 맞는 결과를 생성합니다.',
  'designFiles.usefulInfoTip5': '아이디어가 없다면 홈의 커뮤니티에서 플러그인 템플릿을 사용해 보세요.',
  'designFiles.usefulInfoTip6': '질문이나 제안이 있다면 Discord에서 함께 이야기해요.',
  'designFiles.usefulInfoTip7': '마음에 드셨다면 GitHub에서 스타를 눌러 주세요.',
  'designFiles.usefulInfoTip8': 'X에서 @OpenDesignHQ를 팔로우하고 최신 소식을 받아 보세요.',
  'designFiles.usefulInfoTip9': '이미지, 문서, 폴더째로 이 패널에 끌어다 놓으면 에이전트가 문맥으로 활용합니다.',
  'designFiles.usefulInfoTip10': '새 스케치로 레이아웃을 그리면 에이전트가 그대로 만들어 줍니다.',
  'designFiles.usefulInfoTip11': '미리보기에서 요소를 선택해 댓글을 남기면 에이전트가 해당 부분만 수정합니다.',
  'designFiles.usefulInfoTip12': '결과가 마음에 들지 않나요? 다시 설명하는 것보다 영역을 지정해 표시하는 편이 빠릅니다.',
  'designFiles.usefulInfoTip13': '디자인을 PDF, 이미지, 독립 HTML로 한 번에 내보낼 수 있습니다.',
  'designFiles.usefulInfoTip14': '마음에 드는 프로젝트는 공유 메뉴에서 템플릿으로 저장해 재사용하세요.',
  'designFiles.usefulInfoTip15': '배포 후에는 소셜 공유 카드를 바로 생성할 수 있습니다.',
  'designFiles.usefulInfoTip16': 'Threads에서 @opendesign.ai를 팔로우하고 비하인드 소식을 받아보세요.',
  'designFiles.usefulInfoTip17': 'Instagram에서 @opendesign.ai를 팔로우하고 디자인 영감을 얻으세요.',
  'designFiles.usefulInfoTip18': 'YouTube에서 Open Design을 구독하고 튜토리얼과 데모를 만나보세요.',
  'designFiles.usefulInfoTip19': 'LinkedIn에서 Open Design을 팔로우하고 제품 소식을 받아보세요.',
  'designFiles.usefulInfoTip20': 'Xiaohongshu에서 Open Design을 팔로우하고 팁과 영감을 얻으세요.',
  'quickSwitcher.placeholder': '파일 열기…',
  'quickSwitcher.empty': '이 프로젝트에 파일이 없습니다',
  'quickSwitcher.noMatches': '일치 항목 없음',
  'quickSwitcher.navigate': '탐색',
  'quickSwitcher.open': '열기',
  'quickSwitcher.close': '닫기',
  'pasteDialog.title': '텍스트 붙여넣기',
  'pasteDialog.hint': '프로젝트 폴더에 저장됩니다. 파일 이름을 지정하세요.',
  'pasteDialog.fileNameLabel': '파일 이름',
  'pasteDialog.namePlaceholder': 'notes.txt',
  'pasteDialog.contentLabel': '내용',
  'pasteDialog.contentPlaceholder': '여기에 내용을 붙여넣으세요…',
  'pasteDialog.save': '저장',
  'pasteDialog.cancel': '취소',
  'sketch.save': '스케치 저장',
  'sketch.cancel': '취소',
  'sketch.saving': '저장 중…',
  'sketch.saved': '저장됨',
  'sketch.tooltipMainMenu': '메인 메뉴: 저장, 내보내기, 도움말 및 캔버스 설정',
  'sketch.tooltipLock': "Keep the current drawing tool active for repeated use",
  'sketch.tooltipHand': "Pan the canvas without selecting objects",
  'sketch.tooltipSelection': "Select, move, resize, or edit objects on the canvas",
  'sketch.tooltipRectangle': "Draw a rectangle or card area",
  'sketch.tooltipDiamond': "Draw a diamond for decisions or branching structure",
  'sketch.tooltipEllipse': "Draw a circle or ellipse",
  'sketch.tooltipArrow': "Draw a directional connector or flow arrow",
  'sketch.tooltipLine': "Draw a straight divider or connector line",
  'sketch.tooltipFreedraw': "Draw freehand lines on the canvas",
  'sketch.tooltipText': "Add editable text to the canvas",
  'sketch.tooltipImage': "Insert an image into the canvas",
  'sketch.tooltipEraser': "Erase objects from the canvas",
  'sketch.tooltipFrame': "Create a frame to group a region of the canvas",
  'sketch.tooltipEmbeddable': "Web Embed only supports valid https:// or http:// links",
  'sketch.tooltipLaser': "Point at canvas content temporarily without changing it",
  'sketch.tooltipMoreTools': "Open additional tools such as frame, web embed, and laser pointer",
  'sketch.tooltipDirty': '저장되지 않은 변경 사항',
  'sketch.tooltipClean': '저장됨',
  'fileViewer.empty': '보려는 파일을 선택하세요.',
  'fileViewer.loading': '불러오는 중…',
  'fileViewer.exportPptx': 'PPTX로 내보내기',
  'fileViewer.openInNewTab': '새 탭에서 열기',
  'fileViewer.copyPath': '경로 복사',
  'fileViewer.copied': '복사 완료!',
  'fileViewer.share': '공유',
  'fileViewer.binaryMeta': '바이너리 · {size}',
  'fileViewer.binaryNote': '바이너리 파일 ({size} 바이트). 확인하려면 다운로드하거나 디스크에서 직접 여세요.',
  'fileViewer.pdfMeta': 'PDF 문서 · {size}',
  'fileViewer.documentMeta': '문서',
  'fileViewer.presentationMeta': '프레젠테이션',
  'fileViewer.spreadsheetMeta': '스프레드시트',
  'fileViewer.previewUnavailable': '미리보기를 제공할 수 없습니다. 파일을 확인하려면 다운로드하거나 직접 열어보세요.',
  'fileViewer.download': '다운로드',
  'fileViewer.open': '열기',
  'fileViewer.imageMeta': '이미지 · {size}',
  'fileViewer.reactMeta': 'React 컴포넌트 · {size}',
  'fileViewer.sketchMeta': '스케치 · {size}',
  'fileViewer.markdownStreamingMeta': '스트리밍 미리보기 중…',
  'fileViewer.markdownErrorMeta': '생성 오류로 인해 미리보기가 불완전할 수 있습니다.',
  'fileViewer.markdownStreamingStatus': '스트리밍 중… 일부 마크다운만 보입니다.',
  'fileViewer.markdownErrorStatus': '생성 오류가 발생했습니다. 이용 가능한 마지막 내용만 표시합니다.',
  'fileViewer.markdownSaving': "Saving...",
  'fileViewer.markdownSaveFailed': "Save failed",
  'fileViewer.markdownSaved': "Saved",
  'fileViewer.markdownAutoSaved': "Auto-saved · {time}",
  'fileViewer.markdownAutoSaveHint': "Auto-save on",
  'fileViewer.markdownViewMode': "Markdown view mode",
  'fileViewer.split': "Split",
  'fileViewer.markdownEditor': "Markdown editor",
  'fileViewer.markdownEditorPlaceholder': "Type notes, requirements, or instructions for this document...",
  'fileViewer.markdownPreview': "Markdown preview",
  'fileViewer.videoMeta': '비디오 · {size}',
  'fileViewer.audioMeta': '오디오 · {size}',
  'fileViewer.reload': '새로고침',
  'fileViewer.reloadDisk': '디스크에서 새로고침',
  'fileViewer.copy': '복사',
  'fileViewer.copyTitle': '파일 내용 복사',
  'fileViewer.saveDisabled': '저장 (읽기 전용)',
  'fileViewer.save': '저장',
  'fileViewer.preview': '미리보기',
  'fileViewer.source': '소스 코드',
  'fileViewer.tweaks': '조정 (Tweaks)',
  'fileViewer.tweaksUnavailable': '이 아티팩트에 조정 패널이 없습니다',
  'fileViewer.jsxModuleTitle': '독립 미리보기 없음',
  'fileViewer.jsxModuleBody': '이 파일은 다른 페이지에서 불러오는 컴포넌트 모듈입니다.',
  'fileViewer.jsxModuleCta': '이 파일을 렌더링하는 페이지를 여세요:',
  'fileViewer.comment': '댓글',
  'fileViewer.edit': '편집',
  'fileViewer.draw': '그리기',
  'fileViewer.mark': '표시',
  'fileViewer.markTool': '표시 도구',
  'fileViewer.boxSelect': '영역 선택',
  'fileViewer.textTool': '텍스트',
  'fileViewer.textAnnotationRemove': '텍스트 삭제',
  'fileViewer.screenshot': '스크린샷',
  'fileViewer.versions.entry': '버전',
  'fileViewer.versions.title': '버전',
  'fileViewer.versions.countOne': '버전 1개',
  'fileViewer.versions.countMany': '버전 {count}개',
  'fileViewer.versions.current': '현재',
  'fileViewer.versions.sourceAi': 'AI edit',
  'fileViewer.versions.sourceManual': 'Manual edit',
  'fileViewer.versions.sourceRestore': 'Restored',
  'fileViewer.versions.restoredFrom': 'Restored from v{version}',
  'fileViewer.versions.versionLabel': '버전 {version}',
  'fileViewer.versions.listAria': '파일 버전',
  'fileViewer.versions.loading': '버전을 불러오는 중...',
  'fileViewer.versions.empty': '아직 버전이 없습니다.',
  'fileViewer.versions.loadFailed': '버전을 불러오지 못했습니다.',
  'fileViewer.versions.previewFailed': '이 버전 미리보기를 불러오지 못했습니다.',
  'fileViewer.versions.previewLoading': '버전 미리보기를 불러오는 중...',
  'fileViewer.versions.noPrompt': '기록된 프롬프트 없음',
  'fileViewer.versions.noPromptBody': '이 버전에는 프롬프트가 기록되지 않았습니다.',
  'fileViewer.versions.promptTitle': '프롬프트',
  'fileViewer.versions.copyPrompt': '프롬프트 복사',
  'fileViewer.versions.fullscreen': '전체 화면 미리보기',
  'fileViewer.versions.open': '미리보기 열기',
  'fileViewer.versions.currentHelp': '이미 현재 버전입니다.',
  'fileViewer.versions.restoreHelp': '전환하면 이 HTML이 새로운 현재 버전으로 복원됩니다.',
  'fileViewer.versions.restore': '이 버전으로 전환',
  'fileViewer.versions.restoreConfirmTitle': '이 버전으로 전환할까요?',
  'fileViewer.versions.restoreConfirmCta': '전환',
  'fileViewer.versions.restoring': '전환 중...',
  'fileViewer.versions.restoreFailed': '이 버전으로 전환하지 못했습니다.',
  'fileViewer.versions.restoreSuccess': '이 버전으로 전환했습니다.',
  'manualEdit.layers': '레이어',
  'manualEdit.editableCount': '{count}개 편집 가능',
  'manualEdit.hiddenBadge': '숨김',
  'manualEdit.title': '수동 편집기',
  'manualEdit.fallbackTitle': '편집',
  'manualEdit.movePanel': '편집 패널 이동',
  'manualEdit.editParams': '매개변수 편집',
  'manualEdit.closePanel': '편집 패널 닫기',
  'manualEdit.selectLayer': '레이어 선택',
  'manualEdit.empty': '미리보기에서 요소를 클릭하거나 레이어를 선택하세요.',
  'manualEdit.noEditableLayers': '편집 가능한 레이어가 없습니다.',
  'manualEdit.noClass': '클래스 없음',
  'manualEdit.tabsAria': '수동 편집 탭',
  'manualEdit.tabContent': '콘텐츠',
  'manualEdit.tabStyle': '스타일',
  'manualEdit.tabAttributes': '속성',
  'manualEdit.tabHtml': 'Html',
  'manualEdit.tabSource': '소스',
  'manualEdit.attributesJson': '속성 JSON',
  'manualEdit.selectedHtml': '선택한 요소 HTML',
  'manualEdit.fullSource': '전체 아티팩트 소스',
  'manualEdit.applyContent': '콘텐츠 적용',
  'manualEdit.applyStyle': '스타일 적용',
  'manualEdit.applyAttributes': '속성 적용',
  'manualEdit.applyHtml': 'HTML 적용',
  'manualEdit.applySource': '소스 적용',
  'manualEdit.invalidAttributes': '유효하지 않은 속성 JSON입니다.',
  'manualEdit.changes': '변경 사항',
  'manualEdit.undo': '실행 취소',
  'manualEdit.redo': '다시 실행',
  'manualEdit.noChanges': '아직 수동 편집이 없습니다.',
  'manualEdit.imageUrl': '이미지 URL',
  'manualEdit.altText': '대체 텍스트',
  'manualEdit.label': '레이블',
  'manualEdit.text': '텍스트',
  'manualEdit.href': 'Href',
  'manualEdit.textColor': '텍스트 색상',
  'manualEdit.background': '배경',
  'manualEdit.fontSize': '글꼴 크기',
  'manualEdit.weight': '굵기',
  'manualEdit.align': '정렬',
  'manualEdit.padding': '안쪽 여백',
  'manualEdit.margin': '바깥쪽 여백',
  'manualEdit.radius': '모서리 둥글기',
  'manualEdit.border': '테두리',
  'manualEdit.width': '너비',
  'manualEdit.minHeight': '최소 높이',
  'manualEdit.deleteElement': '요소 삭제',
  'manualEdit.deleteElementConfirm': '선택한 요소를 삭제할까요? 실행 취소로 되돌릴 수 있습니다.',
  'manualEdit.uploadImage': '이미지 업로드',
  'manualEdit.uploadingImage': '이미지 업로드 중…',
  'manualEdit.uploadImageFailed': '이미지를 업로드할 수 없습니다.',
  'manualEdit.focusSlides': '슬라이드에 집중',
  'manualEdit.showPanels': '패널 표시',
  'fileViewer.zoomOut': '축소',
  'fileViewer.zoomIn': '확대',
  'fileViewer.resetZoom': '배율 초기화',
  'fileViewer.viewportAria': '미리보기 뷰포트',
  'fileViewer.viewportDesktop': '데스크톱',
  'fileViewer.viewportDesktopTitle': '전체 너비 데스크톱 미리보기',
  'fileViewer.viewportTablet': '태블릿',
  'fileViewer.viewportTabletTitle': '820 × 1180 태블릿 미리보기 (최신 세로 기준)',
  'fileViewer.viewportMobile': '모바일',
  'fileViewer.viewportMobileTitle': '390 × 844 모바일 미리보기',
  'fileViewer.reloadAria': '새로고침',
  'fileViewer.previousSlide': '이전 슬라이드',
  'fileViewer.nextSlide': '다음 슬라이드',
  'fileViewer.slideNavAria': '슬라이드 이동',
  'fileViewer.speakerNotes': '발표자 노트',
  'fileViewer.speakerNotesSlide': '슬라이드 {current} / {total}',
  'fileViewer.speakerNotesEmpty': '이 슬라이드에는 발표자 노트가 없습니다.',
  'fileViewer.speakerNotesEdit': '편집',
  'fileViewer.speakerNotesSave': '노트 저장',
  'fileViewer.speakerNotesSaving': '저장 중…',
  'fileViewer.speakerNotesSaved': '저장됨',
  'fileViewer.speakerNotesSaveFailed': '발표자 노트를 저장하지 못했습니다.',
  'fileViewer.speakerNotesPlaceholder': '이 슬라이드의 발표자 노트를 추가하세요…',
  'fileViewer.presenterReset': '초기화',
  'fileViewer.present': '프레젠테이션',
  'fileViewer.presentInTab': '현재 탭에서',
  'fileViewer.presentFullscreen': '전체 화면',
  'fileViewer.presentNewTab': '새 탭에서',
  'fileViewer.exitPresentation': '프레젠테이션 종료',
  'fileViewer.shareLabel': '공유',
  'fileViewer.shareMenuShareLink': '공유',
  'fileViewer.shareMenuPublishOnline': '온라인 게시',
  'fileViewer.shareMenuDownload': '다운로드',
  'fileViewer.shareMenuPresentation': '프레젠테이션',
  'fileViewer.shareMenuSourceFiles': '소스 파일',
  'fileViewer.shareMenuSave': '저장',
  'fileViewer.copyShareLink': '공유 링크 복사',
  'fileViewer.openSharePage': '공유 페이지 열기',
  'fileViewer.shareLinkRequiresDeploy': '링크를 받으려면 먼저 온라인에 게시하세요',
  'fileViewer.shareLinkPublishGuide': '위에서 온라인에 게시하면 공유할 수 있습니다 ↑',
  'fileViewer.shareAfterGenerationComplete': '생성이 완료되면 공유할 수 있습니다',
  'fileViewer.copyProviderLink': '{provider} 링크 복사',
  'fileViewer.copyCloudflareLink': 'Cloudflare 링크 복사',
  'fileViewer.screenshotCopying': '스크린샷 복사 중...',
  'fileViewer.screenshotCopied': '스크린샷이 클립보드에 복사되었습니다',
  'fileViewer.screenshotClipboardDenied': '브라우저가 클립보드 접근을 차단했습니다',
  'fileViewer.screenshotPreviewLoading': '미리보기를 아직 불러오는 중입니다. 잠시 후 다시 시도하세요.',
  'fileViewer.screenshotCaptureFailed': '미리보기를 캡처할 수 없습니다. 다시 시도해 주세요.',
  'fileViewer.exportPdf': 'PDF로 내보내기',
  'fileViewer.exportPdfAllSlides': 'PDF로 내보내기 (모든 슬라이드)',
  'fileViewer.exportPptxBusy': '현재 작업이 끝날 때까지 기다려 주세요.',
  'fileViewer.exportPptxHint': '이 디자인을 PPTX로 변환하도록 에이전트에 요청합니다.',
  'fileViewer.exportPptxNa': '이곳에서는 PPTX 내보내기를 할 수 없습니다.',
  'fileViewer.exportZip': '.zip으로 다운로드',
  'fileViewer.exportHtml': '독립 실행형 HTML로 내보내기',
  'fileViewer.exportMd': 'Markdown으로 내보내기',
  'fileViewer.exportImage': '이미지로 내보내기',
  'fileViewer.exportPptxImages': 'PPTX(이미지)로 내보내기',
  'fileViewer.exportPptxEditable': 'PPTX(편집 가능)로 내보내기',
  'fileViewer.exportPptxEditableHint': 'Native editable shapes & text (not pixel-perfect)',
  'fileViewer.exportPptxModalSubtitle': "Choose how to export, then download.",
  'fileViewer.exportPptxScreenshot': "Screenshot PPTX",
  'fileViewer.exportPptxScreenshotHint': "One image per slide — pixel-perfect, but not editable.",
  'fileViewer.exportPptxConfirm': "Export",
  'fileViewer.exportPptxRecommended': "Recommended",
  'fileViewer.exportingProgress': '내보내는 중…',
  'fileViewer.exportSlideProgress': '슬라이드 {current}/{total} 내보내는 중…',
  'fileViewer.exportingElapsed': '내보내는 중… {seconds}초',
  'fileViewer.exportSlideEta': '슬라이드 {current}/{total} 내보내는 중 · 약 {seconds}초 남음',
  'fileViewer.exportFailed': '내보내기에 실패했습니다. 다시 시도해 주세요.',
  'fileViewer.exportDone': '내보내기 완료',
  'fileViewer.exportImageFailed': '이미지 캡처에 실패했습니다. 다시 시도하거나 브라우저의 스크린샷 도구를 사용하세요.',
  'fileViewer.exportImageModalSubtitle': '형식을 선택한 다음 현재 미리보기를 이미지로 다운로드합니다.',
  'fileViewer.exportImageFormatLabel': '형식',
  'fileViewer.exportImageSaving': '이미지 저장 중…',
  'fileViewer.exportImageSaved': '이미지가 저장되었습니다',
  'fileViewer.exportImageDownloadStarted': '다운로드가 시작되었습니다',
  'fileViewer.exportImageDownloadDetails': '다른 이름으로 저장 창이 나타나지 않았다면 브라우저 다운로드 폴더에서 {filename}을 확인하세요.',
  'fileViewer.exportJsx': 'JSX로 내보내기',
  'fileViewer.exportReactHtml': '미리보기를 HTML로 내보내기',
  'fileViewer.exportStarted': '내보내기를 시작했습니다',
  'fileViewer.saveAsTemplate': '템플릿으로 저장…',
  'fileViewer.savingTemplate': '템플릿 저장 중…',
  'fileViewer.savedTemplate': '"{name}"(으)로 저장됨',
  'fileViewer.savedTemplateFail': '템플릿 저장에 실패했습니다. 다시 시도해 주세요.',
  'fileViewer.templateNamePrompt': '템플릿 이름',
  'fileViewer.templateNameDefault': '제목 없는 템플릿',
  'fileViewer.templateDescPrompt': '간단한 설명 (선택 사항 — 이 템플릿의 용도나 특징이 무엇인가요?)',
  'liveArtifact.refresh.button': '새로 고침',
  'liveArtifact.refresh.buttonTitle': '이 라이브 아티팩트 새로 고침',
  'liveArtifact.refresh.loadingTitle': '라이브 아티팩트 로딩 중…',
  'liveArtifact.refresh.noSourceTitle': '아직 사용 가능한 새로 고침 소스가 없습니다.',
  'liveArtifact.refresh.running': '새로고침 중…',
  'liveArtifact.refresh.runningMessage': '데이터와 미리보기를 새로 고치는 중입니다. 잠시 걸릴 수 있습니다.',
  'liveArtifact.refresh.runningAction': '새로 고침이 성공할 때까지 이전 미리보기가 계속 표시됩니다.',
  'liveArtifact.refresh.successOne': '새로 고침이 완료되었습니다. 데이터가 업데이트되었습니다.',
  'liveArtifact.refresh.successMany': '새로 고침이 완료되었습니다. 데이터가 업데이트되었습니다.',
  'liveArtifact.refresh.successAction': '미리보기가 가장 최근 커밋된 데이터로 다시 로드되었습니다.',
  'liveArtifact.refresh.previousFailure': '이전 새로 고침 실패: {message}',
  'liveArtifact.refresh.failureAction': '새로 고침 기록을 확인하고 소스 또는 권한 문제를 해결한 후 다시 시도하세요.',
  'liveArtifact.refresh.networkFailure': '새로 고침 요청에 실패했습니다. 연결을 확인하고 다시 시도하세요.',
  'liveArtifact.refresh.genericFailure': '새로 고침에 실패했습니다.',
  'liveArtifact.refresh.statusNever': '새로 고칠 수 없음',
  'liveArtifact.refresh.statusReady': '새로 고칠 준비됨',
  'liveArtifact.refresh.statusSucceeded': '최신 상태',
  'liveArtifact.refresh.statusFailed': '새로 고침 실패',
  'liveArtifact.refresh.statusRunning': '새로 고치는 중',
  'liveArtifact.refresh.statusRunningDescription': '새로 고침 작업이 현재 진행 중입니다.',
  'liveArtifact.refresh.statusSucceededDescription': '마지막 새로 고침이 성공적으로 완료되었습니다.',
  'liveArtifact.refresh.statusFailedDescription': '마지막 새로 고침 시도가 성공적으로 완료되지 않았습니다.',
  'liveArtifact.refresh.statusReadyDescription': '새로 고칠 수 있는 소스가 구성되어 있지만 진행 중인 작업이 없습니다.',
  'liveArtifact.refresh.statusNeverDescription': '이 라이브 아티팩트에는 아직 새로 고침 소스가 없습니다.',
  'liveArtifact.refresh.eventStarted': '시작됨',
  'liveArtifact.refresh.eventSucceeded': '성공함',
  'liveArtifact.refresh.eventFailed': '실패함',
  'liveArtifact.refresh.eventStartedDetail': '새로고침 시작됨…',
  'liveArtifact.refresh.sourcesUpdatedOne': '소스 {n}개 업데이트됨',
  'liveArtifact.refresh.sourcesUpdatedMany': '소스 {n}개 업데이트됨',
  'liveArtifact.refresh.timelineEmpty': '이 세션에서 아직 새로 고침 활동이 없습니다. 새로 고침을 실행하여 타임라인을 기록하거나 자동 실행을 기다리세요.',
  'liveArtifact.refresh.heroLastRefreshedLabel': '마지막 새로 고침',
  'liveArtifact.refresh.heroLastRefreshedNever': '없음',
  'liveArtifact.refresh.justNow': '방금 전',
  'liveArtifact.refresh.factCreated': '생성됨',
  'liveArtifact.refresh.factLastUpdated': '마지막 업데이트',
  'liveArtifact.refresh.factUnknown': '알 수 없음',
  'liveArtifact.refresh.persistedTitle': '저장된 새로 고침 기록',
  'liveArtifact.refresh.persistedHint': 'refreshes.jsonl에서 불러온 항목',
  'liveArtifact.refresh.persistedEmpty': '저장된 새로 고침 기록이 아직 없습니다.',
  'liveArtifact.refresh.persistedStatusSucceeded': '성공함',
  'liveArtifact.refresh.persistedStatusRunning': '실행 중',
  'liveArtifact.refresh.persistedStatusFailed': '실패함',
  'liveArtifact.refresh.persistedStatusCancelled': '취소됨',
  'liveArtifact.refresh.persistedStatusSkipped': '건너뜀',
  'liveArtifact.refresh.sessionTitle': '세션 활동',
  'liveArtifact.refresh.sessionHint': '이 탭이 열려 있는 동안 관찰된 이벤트',
  'liveArtifact.refresh.docSourceTitle': '문서 소스',
  'liveArtifact.refresh.docSourceHint': '소스 구성됨',
  'liveArtifact.refresh.docSourceType': '유형',
  'liveArtifact.refresh.docSourceTool': '도구',
  'liveArtifact.refresh.docSourceConnector': '커넥터',
  'liveArtifact.refresh.debugSummary': '고급 디버그 메타데이터',
  'liveArtifact.refresh.debugNote': '커넥터 ID, 파일 이름, 소스 메타데이터 및 내부 아티팩트 경로가 포함될 수 있습니다.',
  'liveArtifact.viewer.tabPreview': '미리보기',
  'liveArtifact.viewer.tabCode': '코드',
  'liveArtifact.viewer.tabData': '데이터',
  'liveArtifact.viewer.tabRefreshHistory': '새로고침 기록',
  'liveArtifact.viewer.dataEmpty': '사용 가능한 data.json 캐시가 없습니다.',
  'liveArtifact.viewer.code.templateHeading': '템플릿 HTML',
  'liveArtifact.viewer.code.renderedHeading': '렌더링된 HTML',
  'liveArtifact.viewer.code.templateHelp': 'data.json과 함께 미리보기를 생성하는 데 사용되는 편집 가능한 템플릿입니다.',
  'liveArtifact.viewer.code.renderedHelp': '미리보기가 현재 로드한 생성된 index.html입니다.',
  'liveArtifact.viewer.code.variantAria': '코드 변형',
  'liveArtifact.viewer.code.variantTemplate': '템플릿',
  'liveArtifact.viewer.code.variantRendered': '렌더링됨',
  'liveArtifact.viewer.code.loading': '코드 로드 중…',
  'liveArtifact.viewer.code.unavailable': '아직 코드를 사용할 수 없습니다.',
  'liveArtifact.viewer.code.empty': '이 코드 파일은 비어 있습니다.',
  'fileViewer.deployToVercel': 'Vercel에 배포',
  'fileViewer.redeployToVercel': '다시 배포',
  'fileViewer.deployingToVercel': 'Vercel에 배포 중…',
  'fileViewer.deployProviderLabel': '배포 플랫폼',
  'fileViewer.vercelProvider': 'Vercel',
  'fileViewer.cloudflarePagesProvider': 'Cloudflare Pages',
  'fileViewer.deployToProvider': '{provider}에 배포',
  'fileViewer.redeployToProvider': '{provider}에 다시 배포',
  'fileViewer.deployingToProvider': '{provider}에 배포 중…',
  'fileViewer.preparingPublicLink': '공개 링크 준비 중…',
  'fileViewer.copyDeployLink': '링크 복사',
  'fileViewer.deployModalTitle': '배포',
  'fileViewer.deployModalSubtitle': '선택한 플랫폼 계정으로 이 HTML 미리보기를 배포합니다.',
  'fileViewer.vercelToken': 'Vercel 토큰',
  'fileViewer.vercelTokenGetLink': 'Vercel 토큰 발급 받기',
  'fileViewer.vercelTokenPlaceholder': 'Vercel 토큰을 붙여넣으세요',
  'fileViewer.vercelTokenReuseHint': '저장된 토큰이 사용됩니다. 변경하려면 새 토큰을 입력하세요.',
  'fileViewer.vercelTokenRequired': '먼저 Vercel 토큰을 입력하고 저장하세요.',
  'fileViewer.cloudflareApiToken': 'Cloudflare API 토큰',
  'fileViewer.cloudflareApiTokenGetLink': 'API 토큰 받기',
  'fileViewer.cloudflareApiTokenPlaceholder': 'Cloudflare API 토큰을 붙여넣으세요',
  'fileViewer.cloudflareApiTokenReuseHint': '저장된 Cloudflare API 토큰이 사용됩니다. 변경하려면 새 토큰을 입력하세요.',
  'fileViewer.cloudflareApiTokenRequired': '먼저 Cloudflare API 토큰을 입력하고 저장하세요.',
  'fileViewer.cloudflareApiTokenScopeHint': 'API 토큰을 만들 때 Pages Edit를 선택하세요. 사용자 지정 도메인에는 Zone Read / DNS Edit가 필요합니다.',
  'fileViewer.vercelTeamId': '팀 ID (Team ID)',
  'fileViewer.vercelTeamSlug': '팀 슬러그 (Team slug)',
  'fileViewer.cloudflareAccountId': '계정 ID',
  'fileViewer.cloudflareAccountIdHint': 'Cloudflare 대시보드에서 계정 ID를 확인하세요.',
  'fileViewer.cloudflareAccountIdRequired': '먼저 Cloudflare Account ID를 입력하고 저장하세요.',
  'fileViewer.cloudflareZoneLabel': '도메인',
  'fileViewer.cloudflareZonePlaceholder': '도메인을 불러오려면 Cloudflare 설정을 저장하세요',
  'fileViewer.cloudflareZoneRequired': '먼저 Cloudflare 도메인을 선택하세요.',
  'fileViewer.cloudflareZonesLoading': 'Cloudflare 도메인 로딩 중…',
  'fileViewer.cloudflareZonesRefresh': '도메인 새로 고침',
  'fileViewer.cloudflareZonesLoadFailed': 'Cloudflare 도메인을 불러올 수 없습니다.',
  'fileViewer.cloudflareZonesEmpty': '이 계정에 대해 활성화된 전체 Cloudflare 도메인을 찾을 수 없습니다.',
  'fileViewer.cloudflareDomainPrefixLabel': '하위 도메인 접두사',
  'fileViewer.cloudflareDomainPrefixPlaceholder': 'demo',
  'fileViewer.cloudflareDomainPrefixInvalid': '하나의 DNS 레이블만 사용하세요: 소문자, 숫자, 하이픈.',
  'fileViewer.cloudflareHostnamePreview': '사용자 지정 도메인 미리 보기: {hostname}',
  'fileViewer.cloudflareCustomDomainHint': '선택 사항: 사용자 지정 도메인을 연결합니다. 비워 두어도 pages.dev 링크가 생성됩니다.',
  'fileViewer.cloudflarePagesDevLinkLabel': 'pages.dev URL',
  'fileViewer.cloudflareCustomDomainLinkLabel': '사용자 지정 도메인',
  'fileViewer.optional': '선택 사항',
  'fileViewer.vercelPreviewOnly': '현재 배포는 Preview 모드만 지원합니다.',
  'fileViewer.cloudflarePagesPreviewHint': 'Cloudflare Pages 배포는 Direct Upload를 사용합니다.',
  'fileViewer.savingConfig': '설정 저장 중…',
  'fileViewer.deployConfigSaveFailed': 'Vercel 설정을 저장하지 못했습니다.',
  'fileViewer.deployFailed': '배포 실패. Vercel 설정을 확인하고 다시 시도해 주세요.',
  'fileViewer.deployProviderConfigSaveFailed': '{provider} 설정을 저장하지 못했습니다.',
  'fileViewer.deployProviderFailed': '{provider} 배포에 실패했습니다. 설정을 확인하고 다시 시도해 주세요.',
  'fileViewer.deployResultLabel': '배포된 URL',
  'fileViewer.deployLinkReady': '준비됨',
  'fileViewer.deploySuccessToast': '배포가 정상적으로 업로드되었습니다',
  'fileViewer.deploySuccessToastDetails': '{provider} · {url}',
  'fileViewer.deployLinkPreparingLabel': '공개 링크 보류 중',
  'fileViewer.deployLinkDelayed': '사이트가 배포되었습니다. 플랫폼에서 공개 링크를 아직 준비 중입니다.',
  'fileViewer.deployLinkFailed': '사용자 지정 도메인 실패',
  'fileViewer.deployLinkProtectedLabel': '배포 보호가 활성화됨',
  'fileViewer.deployLinkProtected': '사이트가 배포되었지만 이 미리보기 링크에는 인증이 필요합니다. Deployment Protection을 끄거나 사용자 지정 도메인을 사용하세요.',
  'fileViewer.retryLink': '지금 다시 시도',
  'questionForm.submit': '제출',
  'questionForm.skip': '건너뛰기',
  'questionForm.locked': '답변됨',
  'conv.switch': '대화 전환',
  'conv.label': '대화',
  'conv.heading': '대화 목록',
  'conv.new': '+ 새 대화',
  'conv.empty': '아직 대화가 없습니다.',
  'conv.untitled': '제목 없는 대화',
  'conv.renameTooltip': '더블 클릭하여 이름 변경',
  'conv.delete': '대화 삭제',
  'conv.deleteConfirm': '"{title}" 대화를 삭제하시겠습니까? 관련 메시지도 함께 삭제됩니다.',
  'agentPicker.label': '에이전트',
  'agentPicker.modeChoose': '실행 모드 선택',
  'agentPicker.localCli': '로컬 CLI',
  'agentPicker.daemonOff': '데몬 꺼짐',
  'agentPicker.byok': 'API · BYOK',
  'agentPicker.selectAgent': '감지된 코드 에이전트 CLI 선택',
  'agentPicker.noAgents': 'PATH에서 에이전트를 찾을 수 없음',
  'agentPicker.notInstalled': '설치되지 않음',
  'agentPicker.rescan': '로컬 PATH에서 에이전트 다시 스캔',
  'tool.openInTab': '탭에서 {name} 열기',
  'tool.open': '열기',
  'tool.todos': '할 일 (Todos)',
  'tool.todosExpand': '할 일 표시',
  'tool.todosCollapse': '할 일 숨기기',
  'tool.todosDone': '완료',
  'tool.todosDismiss': '할 일 목록 닫기',
  'tool.write': '작성 (Write)',
  'tool.edit': '편집 (Edit)',
  'tool.read': '읽기 (Read)',
  'tool.delete': '삭제',
  'tool.bash': '명령어 (Bash)',
  'tool.glob': '검색 (Glob)',
  'tool.grep': '검색 (Grep)',
  'tool.fetch': '가져오기 (Fetch)',
  'tool.search': '검색 (Search)',
  'tool.lines': '{n} 줄',
  'tool.changeSingular': '변경',
  'tool.changePlural': '변경',
  'tool.in': '경로: {path}',
  'tool.hide': '숨기기',
  'tool.output': '출력',
  'tool.running': '실행 중…',
  'tool.error': '오류',
  'tool.done': '완료',
  'assistant.role': '어시스턴트 (Assistant)',
  'assistant.workingLabel': '작업 중',
  'assistant.doneLabel': '완료됨',
  'assistant.copyMarkdown': '응답 Markdown 복사',
  'assistant.forkConversation': '여기서 포크',
  'assistant.forkingConversation': '포크 중…',
  'assistant.shareToOpenDesign': 'Open Design에 공유',
  'assistant.shareToOpenDesignBusy': '패키지 준비 중…',
  'assistant.feedbackPrompt': '피드백',
  'assistant.feedbackPositive': '도움 됨',
  'assistant.feedbackNegative': '도움 안 됨',
  'assistant.feedbackReasonTitle': '이유를 알려주세요',
  'assistant.feedbackReasonPositiveMatched': '내 요청을 이해함',
  'assistant.feedbackReasonPositiveVisual': '좋아 보임',
  'assistant.feedbackReasonPositiveUseful': '유용한 구조',
  'assistant.feedbackReasonPositiveEasy': '계속 편집하기 쉬움',
  'assistant.feedbackReasonPositiveDesignSystem': '디자인 시스템을 따름',
  'assistant.feedbackReasonNegativeMissed': '내 요청을 놓침',
  'assistant.feedbackReasonNegativeVisual': '시각적 품질 개선이 필요함',
  'assistant.feedbackReasonNegativeIncomplete': '불완전한 출력',
  'assistant.feedbackReasonNegativeHard': '사용하기 어려움',
  'assistant.feedbackReasonNegativeDesignSystem': '디자인 시스템을 따르지 않음',
  'assistant.feedbackReasonOther': '기타',
  'assistant.feedbackReasonPlaceholder': '간단한 메모 추가...',
  'assistant.feedbackReasonSubmit': '제출',
  'assistant.emptyResponseLabel': '출력 없음',
  'assistant.emptyResponseMessage': '제공자가 텍스트나 아티팩트를 반환하지 않고 요청을 종료했습니다. 다른 모델이나 제공자를 사용하거나, 할당량을 확인하거나, 다시 시도하세요.',
  'assistant.unfinishedLabel': '작업을 마치지 못하고 중지됨',
  'assistant.unfinishedSummary': '{n}개 작업 남음',
  'assistant.unfinishedMore': '+{n}개 추가',
  'assistant.continueRemaining': '남은 작업 계속하기',
  'chat.resumeRunCta': '실행 계속하기',
  'assistant.outTokens': '{n} 출력',
  'assistant.producedFiles': '이 턴에서 생성된 파일',
  'assistant.openFile': '열기',
  'assistant.downloadFile': '다운로드',
  'nextStep.title': '다음 단계',
  'nextStep.more': '더 보기',
  'nextStep.share': '공유',
  'nextStep.download': '다운로드',
  'nextStep.createDesignSystemTitle': 'Create design system',
  'nextStep.createDesignSystemBody': 'Duplicate this project into a design-system workspace and start an agent pass from all current files and references.',
  'nextStep.createDesignSystemBusy': 'Creating design system...',
  'nextStep.contribute': '커뮤니티 기여',
  'nextStep.planGenerateTitle': "Generate from document",
  'nextStep.planGenerateBody': "Use the approved Markdown plan as the source of truth for the next design run.",
  'nextStep.planImproveTitle': "Improve document",
  'nextStep.planImproveBody': "Tighten the current plan document before generating the final artifact.",
  'nextStep.planGeneratePrompt': "Use `{file}` as the source of truth. Read the document first, preserve its decisions, then generate the final design artifact that matches it. If it is a slide outline, generate the deck; if it is a PRD/prototype plan, generate the prototype or wireframes; if it is a storyboard/creative brief, generate the matching visual/media artifact. Before generating, call out any blocking TODOs or contradictions you cannot resolve.",
  'nextStep.planImprovePrompt': "Read `{file}` and improve it in place as an editable plan document. Tighten scope, fill weak sections, add missing acceptance checks, and keep TODO/open questions where user input is still needed. Do not generate the final design artifact yet.",
  'nextStep.planImproveArtifactTitle': "Improve artifact",
  'nextStep.planImproveArtifactBody': "Keep iterating the generated artifact instead of going back to planning.",
  'nextStep.planImproveArtifactPrompt': "Improve `{artifact}` in place. Keep the existing working artifact and make the highest-impact product, visual, interaction, and content improvements. Preserve behavior that already works, then summarize changed files and any remaining risks.",
  'nextStep.planMergeTitle': "Align document and artifact",
  'nextStep.planMergeBody': "Reconcile the plan and generated artifact so they advance together.",
  'nextStep.planMergePrompt': "Read `{document}` and `{artifact}` together. Treat the document as the intent and the artifact as the current implementation. Reconcile them: update the artifact to match confirmed decisions, update the document only where it is stale, and keep explicit TODO/open questions for anything still unresolved. Preserve existing working behavior and summarize what changed in both files.",

  'nextStep.projectContinueTitle': 'Continue working',
  'nextStep.projectGenerateArtifactTitle': 'Generate artifact',
  'nextStep.designSystemAiRefineTitle': 'AI refine design system',
  'nextStep.designSystemAuditKitTitle': 'Audit tokens & kit',

  'nextStep.brandAiOptimizeTitle': 'Refine extracted design system',
  'nextStep.brandAiOptimizeBody': 'Starts an agent pass that consumes model tokens, re-extracts the source, and updates this design system in place.',
  'nextStep.brandCreateDesignTitle': 'Create with this design system',
  'nextStep.brandCreateDesignBody': 'Start a new design using the extracted colors, type, assets, and system guidance.',
  'nextStep.brandCreateDesignPrompt': 'Create a new design with the {designSystem} design system.',

  'nextStep.brandContinueExtractionTitle': 'Continue extraction',
  'nextStep.brandContinueExtractionBody': 'After the Browser tab is past any verification, read it and keep filling the saved kit.',
  'nextStep.brandContinueExtractionBusy': 'Continuing extraction...',
  'nextStep.brandContinueAiExtractionTitle': 'Continue with agent',
  'nextStep.brandContinueAiExtractionProgrammaticBody': 'Use the selected agent to extract from the saved draft if the programmatic pass still cannot finish.',
  'nextStep.brandContinueAiExtractionAiBody': 'Resume the selected agent from the current brand scaffold and finish the same design system.',
  'nextStep.brandContinueAiExtractionBusy': 'Continuing with agent...',
  'nextStep.createDesignBusy': '디자인 생성 중...',
  'assistant.thinking': '생각 중 (Thinking)',
  'assistant.thought': '생각 완료',
  'assistant.thoughtFor': '{s}초 동안 생각함',
  'assistant.systemReminder': '시스템 알림',
  'assistant.possiblePromptInjection': '프롬프트 인젝션 가능성',
  'assistant.waitingFirstOutput': '첫 번째 출력 대기 중',
  'assistant.statusBootingAgent': '에이전트 부팅 중',
  'assistant.statusPreparing': '준비 중...',
  'assistant.statusStarting': '시작 중',
  'assistant.statusRequesting': '요청 전송 중',
  'assistant.statusThinking': '생각 중',
  'assistant.statusStreaming': '스트리밍 중',
  'assistant.slowHint': '평소보다 오래 걸립니다. 5-10초 후에도 양식이 나타나지 않으면, 중지(Stop)를 누르고 질문을 다시 작성해 보세요.',
  'assistant.verbEditing': '편집 중',
  'assistant.verbWriting': '작성 중',
  'assistant.verbReading': '읽는 중',
  'assistant.verbSearching': '검색 중',
  'assistant.verbRunning': '실행 중',
  'assistant.verbTodos': '할 일 목록',
  'assistant.verbFetching': '가져오는 중',
  'assistant.verbCalling': '호출 중',
  'qf.answered': '답변 완료',
  'qf.choose': '선택하세요…',
  'qf.customLabel': 'Custom answer',
  'qf.customPlaceholder': 'Type your own answer...',
  'qf.required': '필수',
  'qf.lockedSubmitted': '답변이 전송되었습니다 — 에이전트가 이 답변을 활용하여 남은 세션을 진행합니다.',
  'qf.lockedPrev': '이전에 완료된 턴의 양식입니다.',
  'qf.hint': '적절한 항목을 선택하세요. 관심 없는 선택 항목은 건너뛰어도 좋습니다 — 에이전트가 알아서 기본값을 적용합니다.',
  'qf.submitDefault': '답변 전송',
  'qf.submitDisabledTitle': '필수 항목을 모두 채워주세요',
  'qf.submitTitle': '답변 전송',
  'qf.cardSelected': '선택됨',
  'qf.cardRefs': '참조:',
  'qf.cardSampleText': '다람쥐 헌 쳇바퀴에 타고파 · 0123',
  'questions.tabLabel': '질문',
  'questions.banner': '간단한 질문 몇 가지 드려도 될까요?',
  'questions.bannerAnswered': '질문에 답변함',
  'questions.continue': '계속',
  'questions.generating': '질문 생성 중…',
  'questions.skipAll': '모두 건너뛰기',
  'questions.autoSkipHint': '타이머가 종료되면 자동으로 계속됩니다',
  'questions.submitting': '제출 중…',
  'sketch.toolSelect': '선택',
  'sketch.toolPen': '펜',
  'sketch.toolText': '텍스트',
  'sketch.toolRect': '사각형',
  'sketch.toolArrow': '화살표',
  'sketch.toolEraser': '지우개',
  'sketch.color': '색상',
  'sketch.strokeSize': '선 굵기',
  'sketch.undo': '실행 취소',
  'sketch.clear': '모두 지우기',
  'sketch.close': '닫기',
  'sketch.closeConfirm': '스케치를 닫고 저장되지 않은 변경사항을 버릴까요?',
  'sketch.textPrompt': '텍스트:',
  'sketch.textModalTitle': '텍스트 추가',
  'critiqueTheater.userFacingName': '디자인 배심',
  'critiqueTheater.roleDesigner': '디자이너',
  'critiqueTheater.roleCritic': '평론가',
  'critiqueTheater.roleBrand': '브랜드',
  'critiqueTheater.roleA11y': '접근성',
  'critiqueTheater.roleCopy': '카피',
  'critiqueTheater.roundLabel': '{n} 라운드 / 총 {m} 라운드',
  'critiqueTheater.mustFix': '필수 수정 {n}건',
  'critiqueTheater.composite': '종합 점수',
  'critiqueTheater.threshold': '임계값',
  'critiqueTheater.consensus': '합의',
  'critiqueTheater.interrupt': '중단',
  'critiqueTheater.interrupting': '중단 중…',
  'critiqueTheater.interrupted': '중단됨',
  'critiqueTheater.degradedHeading': '이번 실행에서는 패널 사용 불가',
  'critiqueTheater.degradedReasonMalformed': '패널 출력 형식이 올바르지 않습니다(파서가 거부함).',
  'critiqueTheater.degradedReasonOversize': '패널 출력이 안전 바이트 예산을 초과했습니다.',
  'critiqueTheater.degradedReasonAdapter': '어댑터 {adapter}이(가) 비평 프로토콜을 지원하지 않습니다.',
  'critiqueTheater.degradedReasonProtocol': '어댑터 {adapter}이(가) 지원하지 않는 프로토콜 버전을 사용했습니다.',
  'critiqueTheater.degradedReasonMissingArtifact': '실행이 완료되었으나 최종 산출물이 없습니다.',
  'critiqueTheater.replay': '리플레이',
  'critiqueTheater.replaySpeed': '리플레이 속도',
  'critiqueTheater.readOnly': '읽기 전용',
  'critiqueTheater.shippedSummary': '{round} 라운드에서 배포 · 종합 {composite}',
  'critiqueTheater.interruptedSummary': '{round} 라운드에서 중단 · 최고 종합 {composite}',
  'critiqueTheater.shippedBadge': '배포됨',
  'critiqueTheater.belowThresholdBadge': '임계값 미달',
  'critiqueTheater.timedOutBadge': '시간 초과',
  'critiqueTheater.failedHeading': '실행 실패',
  'critiqueTheater.failedReasonCliExit': '에이전트 CLI가 패널 완료 전에 비정상 종료되었습니다.',
  'critiqueTheater.failedReasonPerRoundTimeout': '한 라운드가 시간 예산을 초과했습니다.',
  'critiqueTheater.failedReasonTotalTimeout': '전체 실행이 시간 예산을 초과했습니다.',
  'critiqueTheater.failedReasonOrchestrator': '오케스트레이터 내부 오류.',
  'critiqueTheater.transcriptEmpty': '리플레이할 트랜스크립트가 없습니다. 비평을 실행해 기록을 만드세요.',
  'critiqueTheater.transcriptLoading': '트랜스크립트 불러오는 중…',
  'critiqueTheater.transcriptError': '트랜스크립트를 불러오지 못했습니다: {error}',
  'critiqueTheater.replaySpeedPaused': '일시 정지',
  'critiqueTheater.replaySpeedInstant': '즉시',
  'critiqueTheater.replaySpeedLive': '실시간',
  'critiqueTheater.replaySpeedFast': '빠르게',
  'critiqueTheater.settingsNav': '디자인 배심원단',
  'critiqueTheater.settingsNavHint': '에이전트 실행 중 5인 패널 리뷰',
  'critiqueTheater.settingsEnabledLabel': '에이전트 실행 중 디자인 배심원단 표시',
  'critiqueTheater.settingsEnabledDescription': '활성화하면 에이전트가 생성하는 동안 5인 패널 리뷰가 함께 진행되며 출하 전에 결과에 점수를 매깁니다. 언제든지 중단할 수 있습니다.',
  'critiqueTheater.settingsEnabledProjectHint': '이 프로젝트에 저장되었습니다. 새 실행은 서버 측에서 디자인 배심원단을 통과합니다.',
  'critiqueTheater.settingsEnabledNoProjectHint': '서버 측에 저장하려면 프로젝트를 여세요. 지금은 브라우저 내 환경설정만 변경됩니다.',
  'pet.title': '펫',
  'pet.subtitle': '작업 공간 위에 떠다니는 작은 친구를 입양해 보세요.',
  'pet.navTitle': '펫',
  'pet.navHint': '입양 또는 사용자 지정',
  'pet.tabBuiltIn': '내장',
  'pet.tabBuiltInHint': 'Open Design에 기본 포함된 친구들 — 골라서 입양하세요.',
  'pet.builtInEmpty': '지금은 기본 제공 펫을 불러올 수 없어요. 데몬이 다시 켜지면 커뮤니티 탭을 새로고침해 주세요.',
  'pet.tabCustom': '커스텀',
  'pet.tabCustomHint': '이름·글리프·색상·스프라이트를 직접 정해 보세요.',
  'pet.tabCommunity': '커뮤니티',
  'pet.tabCommunityHint': 'Codex에서 부화한 펫 — 입양하거나 AI로 새로 만드세요.',
  'pet.tabsAria': '펫 소스',
  'pet.adopt': '입양',
  'pet.adoptedBadge': '입양 완료',
  'pet.adoptCallout': '펫 입양하기',
  'pet.changePet': '펫 변경',
  'pet.wake': '깨우기',
  'pet.tuck': '숨기기',
  'pet.wakeTitle': '펫 깨우기 — 떠다니는 오버레이 표시.',
  'pet.tuckTitle': '펫 숨기기 — 오버레이 숨김.',
  'pet.settingsTitle': '펫 설정 열기',
  'pet.useCustom': '내 펫 사용',
  'pet.customTitle': '내 펫 만들기',
  'pet.customHint': '이름, 아이콘, 강조 색상을 골라보세요. 오버레이가 실시간으로 업데이트됩니다.',
  'pet.customGreetingPlaceholder': '펫의 인사말…',
  'pet.fieldName': '이름',
  'pet.fieldGlyph': '아이콘',
  'pet.fieldGlyphHint': '이모지 하나가 가장 잘 어울려요 (예: 🐝, 🦄, 🐢).',
  'pet.fieldGreeting': '인사말',
  'pet.fieldAccent': '강조 색상',
  'pet.fieldAccentCustom': '사용자 색상',
  'pet.fieldAccentDefault': '기본 강조 색상',
  'pet.overlayAria': '펫 친구',
  'pet.spriteAria': '{name} — 드래그하여 이동, 클릭하여 대화',
  'pet.spriteTitle': '{name}의 인사! 클릭해서 대화하세요.',
  'pet.taskSummarySingle': 'Agent 작업 {count}개가 실행 중입니다.',
  'pet.taskSummaryMultiple': '{projects}개 프로젝트에서 Agent 작업 {count}개가 실행 중입니다.',
  'pet.taskSummaryRecentSingle': 'Agent 작업 {count}개가 최근에 완료되었습니다.',
  'pet.taskSummaryRecentMultiple': 'Agent 작업 {count}개가 최근에 완료되었습니다.',
  'pet.taskListAria': '활성 Agent 작업',
  'pet.taskOpenProject': '{project} 열기',
  'pet.taskGroup.running': '실행 중',
  'pet.taskGroup.queued': '대기 중',
  'pet.taskGroup.recent': '최근 완료됨',
  'pet.idleQuote.leonardo.text': '배움은 정신을 결코 지치게 하지 않는다.',
  'pet.idleQuote.leonardo.author': 'Leonardo da Vinci',
  'pet.idleQuote.michelangelo.text': '나는 대리석 속에서 천사를 보았고, 그를 자유롭게 할 때까지 깎아냈다.',
  'pet.idleQuote.michelangelo.author': 'Michelangelo',
  'pet.idleQuote.bernini.text': '조각가를 도울 수 있는 두 가지가 있다. 바로 빛과 그림자다.',
  'pet.idleQuote.bernini.author': 'Gian Lorenzo Bernini',
  'pet.idleQuote.raphael.text': '그림을 그릴 때는 생각하지 않는다.',
  'pet.idleQuote.raphael.author': 'Raphael',
  'pet.idleQuote.caravaggio.text': '무엇을 그렸든 누가 그렸든, 모든 작품은 실제 삶에서 만들어지고 그려지지 않는 한 하찮은 것이고 유치한 장난에 불과하다.',
  'pet.idleQuote.caravaggio.author': 'Caravaggio',
  'pet.idleQuote.rodin.text': '가장 중요한 것은 감동하고, 사랑하고, 희망하고, 떨고, 살아가는 것이다.',
  'pet.idleQuote.rodin.author': 'Auguste Rodin',
  'pet.composerTitle': '펫 — 깨우기, 숨기기 또는 선택',
  'pet.composerMenuTitle': '펫',
  'pet.composerMenuHint': '팁: /pet 을 입력하면 토글',
  'pet.composerOpenSettings': '펫 관리',
  'pet.welcomeTeaserTitle': '펫 입양하기',
  'pet.welcomeTeaserBody': '작업 공간 위에 떠다니는 작은 친구입니다.',
  'pet.welcomeTeaserCta': '고르기',
  'pet.imageUpload': '스프라이트 업로드',
  'pet.imageReplace': '스프라이트 교체',
  'pet.imageRemove': '이모지로 변경',
  'pet.imageHintIdle': 'PNG / JPG / WebP / GIF / SVG 지원. 스프라이트시트? 가로 스트립을 올리고 프레임 수를 설정하세요.',
  'pet.imageHintActive': '업로드한 스프라이트 표시 중. 프레임을 1보다 크게 설정하면 가로 스프라이트시트가 움직입니다.',
  'pet.fieldFrames': '프레임',
  'pet.fieldFramesHint': '1 = 정적. > 1 = 가로 스프라이트시트.',
  'pet.fieldFps': '속도 (fps)',
  'pet.fieldFpsHint': '프레임 전환 속도.',
  'pet.atlasImport': 'Codex 스프라이트 가져오기',
  'pet.atlasImportTitle': 'hatch-pet의 8x9 / 192x208 아틀라스(PNG 또는 WebP)를 가져옵니다.',
  'pet.atlasPickerTitle': '애니메이션 행 선택',
  'pet.atlasPickerHint': 'Codex 펫은 9개의 애니메이션 행을 가집니다. 기본값은 전체 아틀라스를 유지해 호버, 드래그 방향, 장시간 대기에 따라 행이 바뀝니다. 한 행으로 고정할 수도 있습니다.',
  'pet.atlasCancel': '아틀라스 취소',
  'pet.atlasAdopt': '이 행으로 고정',
  'pet.atlasAdoptFull': '전체 아틀라스 사용 (애니메이션)',
  'pet.atlasAdoptFullTitle': '모든 행을 유지해 호버, 드래그 방향, 장시간 대기에 반응합니다.',
  'pet.atlasAdoptRowTitle': '강조된 행만 루프 스트립으로 잘라냅니다.',
  'pet.atlasActiveHint': '애니메이션 아틀라스 활성 — 상호작용(호버, 드래그, 대기)에 따라 펫이 행을 자동으로 전환합니다.',
  'pet.atlasRow.idle': '대기',
  'pet.atlasRow.running-right': '오른쪽으로 달리기',
  'pet.atlasRow.running-left': '왼쪽으로 달리기',
  'pet.atlasRow.waving': '손 흔들기',
  'pet.atlasRow.jumping': '점프',
  'pet.atlasRow.failed': '실패',
  'pet.atlasRow.waiting': '기다리기',
  'pet.atlasRow.running': '달리기',
  'pet.atlasRow.review': '검토',
  'pet.hatchTitle': 'AI로 새 펫 부화하기',
  'pet.hatchHint': '내장된 hatch-pet 스킬을 채팅에서 실행해 Codex 스타일 스프라이트시트를 만든 뒤 여기에서 가져오세요.',
  'pet.hatchConcept': '펫 콘셉트 (선택)',
  'pet.hatchConceptPlaceholder': '예: 스웨터를 입은 작은 픽셀 시바견',
  'pet.hatchCopy': '프롬프트 복사',
  'pet.hatchCopied': '복사됨!',
  'pet.hatchFoot': '스킬이 펫을 저장하면 여기로 돌아와 "Codex 스프라이트 가져오기"를 누르세요.',
  'pet.slashPopoverAria': '슬래시 명령',
  'pet.slashPopoverTitle': '명령',
  'pet.slashPopoverHint': '↑↓ 이동 · enter 선택 · esc 닫기',
  'pet.slashPet': '펫을 토글하거나 입양 또는 설정으로 이동.',
  'pet.slashPetWake': '플로팅 펫을 깨우기.',
  'pet.slashPetTuck': '펫을 잠시 치우기.',
  'pet.slashHatch': 'hatch-pet 스킬로 Codex 펫 생성.',
  'pet.slashHatchArg': '<콘셉트>',
  'pet.slashSearch': 'OD research 명령으로 웹을 검색합니다.',
  'pet.slashSearchArg': '<검색어>',
  'pet.codexTitle': '최근 부화',
  'pet.codexSubtitle': 'hatch-pet 스킬이 패키지한 펫이 여기에서 원클릭으로 입양 가능.',
  'pet.codexSubtitleWithDir': 'hatch-pet 스킬 패키지를 위해 {dir} 스캔 중.',
  'pet.codexEmpty': '부화된 펫이 아직 없습니다. 채팅에서 /hatch를 입력해 생성하세요.',
  'pet.codexLoading': '부화된 펫을 찾는 중…',
  'pet.codexRefresh': '새로고침',
  'pet.codexAdopt': '입양',
  'pet.codexAdopting': '입양 중…',
  'pet.communitySync': '커뮤니티 펫 다운로드',
  'pet.communitySyncing': '다운로드 중…',
  'pet.communitySyncTitle': 'Codex Pet Share + j20 Hatchery 의 최신 펫을 ~/.codex/pets/ 로 동기화합니다.',
  'pet.communitySyncDone': '신규 펫 {wrote} 마리 동기화됨 (총 {total} 마리).',
  'pet.communitySyncFailed': '동기화 실패: {error}',
  'pet.codexBundled': '내장',
  'pet.codexBundledTitle': 'Open Design 에 내장 — 다운로드 불필요.',
  'settings.notifications': '알림',
  'settings.notificationsHint': '작업 완료 시 효과음 및 데스크톱 알림',
  'settings.notifyCompletionSound': '완료 사운드',
  'settings.notifyCompletionSoundHint': '한 턴이 끝나면 재생됩니다. 기본값은 꺼짐입니다.',
  'settings.notifySuccessSound': '성공 사운드',
  'settings.notifyFailureSound': '실패 사운드',
  'settings.notifyDesktop': '데스크톱 알림',
  'settings.notifyDesktopHint': '창이 활성화되지 않았을 때 전송됩니다.',
  'settings.notifyDesktopBlocked': '브라우저에서 차단되었습니다. 사이트 설정에서 허용하세요.',
  'settings.notifyDesktopUnsupported': '이 환경에서는 데스크톱 알림을 사용할 수 없습니다.',
  'settings.notifyTest': '테스트 보내기',
  'settings.notifyTestSent': '테스트 알림을 보냈습니다. 배너가 보이지 않으면 브라우저와 시스템 알림 설정을 확인하세요.',
  'settings.notifyTestFailed': '알림 호출에 실패했습니다. 브라우저와 시스템 알림 설정을 확인하세요.',
  'settings.notifySoundDing': '딩',
  'settings.notifySoundChime': '차임벨',
  'settings.notifySoundTwoToneUp': '상승 2음',
  'settings.notifySoundPluck': '플럭',
  'settings.notifySoundBuzz': '버즈',
  'settings.notifySoundTwoToneDown': '하강 2음',
  'settings.notifySoundThud': '쿵',
  'settings.skills': '스킬',
  'settings.skillsHint': '에이전트가 작업 중 호출할 수 있는 기능 스킬',
  'settings.skillsNew': '새 스킬',
  'settings.skillsEmpty': '왼쪽에서 스킬을 선택하거나 새로 만드세요.',
  'settings.skillsEdit': '편집',
  'settings.skillsDelete': '삭제',
  'settings.skillsDeleteConfirm': '삭제 확인',
  'settings.skillsName': '이름',
  'settings.skillsTriggers': '트리거 (쉼표 또는 줄바꿈으로 구분)',
  'settings.skillsDescription': '설명',
  'settings.skillsBody': 'SKILL.md 본문',
  'settings.skillsCreate': '만들기',
  'settings.skillsSave': '저장',
  'settings.skillsSaving': '저장 중…',
  'settings.skillsFiles': '파일',
  'settings.skillsNoFiles': '이 스킬 폴더에 파일이 없습니다.',
  'settings.skillsNameRequired': '스킬 이름은 필수입니다.',
  'settings.skillsBodyRequired': '스킬 내용은 필수입니다.',
  'settings.designSystems': '디자인 시스템',
  'settings.designSystemsHint': '사용 가능한 디자인 시스템을 탐색하고 전환하세요',
  'settings.designSystemsInstalled': '설치됨',
  'settings.designSystemsAdd': '디자인 시스템 추가',
  'settings.designSystemsHiddenCount': '{count}개가 홈 갤러리에서 숨겨짐',
  'settings.designSystemsShowAll': '모두 보기',
  'settings.designSystemsShowHidden': '숨김 보기',
  'settings.designSystemsSource': '소스',
  'settings.designSystemsSourceLocal': '로컬',
  'settings.designSystemsSourceGithub': 'GitHub',
  'settings.designSystemsSourceShadcn': 'shadcn',
  'settings.designSystemsShadcnReference': 'shadcn 레지스트리 참조',
  'settings.designSystemsImportShadcn': 'shadcn에서 가져오기',
  'settings.designSystemsStructure': '구조',
  'settings.designSystemsModeHybrid': '하이브리드',
  'settings.designSystemsModeNormalized': '정규화',
  'settings.designSystemsModeVerbatim': '원본 유지',
  'settings.designSystemsCraft': 'Craft',
  'settings.designSystemsCraftColor': '색상',
  'settings.designSystemsCraftAccessibility': '접근성',
  'settings.designSystemsGithubUrl': 'GitHub URL',
  'settings.designSystemsProjectPath': '프로젝트 경로',
  'settings.designSystemsImportGithub': 'GitHub에서 가져오기',
  'settings.designSystemsImportProject': '프로젝트에서 가져오기',
  'settings.designSystemsImportedStatus': '{title} 가져옴',
  'settings.designSystemsViewImported': '가져온 디자인 시스템 보기',
  'settings.designSystemsCategory': '카테고리',
  'settings.designSystemsAllCategories': '모든 카테고리',
  'settings.designSystemsShowInHomeGallery': '홈 갤러리에 표시',
  'settings.projectLocations': '프로젝트 위치',
  'settings.projectLocationsHint': '워크스페이스 저장 루트',
  'settings.projectLocationsDescription': '여러 Open Design 프로젝트 폴더를 포함할 수 있는 작업 베이스를 추가합니다. 새 프로젝트는 선택한 베이스 안의 폴더로 저장됩니다.',
  'settings.projectLocationsSaveError': '프로젝트 위치를 저장할 수 없습니다. 각 경로가 접근 가능한 폴더인지 확인하세요.',
  'settings.projectLocationsSaved': '프로젝트 위치가 저장되었습니다.',
  'settings.projectLocationsScanError': '프로젝트 위치를 스캔할 수 없습니다.',
  'settings.projectLocationsScanComplete': '스캔 완료: {imported}개 가져옴, {existing}개는 이미 등록됨.',
  'settings.projectLocationsNoFolderSelected': '선택한 폴더가 없습니다.',
  'settings.projectLocationsDuplicate': '해당 작업 베이스는 이미 추가되었습니다.',
  'settings.projectLocationsWorkBaseMeta': '작업 베이스 · 프로젝트는 여기에 하위 폴더로 생성됩니다',
  'settings.projectLocationsAddFolder': '폴더 추가…',
  'settings.projectLocationsDefaultBadge': '기본 위치',
  'settings.projectLocationsMakeDefault': '기본값으로 설정',
  'settings.projectLocationsDefaultSaved': '기본 프로젝트 위치가 업데이트되었습니다.',
  'settings.librarySkills': '스킬',
  'settings.libraryDesignSystems': '디자인 시스템',
  'settings.librarySearch': '검색...',
  'settings.libraryAll': '전체',
  'settings.libraryPreview': '미리보기',
  'settings.libraryPreviewClose': '닫기',
  'settings.libraryLoading': '불러오는 중...',
  'settings.libraryNoResults': '검색어와 일치하는 항목이 없습니다.',
  'settings.libraryEnabled': '활성화됨',
  'settings.libraryDisabled': '비활성화됨',
  'settings.connectorsNavHint': '외부 시스템 연결',
  'settings.connectorsHint': '이 기기의 커넥터 및 도구 제공자 설정을 관리합니다.',
  'settings.connectorsComposioApiKey': 'Composio API 키',
  'settings.connectorsSavedTitle': '로컬 daemon에 저장됨',
  'settings.connectorsSavedWithTail': '저장됨 · ••••{tail}',
  'settings.connectorsSaved': '저장됨',
  'settings.connectorsGetApiKey': 'API 키 받기',
  'settings.connectorsReplaceKeyPlaceholder': '저장된 키를 교체하려면 새 키를 붙여넣으세요',
  'settings.connectorsApiKeyPlaceholder': 'Composio API 키 붙여넣기',
  'settings.connectorsClear': '지우기',
  'settings.connectorsClearConfirmTitle': '저장된 Composio API 키를 지울까요?',
  'settings.connectorsClearConfirmBody': '키를 삭제하면 이 워크스페이스에 연결된 모든 Composio 커넥터가 해제됩니다. 연결된 계정, OAuth 권한, 도구 접근 권한이 모두 제거됩니다.',
  'settings.connectorsClearConfirmContinue': '계속',
  'settings.connectorsClearFinalTitle': '모든 커넥터 연결이 해제됩니다',
  'settings.connectorsClearFinalBody': '되돌릴 수 없습니다. 새 키를 붙여 넣은 뒤에는 각 통합을 처음부터 다시 연결해야 합니다.',
  'settings.connectorsClearFinalConfirm': '키 삭제 및 연결 해제',
  'settings.connectorsClearArming': '잠시만요…',
  'settings.connectorsClearCancel': '취소',
  'settings.connectorsSaveKey': '키 저장',
  'settings.connectorsSaveKeyTitle': '이 키를 로컬 데몬으로 전송',
  'settings.connectorsKeySaving': '저장 중…',
  'settings.connectorsKeySaved': '저장됨 ✓',
  'settings.connectorsKeyError': '키를 저장하지 못했습니다. 로컬 데몬이 실행 중인지 확인한 뒤 다시 시도하세요.',
  'settings.connectorsHelpSaved': '키가 아래 카탈로그를 열며 로컬 daemon에 유지됩니다. 교체하려면 새 키를 붙여넣고, 제거하려면 지우세요.',
  'settings.connectorsHelpUnsaved': '저장되지 않은 변경사항 — 「키 저장」을 눌러 이 자격 정보를 로컬 데몬에 저장하고 아래 카탈로그를 해제하세요.',
  'settings.connectorsHelpEmpty': '아래 카탈로그를 열려면 키를 추가하세요. 키는 daemon에 로컬로 저장되며 환경 변수로 전송되지 않습니다.',
  'settings.connectorsLoadingSavedKey': '로컬 daemon에서 저장된 키를 확인하는 중…',
  'settings.autosaveSaving': '저장 중…',
  'settings.autosaveSaved': '모든 변경사항이 저장됨',
  'settings.autosaveError': '변경사항을 저장하지 못했습니다. 로컬 데몬이 오프라인일 수 있습니다.',
  'settings.libraryToggleLabel': '전환',
  'settings.memory': '메모리',
  'settings.memoryHint': '대화에서 자동으로 추출된 개인 정보',
  'artifact.odCardTaskBriefChip': '메모리 적용됨 · 브리프 보기',
  'artifact.odCardScorecardTitle': '자체 점검',
  'artifact.odCardScorecardStatusPass': '통과',
  'artifact.odCardScorecardStatusPartial': '부분 통과',
  'artifact.odCardScorecardStatusFail': '보완 필요',
  'artifact.odCardRuleKicker': '제안된 규칙',
  'artifact.odCardRuleNameLabel': '이름',
  'artifact.odCardRuleDescriptionLabel': '설명',
  'artifact.odCardRuleAssertionLabel': '반드시 지켜야 할 것',
  'artifact.odCardRuleCheckLabel': '확인 방법',
  'artifact.odCardRuleRationaleLabel': '이유',
  'artifact.odCardRuleKeep': '유지',
  'artifact.odCardRuleEdit': '편집',
  'artifact.odCardRuleDone': '완료',
  'artifact.odCardRuleDiscard': '버리기',
  'artifact.odCardRuleSaving': '저장 중…',
  'artifact.odCardRuleSaved': '“{name}”을(를) 규칙으로 저장했습니다',
  'artifact.odCardRuleError': '규칙을 저장하지 못했습니다. 다시 시도하세요.',
  'artifact.odCardBrandAssistDone': 'Browser assist confirmed',
  'artifact.odCardBrandAssistKicker': 'Browser assist needed: {reason}',
  'artifact.odCardBrandAssistBody': 'Open Browser and clear any human check. Then click More, choose Download Page, wait for the saved snapshot success, and use the left Next Step card to continue extraction.',
  'artifact.odCardBrandAssistError': 'Could not start browser assist. Try again.',
  'artifact.odCardBrandAssistWorking': 'Starting...',
  'artifact.odCardBrandAssistConfirm': 'Open browser assist',
  'settings.memoryTypeProfile': '프로필',
  'settings.memoryTypeRule': '규칙',
  'settings.memoryTabMemories': '메모리',
  'settings.memoryTabMemoriesCaption': '저장된 메모리 보기 및 관리',
  'settings.memoryTabHow': '작동 방식',
  'settings.memoryTabHowCaption': '두 가지 루프와 해당 제어',
  'settings.memoryAddDisclosure': '메모리 추가 또는 가져오기',
  'settings.memoryAddDisclosureHint': '프로필, 수동 입력 또는 연결된 앱',
  'settings.memoryProfileTab': '업무 프로필',
  'settings.memoryProfileTabCaption': '당신이 누구인지와 기본값',
  'settings.memoryProfileTitle': '내 업무 프로필',
  'settings.memoryProfileHint':
    '당신과 당신의 기본값에 관한 몇 가지 사실입니다. 메모리가 모든 작업 전에 이를 주입하여, 짧은 요청만으로도 에이전트가 당신의 의도를 추론합니다.',
  'settings.memoryProfileName': '업무 프로필',
  'settings.memoryProfileDescription':
    '어시스턴트가 재사용해야 할 역할, 회사, 도메인, 대상, 취향, 기본값입니다.',
  'settings.memoryProfileSave': '프로필 저장',
  'settings.memoryProfileSaving': '저장 중…',
  'settings.memoryProfileSaved': '프로필 저장됨',
  'settings.memoryProfileRole': '역할',
  'settings.memoryProfileRolePlaceholder': '예: Founder, designer, PM',
  'settings.memoryProfileCompany': '회사 / 팀',
  'settings.memoryProfileCompanyPlaceholder': '예: Acme, growth team',
  'settings.memoryProfileDomain': '도메인',
  'settings.memoryProfileDomainPlaceholder': '예: B2B SaaS, fintech, devtools',
  'settings.memoryProfileAudience': '주요 대상',
  'settings.memoryProfileAudiencePlaceholder': '예: executives, engineers, end users',
  'settings.memoryProfileAesthetic': '미감 / 취향',
  'settings.memoryProfileAestheticPlaceholder':
    '예: clean and editorial, light backgrounds, generous whitespace',
  'settings.memoryProfileDeliverables': '기본 산출물',
  'settings.memoryProfileDeliverablesPlaceholder': '예: landing pages, decks, one-pagers',
  'settings.memoryProfileLocale': '로캘 / 언어',
  'settings.memoryProfileLocalePlaceholder': '예: English (US), Simplified Chinese',
  'settings.memoryProfileGoals': '현재 목표',
  'settings.memoryProfileGoalsPlaceholder':
    '예: ship the new pricing page, raise conversion on the trial flow',
  'settings.memoryHooksTitle': '메모리 후크',
  'settings.memoryHooksHint':
    '메모리의 어떤 부분이 자동으로 실행될지 선택하세요. 위의 마스터 스위치는 이 모두를 끕니다.',
  'settings.memoryHooksProfileLabel': '내 프로필 사용',
  'settings.memoryHooksProfileDesc': '모든 작업에 업무 프로필을 주입합니다.',
  'settings.memoryHooksRewriteLabel': '짧은 요청 다시 쓰기',
  'settings.memoryHooksRewriteDesc': 'PRE: 짧은 요청을 완전한 작업 브리프로 확장합니다.',
  'settings.memoryHooksVerifyLabel': '출력 자체 검증',
  'settings.memoryHooksVerifyDesc': 'POST: 결과를 규칙과 대조한 뒤 점검표를 표시합니다.',
  'settings.memoryHooksExtractionLabel': '대화에서 학습',
  'settings.memoryHooksExtractionDesc': '대화 turn에서 유용한 사실과 선호 사항을 수집합니다.',
  'settings.customInstructionsTitle': '전역 규칙',
  'settings.customInstructionsHint': '모든 채팅에서 Open Design이 따라야 할 고정 지침입니다. 사실, 선호 사항, 프로젝트 컨텍스트를 메모리로 저장하세요.',
  'settings.customInstructionsPlaceholder': '예: "항상 TypeScript를 사용하세요. 함수형 컴포넌트를 선호합니다. 응답은 간결하게 유지하세요."',
  'settings.memoryDescription': '취향과 컨텍스트에 관한 사실을 대화에서 자동으로 추출하여 Markdown 파일로 저장하고, 이후 대화에 자동 주입합니다.',
  'settings.memoryEnabled': '활성화됨',
  'settings.memoryDisabled': '비활성화됨',
  'settings.memoryEnableLabel': '메모리 주입 활성화',
  'settings.memoryDisabledBanner': '메모리가 현재 꺼져 있습니다. 기존 사실은 디스크에 유지되지만 새 대화에 주입되지 않으며 새로운 정보도 추출되지 않습니다.',
  'settings.memoryNew': '새 메모리',
  'settings.memoryEdit': '편집',
  'settings.memoryDelete': '삭제',
  'settings.memoryPreview': '미리보기',
  'settings.memoryEmpty': '아직 메모리가 없습니다.',
  'settings.memoryEmptyHintZh': '记住: 用户偏好深色主题',
  'settings.memoryEmptyHintEn': '저는 다크 모드를 선호합니다',
  'settings.memoryName': '이름',
  'settings.memoryDesc': '한 줄 설명',
  'settings.memoryBody': '메모리 본문 (Markdown 지원)',
  'settings.memoryBodyHint': '규칙 본문을 먼저 적고 Why와 How to apply 두 줄을 추가하세요.',
  'settings.memoryStartersLabel': '시작점이 필요하신가요? 클릭하여 양식을 채우세요:',
  'settings.memoryStarterUserName': '내 역할',
  'settings.memoryStarterUserDesc': '저는 SaaS 디자인 도구를 개발하는 프런트엔드 엔지니어입니다',
  'settings.memoryStarterUserBody': '- 역할: 시니어 프런트엔드 엔지니어\n- 스택: React, TypeScript, Vite\n- 분야: 디자인 / 협업 도구\n- 시간대: GMT+8 (Asia/Shanghai)\n\n적용 시점: 모든 채팅 — 예시는 웹 프런트엔드 중심으로 구성합니다.',
  'settings.memoryStarterFeedbackName': 'UI 환경설정',
  'settings.memoryStarterFeedbackDesc': '다크 모드, 큰 본문 텍스트, 낮은 정보 밀도',
  'settings.memoryStarterFeedbackBody': '- 테마: 기본값은 다크 모드\n- 본문 텍스트: 18px 이상\n- 정보 밀도: 여백을 우선하고 화면당 항목 수를 줄임\n\n이유: 긴 작업 세션 동안 눈의 피로를 줄입니다.\n적용 시점: UI, 웹 페이지, 슬라이드를 생성할 때마다.',
  'settings.memoryStarterProjectName': '현재 프로젝트',
  'settings.memoryStarterProjectDesc': 'Open Design v0.5 — 채팅 기반 디자인 편집기',
  'settings.memoryStarterProjectBody': '- 목표: 이번 분기에 채팅 기반 에디터 출시\n- 우선순위: 스트리밍 렌더링, 로컬 멀티모달, 오프라인 우선\n- 스택: Next.js 16, Express 데몬, SQLite\n\n적용 시점: 이 프로젝트에 관한 모든 대화에서.',
  'settings.memorySaveHint': '자동 저장되지 않습니다 — 적용하려면 만들기 / 저장을 클릭하세요.',
  'settings.memoryIndexSaveHint': '인덱스 편집 내용은 자동 저장되지 않습니다 — 적용하려면 인덱스 저장을 클릭하세요.',
  'settings.memoryIndexUnsaved': '저장되지 않은 변경 사항',
  'settings.memoryFlashCreated': '✓ 메모리가 생성되었습니다',
  'settings.memoryFlashSaved': '✓ 메모리가 저장되었습니다',
  'settings.memoryFlashDeleted': '✓ 메모리가 삭제되었습니다',
  'settings.memoryFlashIndexSaved': '✓ 인덱스가 저장되었습니다',
  'settings.memoryFlashPathCopied': '✓ 경로 복사됨',
  'settings.memoryNameLabel': '제목',
  'settings.memoryTypeLabel': '유형',
  'settings.memoryDescLabel': '설명',
  'settings.memoryBodyLabel': '콘텐츠',
  'settings.memoryTypeUser': '사용자',
  'settings.memoryTypeFeedback': '피드백',
  'settings.memoryTypeProject': '프로젝트',
  'settings.memoryTypeReference': '참조',
  'settings.memoryIndex': 'MEMORY.md (색인)',
  'settings.memoryIndexSave': '색인 저장',
  'settings.memoryIndexReset': '초기화',
  'settings.memoryToastChanged': '메모리가 업데이트되었습니다',
  'settings.memoryToastClickHint': '보기',
  'settings.memoryAll': '전체',
  'settings.memoryExtractions': '추출 기록',
  'settings.memoryExtractionsHint': 'Regex가 먼저 실행되고 LLM은 백그라운드에서 실행됩니다.',
  'settings.memoryExtractionsEmpty': '아직 추출된 항목이 없습니다. 다음 채팅 턴에서 이 목록이 채워집니다.',
  'settings.memoryExtractionsRefresh': '새로고침',
  'settings.memoryExtractionsRefreshing': '새로고침 중…',
  'settings.memoryExtractionPhaseRunning': '실행 중…',
  'settings.memoryExtractionPhaseSuccess': '성공',
  'settings.memoryExtractionPhaseSkipped': '건너뜀',
  'settings.memoryExtractionPhaseFailed': '실패',
  'settings.memoryExtractionSkipNoProvider': 'LLM 메모리 추출을 위한 API key가 구성되지 않았습니다.',
  'settings.memoryExtractionSkipDisabled': '메모리가 비활성화되어 있습니다.',
  'settings.memoryExtractionSkipEmpty': '사용자 메시지가 비어 있습니다 — 추출할 내용이 없습니다.',
  'settings.memoryExtractionSkipNoMatch': '이번 턴에 일치하는 정규식 패턴이 없습니다.',
  'settings.memoryExtractionKindHeuristic': '정규식',
  'settings.memoryExtractionKindLlm': 'LLM',
  'settings.memoryExtractionProviderEnv': '환경 변수',
  'settings.memoryExtractionProviderMediaConfig': '미디어 설정',
  'settings.memoryExtractionProviderOverride': '메모리 설정',
  'settings.memoryExtractionProposed': '제안됨',
  'settings.memoryExtractionWritten': '기록됨',
  'settings.memoryExtractionDuration': 'in',
  'settings.memoryExtractionDelete': '삭제',
  'settings.memoryExtractionsClear': '지우기',
  'settings.memoryExtractionsClearTitle': '모든 추출 기록 지우기',
  'settings.memoryExtractionsClearConfirm': '모든 추출 기록을 지우시겠습니까? 이 작업은 취소할 수 없습니다.',
  'settings.memoryNoProviderBannerTitle': 'LLM 메모리 추출이 실행되고 있지 않습니다',
  'settings.memoryNoProviderBannerBody': '메모리 추출기에 대한 API key를 찾을 수 없습니다. LLM 기반 추출을 활성화하려면 미디어 공급자에서 OpenAI key를 추가하거나, 환경에 ANTHROPIC_API_KEY / OPENAI_API_KEY를 설정하세요. 휴리스틱 정규식 추출은 여전히 활성화되어 있습니다.',
  'settings.libraryInstall': '설치',
  'settings.libraryInstallGithub': 'GitHub',
  'settings.libraryInstallLocal': '로컬 경로',
  'settings.libraryInstallUrl': 'https://github.com/owner/repo',
  'settings.libraryInstallPath': '/path/to/skill-folder',
  'settings.libraryInstallButton': '설치',
  'settings.libraryUninstall': '제거',
  'settings.libraryBuiltIn': '내장',
  'settings.libraryInstalled': '설치됨',
  'notify.successTitle': '작업 완료',
  'notify.failureTitle': '작업 실패',
  'notify.successBody': '한 턴이 끝났습니다.',
  'notify.failureBody': '작업이 오류로 종료되었습니다.',
  'updater.available': '업데이트 사용 가능',
  'updater.availableBody': 'Open Design {version}을 사용할 수 있습니다. 설치 프로그램을 열기 전에 다운로드됩니다.',
  'updater.checking': '업데이트 확인 중',
  'updater.download': '업데이트 다운로드',
  'updater.downloading': '업데이트 다운로드 중',
  'updater.downloadingPercent': '업데이트 다운로드 중 {percent}%',
  'updater.done': '완료',
  'updater.failed': '업데이트 실패',
  'updater.installerOpenBody': '설치 프로그램이 열려 있습니다. 업데이트를 완료할 수 있도록 Open Design을 종료하는 중입니다.',
  'updater.installerOpened': '설치 프로그램 열림',
  'updater.later': '나중에',
  "updater.allowSilentUpdates": "자동 업데이트 허용",
  'updater.openFailedFallback': '설치 프로그램을 열 수 없습니다.',
  'updater.installRestart': 'Install and restart',
  'updater.installingRestart': 'Installing and restarting...',
  'updater.openInstaller': '업데이트 설치',
  'updater.opening': '설치 프로그램 여는 중...',
  'updater.payloadReadyGeneric': 'A new Open Design update is ready. Open Design will close and restart automatically.',
  'updater.payloadReadyVersion': 'Open Design {version} is ready. Open Design will close and restart automatically.',
  'updater.quitButton': 'Open Design 종료',
  'updater.quitFailedBody': '설치 프로그램이 열려 있지만 Open Design을 종료할 수 없습니다. 앱을 교체하기 전에 Open Design을 종료하세요.',
  'updater.quitFailedTitle': '종료할 수 없음',
  'updater.quitting': '종료 중...',
  'updater.ready': '업데이트 준비됨',
  'updater.readyGeneric': '새 버전이 준비되었습니다. Open Design을 닫고 설치 프로그램을 엽니다.',
  'updater.readyVersion': 'Open Design {version}이 준비되었습니다. Open Design을 닫고 설치 프로그램을 엽니다.',
  'updater.upToDate': '이미 최신 버전입니다.',
  'whatsNew.cta': '새로운 기능 보기',
  'whatsNew.dismissAria': '새로운 기능 알림 닫기',
  'newsletter.label': '뉴스레터(선택)',
  'newsletter.placeholder': 'you@studio.com',
  'settings.memoryModelInlineLabel': 'Memory model',
  'settings.memoryModelInlineSameAsChat': 'Same as chat',
  'settings.memoryModelInlineSameAsChatWithModel': 'Same as chat ({model})',
  'settings.memoryModelInlineSameAsChatWithProvider': 'Same as chat ({provider})',
  'settings.memoryModelInlineHintCli': 'Optional. The memory extractor uses an env-var or media-providers API key on this provider; pinning a model here just overrides the auto-pick.',
  'settings.memoryModelInlineHintCliConstrained': 'Optional. Memory will call {provider}; needs an env-var or media-providers API key for that provider, or pick a model below to override.',
  'settings.memoryModelInlineHintByok': 'Optional. Reuses your chat API key on the same provider — picking a different (usually cheaper) model only changes the request body.',
  'settings.memoryModelInlineFlashSaved': 'Saved',
  'settings.memoryModelInlineFlashCleared': 'Cleared',
  'settings.orbit.eyebrow': '자동화',
  'settings.orbit.title': 'Orbit',
  'settings.orbit.navHint': '일일 커넥터 요약',
  'settings.orbit.lede': '커넥터 활동을 일정에 따라 수집하고 결과를 새로고침 가능한 live artifact로 게시합니다.',
  'settings.orbit.statusOnTitle': '예약된 일일 실행이 켜져 있습니다',
  'settings.orbit.statusOffTitle': '예약된 일일 실행이 꺼져 있습니다',
  'settings.orbit.statusActive': '활성',
  'settings.orbit.statusOff': '꺼짐',
  'settings.orbit.runTitle': 'Orbit 실행을 시작하고 라이브 대화 열기',
  'settings.orbit.running': '실행 중…',
  'settings.orbit.runOpen': '지금 실행',
  'settings.orbit.dailySummaryTitle': '일일 요약',
  'settings.orbit.dailySummarySub': '예약된 로컬 시간에 하루 한 번 실행됩니다.',
  'settings.orbit.on': '켜짐',
  'settings.orbit.off': '꺼짐',
  'settings.orbit.runTimeTitle': '실행 시간',
  'settings.orbit.runTimeSub': '기본값 08:00. 저장하면 daemon 일정에 적용됩니다.',
  'settings.orbit.runTimeAria': '일일 Orbit 실행 시간',
  'settings.orbit.nextRun': '다음 실행',
  'settings.orbit.nextRunScheduledAfterSave': '저장 후 예약됨',
  'settings.orbit.schedule': '일정',
  'settings.orbit.pausedManualOnly': '일시 중지 — 수동 실행만',
  'settings.orbit.templateTitle': '프롬프트 템플릿',
  'settings.orbit.templateMissing': '템플릿 {id}이(가) 설치되어 있지 않습니다.',
  'settings.orbit.templateMissingOption': '{id}(누락)',
  'settings.orbit.templateMissingInstall': '프롬프트를 조정하려면 Orbit skill을 설치하세요.',
  'settings.orbit.templateMissingPickAnother': '드롭다운에서 다른 템플릿을 선택하세요.',
  'settings.orbit.templateResetTitle': '{id}(으)로 재설정',
  'settings.orbit.templateReset': '재설정',
  'settings.orbit.templateHelp': 'skill로 Orbit을 조정합니다 — 선택한 템플릿의 예시 프롬프트가 모든 Orbit 실행에 주입되어 요약이 해당 템플릿 형식을 따릅니다.',
  'settings.orbit.templateAria': 'Orbit 프롬프트 템플릿',
  'settings.orbit.templatesLoading': '템플릿 로드 중…',
  'settings.orbit.templatesOptgroup': 'Orbit skill 템플릿',
  'settings.orbit.lastRun': '마지막 실행',
  'settings.orbit.triggerManual': '수동',
  'settings.orbit.triggerScheduled': '예약됨',
  'settings.orbit.meterAria': '총 {checked}개 검사 중 성공 {succeeded}개, 건너뜀 {skipped}개, 실패 {failed}개',
  'settings.orbit.countChecked': '검사됨',
  'settings.orbit.countSucceeded': '성공',
  'settings.orbit.countSkipped': '건너뜀',
  'settings.orbit.countFailed': '실패',
  'settings.orbit.runError': 'Orbit을 실행할 수 없습니다. 로컬 daemon이 실행 중이고 커넥터가 구성되어 있는지 확인하세요.',
  'settings.orbit.gateAriaLabel': 'Orbit을 사용하려면 커넥터가 필요합니다',
  'settings.orbit.gateEyebrow': '설정이 필요합니다',
  'settings.orbit.gateTitle': '도구를 연결해 Orbit을 시작하세요',
  'settings.orbit.gateBody': 'Orbit은 커넥터 활동을 요약합니다. 아직 연결된 것이 없어요 — Orbit이 보고할 수 있도록 최소 하나의 통합을 추가하세요.',
  'settings.orbit.gateBodyNoKey': 'Orbit은 커넥터 활동을 요약하며, 커넥터는 Composio를 통해 동작합니다. 커넥터 화면에서 Composio API 키를 추가해 카탈로그를 열고 첫 번째 통합을 선택하세요.',
  'settings.orbit.gateAction': '커넥터 열기',
  'settings.orbit.gateActionNoKey': 'Composio 설정',
  'settings.orbit.gateLoading': '커넥터 확인 중…',
  'settings.orbit.controlsLockedBadge': '잠김',
  'settings.orbit.controlsLockedHint': '도구를 연결하면 Orbit의 일정과 템플릿 설정이 잠금 해제됩니다.',
  'settings.orbit.artifactKickerLive': '라이브 아티팩트',
  'settings.orbit.artifactKickerLegacy': '레거시 요약',
  'settings.orbit.artifactTitle': '일일 Orbit 활동 요약',
  'settings.orbit.artifactMetaLive': '커넥터 활동에서 생성된 새로고침 가능한 HTML artifact입니다.',
  'settings.orbit.artifactMetaLegacy': 'live artifact 지원이 활성화되기 전에 생성됨 — 게시하려면 Orbit을 다시 실행하세요.',
  'settings.orbit.copyMarkdownTitle': 'Markdown 요약을 클립보드에 복사',
  'settings.orbit.copied': '복사됨',
  'settings.orbit.copy': '복사',
  'settings.orbit.openArtifact': 'artifact 열기',
  'settings.orbit.sourceMarkdown': '소스 Markdown',
  'settings.memoryModelInlineHintByokNeutral': '메모리는 채팅과 별도의 모델을 사용합니다. 기본값은 채팅 모델입니다.',
  'diagnostics.exportTitle': '진단 정보 내보내기',
  'diagnostics.exportButton': '진단 정보 내보내기',
  'diagnostics.exportHint': '최근 앱 로그와 기기 정보를 zip으로 묶어 팀에 공유할 수 있게 만듭니다.',
  'diagnostics.exporting': '내보내는 중…',
  'diagnostics.exportSuccess': '진단 정보를 {path}에 저장했습니다',
  'diagnostics.exportFailed': '진단 정보 내보내기 실패: {message}',
  'automations.eyebrow': '예약된 Agent 세션',
  'automations.title': '자동화',
  'automations.lede': '프로젝트 작업, Orbit 다이제스트, 라이브 아티팩트를 위한 반복 대화를 계획하세요.',
  'automations.summaryAria': '자동화 요약',
  'automations.metricActive': '활성',
  'automations.metricPaused': '일시중지됨',
  'automations.metricTemplates': '템플릿',
  'automations.newAutomation': '새 자동화',
  'automations.yourAutomations': '내 자동화',
  'automations.loading': '불러오는 중',
  'automations.emptyTitle': '아직 자동화가 없습니다',
  'automations.emptyBody': '템플릿으로 만들거나 빈 일정으로 시작하세요.',
  'automations.targetNewEachRun': '실행마다 새 프로젝트',
  'automations.targetCreateEachRun': '실행마다 새 프로젝트',
  'automations.lastRun': '마지막 실행 {time}',
  'automations.openResult': '결과 열기',
  'automations.run': '실행',
  'automations.runNowTitle': '지금 실행하고 대화 열기',
  'automations.history': '기록',
  'automations.hideHistory': '기록 숨기기',
  'automations.edit': '편집',
  'automations.pause': '일시중지',
  'automations.resume': '재개',
  'automations.deleteAria': '자동화 삭제',
  'automations.deleteTitle': '이 자동화 삭제',
  'automations.deleteConfirm': '이 자동화를 삭제할까요? 이전 실행과 해당 프로젝트는 유지됩니다.',
  'automations.proposalsTitle': '진화 제안',
  'automations.proposalsSub': '자동화 출력이 메모리, 스킬, 디자인 시스템을 변경하기 전에 검토하세요.',
  'automations.proposalsPending': '{n}건 대기 중',
  'automations.apply': '적용',
  'automations.reject': '거부',
  'automations.proposalsDismissReason': '자동화에서 무시됨',
  'automations.templatesTitle': '템플릿',
  'automations.templatesSub': 'Orbit과 라이브 아티팩트는 동일한 자동화 플로우 내의 템플릿입니다.',
  'automations.templatesCount': '{total}개 중 {filtered}개',
  'automations.templateFiltersAria': '템플릿 필터',
  'automations.templatesEmptyTitle': '이 카테고리에 아직 템플릿이 없습니다.',
  'automations.templatesEmptyBody': '다른 필터를 사용하거나 빈 자동화로 시작하세요.',
  'automations.useTemplate': '템플릿 사용',
  'automations.runHistoryLoading': '실행 기록 불러오는 중...',
  'automations.runHistoryEmpty': '아직 실행 기록이 없습니다.',
  'automations.runHistoryTitle': '실행 기록',
  'automations.runHistoryLatest': '최근 10개',
  'automations.crystallize': '정형화',
  'automations.crystallizing': '정형화 중',
  'automations.crystallizeTitle': '이 실행에서 스킬 및 메모리 제안 초안 작성',
  'automations.crystallizeFailed': 'Crystallize failed: {error}',
  'automations.crystallizePartialSuccess': 'Crystallize created proposals, but Automations could not refresh the proposal list. Review the visible proposals or try refreshing.',
  'automations.crystallizeRefreshFailed': 'Crystallize finished, but Automations could not refresh proposals. Try refreshing before running it again.',
  'automations.crystallizeNoProposals': 'Crystallize finished, but no proposals were returned. Try refreshing or check the run details.',
  'automations.openConversation': '대화 열기',
  'automations.runHistoryAria': '자동화 실행 기록',
  'automations.proposalsAria': '자동화 진화 제안',
  'automations.templatesAria': '자동화 템플릿',
  'automations.runInProgress': '진행 중',
  'automations.promptPlaceholder': '어제의 GitHub + Linear 활동을 가져와 변경된 내용을 요약합니다.',
  'automations.scheduleStatusPaused': '일시중지됨',
  'automations.nextRunManualOnly': '수동 전용',
  'automations.nextRunScheduled': '예약됨',
  'automations.nextRunAt': '다음 {time}',
  'automations.statusSucceeded': '성공',
  'automations.statusFailed': '실패',
  'automations.statusRunning': '실행 중',
  'automations.statusQueued': '대기열에 추가됨',
  'automations.statusCanceled': '취소됨',
  'automations.kindOrbit': 'Orbit',
  'automations.kindLiveArtifact': '라이브 아티팩트',
  'automations.kindAutomation': '자동화',
  'automations.proposalTargetMemory': '메모리',
  'automations.proposalTargetDesignSystem': '디자인 시스템',
  'automations.proposalTargetSkill': '스킬',
  'automations.proposalTargetTemplate': '자동화 템플릿',
  'automations.proposalActionCreate': '생성',
  'automations.proposalActionUpdate': '업데이트',
  'automations.proposalActionMerge': '병합',
  'automations.proposalActionMove': '이동',
  'automations.proposalActionDelete': '삭제',
  'automations.proposalActionPromote': '승격',
  'automations.filterAll': '전체',
  'automations.filterOrbit': 'Orbit',
  'automations.filterLiveArtifacts': '라이브 아티팩트',
  'automations.filterMemory': '메모리',
  'automations.filterDesignSystems': '디자인 시스템',
  'automations.filterSkills': '스킬',
  'automations.filterConnectors': '커넥터',
  'automations.filterCompression': '압축',
  'automations.filterRelease': '릴리스',
  'automations.filterQuality': '품질',
  'automations.tpl.memoryRefresh.title': '최근 작업에서 프로젝트 메모리를 새로 고칩니다.',
  'automations.tpl.memoryRefresh.desc': '반복되는 결정, 선호 사항, 피드백을 재사용 가능한 메모리 업데이트로 전환합니다.',
  'automations.tpl.designSystemRefresh.title': '출시된 아티팩트에서 디자인 시스템을 업데이트합니다.',
  'automations.tpl.designSystemRefresh.desc': '최근 디자인 작업 전반에서 재사용 가능한 토큰, 컴포넌트, 규칙을 찾아냅니다.',
  'automations.tpl.liveArtifactRegistry.title': '라이브 아티팩트를 감사하고 오래된 버전을 새로 고칩니다.',
  'automations.tpl.liveArtifactRegistry.desc': '지속형 대시보드, 보고서, 미리보기를 중복 생성하지 않고 최신 상태로 유지합니다.',
  'automations.tpl.orbitDashboard.title': '커넥터 활동 대시보드를 구축합니다.',
  'automations.tpl.orbitDashboard.desc': '선택한 커넥터를 Orbit 스타일의 라이브 대시보드로 집계합니다.',
  'automations.tpl.releaseNotes.title': '출시된 디자인 작업에서 릴리스 노트 초안을 작성합니다.',
  'automations.tpl.releaseNotes.desc': '병합된 PR, 아티팩트, 제품 관련 변경 사항을 릴리스 노트로 연결합니다.',
  'automations.tpl.qualityRegressionWatch.title': '디자인 및 구현 회귀를 감시합니다.',
  'automations.tpl.qualityRegressionWatch.desc': '최근 변경 사항을 벤치마크, 트레이스, 승인된 레퍼런스와 비교합니다.',
  'automations.tpl.orbitDaily.title': '일일 커넥터 다이제스트.',
  'automations.tpl.orbitDaily.desc': '커넥터 활동 다이제스트를 일정에 따라 새로 고칩니다.',
  'automations.tpl.liveStatusBoard.title': '라이브 상태 아티팩트를 최신 상태로 유지합니다.',
  'automations.tpl.liveStatusBoard.desc': '실행마다 새 보고서를 만드는 대신 하나의 지속형 아티팩트를 업데이트합니다.',
  'dsManager.areaAria': '디자인 시스템 영역',
  'dsManager.tabDesignSystem': '디자인 시스템',
  'dsManager.tabTemplate': '템플릿',
  'dsManager.sourceAria': '디자인 시스템 소스',
  'dsManager.templateSourceAria': '템플릿 소스',
  'dsManager.yourSystems': '내 시스템',
  'dsManager.officialPresets': '공식 프리셋',
  'dsManager.enterprise': '엔터프라이즈',
  'dsManager.yourTemplates': '내 템플릿',
  'dsManager.yourSystemsAria': '내 디자인 시스템',
  'dsManager.eyebrowDesignSystems': '디자인 시스템',
  'dsManager.yourSystemsHeading': '내 시스템',
  'dsManager.filterAria': '디자인 시스템 필터',
  'dsManager.filterAll': '전체',
  'dsManager.filterPublished': '게시됨',
  'dsManager.filterDraft': '초안',
  'dsManager.createTitle': '새 디자인 시스템 만들기',
  'dsManager.createBody': 'Open Design에 브랜드, 제품, 코드, 에셋, 디자인 레퍼런스를 학습시키세요.',
  'dsManager.createAction': '만들기',
  'dsManager.emptyMine': '아직 디자인 시스템이 없습니다. 실제 제품 컨텍스트로 하나 만들어 초안을 검토한 뒤, 이후 프로젝트를 위해 게시하세요.',
  'dsManager.badgeDefault': '기본값',
  'dsManager.rowMetaUpdated': '나 · {date} 업데이트됨',
  'dsManager.edit': '편집',
  'dsManager.openSystem': '열기',
  'dsManager.editWithAgent': 'Agent로 편집',
  'dsManager.downloadTitle': '디자인 시스템 다운로드(.zip + SKILLS.md)',
  'dsManager.downloadAria': '{title}을(를) .zip으로 다운로드',
  'dsManager.downloadFailed': '디자인 시스템을 다운로드할 수 없습니다. 다시 시도하세요.',
  'dsManager.deleteConfirm': '“{title}”을(를) 삭제할까요? 이 기기에서 디자인 시스템 초안이 제거됩니다.',
  'dsManager.makeDefault': '기본값으로 설정',
  'dsManager.statusPublished': '게시됨',
  'dsManager.statusDraft': '초안',
  'dsManager.openSystemAria': '{title} 열기',
  'dsManager.deleteSystemAria': '{title} 삭제',
  'dsManager.presetsAria': '공식 디자인 시스템 프리셋',
  'dsManager.eyebrowLibrary': '라이브러리',
  'dsManager.eyebrowTemplates': '템플릿',
  'dsManager.yourTemplatesAria': '내 템플릿',
  'dsManager.emptyTemplates': '아직 템플릿이 없습니다. 템플릿 게시가 활성화되면 공유를 통해 생성된 프로젝트에서 만들 수 있습니다.',
  'dsManager.templateDescFallback': '프로젝트에서 생성됨',
  'dsManager.comingSoonBadge': '곧 제공 예정',
  'dsManager.enterpriseDsTitle': '엔터프라이즈 디자인 시스템',
  'dsManager.enterpriseDsBody': '공유 팀 디자인 시스템과 거버넌스가 적용된 브랜드 라이브러리가 곧 제공됩니다.',
  'dsManager.enterpriseTplTitle': '엔터프라이즈 템플릿',
  'dsManager.enterpriseTplBody': '팀 승인 템플릿과 조직 전체 게시 기능이 곧 제공됩니다.',
  'settings.instructionsTitle': '지침 / 규칙',
  'settings.instructionsSubtitle': '어시스턴트가 따라야 할 고정 동작',
  'settings.instructionsNavSub': '고정 어시스턴트 동작',
  'settings.customInstructionsDesc': 'Open Design이 모든 채팅에서 따르는 고정 지침입니다. 저장된 메모리가 아니며, 사실, 선호 사항, 프로젝트 컨텍스트에는 메모리를 사용하세요.',
  'mcpClient.forwardedToLabel': '전달 대상:',
  'mcpClient.notForwardedToLabel': '전달되지 않는 대상:',
  'mcpClient.forwardedAcpNote': 'stdio로 표시된 ACP 어댑터는 이 목록에서 stdio MCP 서버만 받습니다. HTTP 및 SSE 항목은 생성 시점에 제외됩니다.',
  'mcpClient.notForwardedNote': '해당 Agent의 경우 Agent 자체 구성 파일(예: ~/.codex/config.toml, ~/.gemini/settings.json)에서 MCP 서버를 구성하세요. 아래 서버는 거기서 자동으로 사용되지 않습니다.',

  // Brands library + extraction
  'brand.libraryTitle': '브랜드 키트',
  'brand.librarySubtitle': 'Teach Open Design your brand kits — extract one from a website, then apply it in any chat.',
  'brand.newBrand': 'New Brand Kit',
  'brand.searchPlaceholder': 'Search your brand kits…',
  'brand.empty': 'No brand kits yet. Extract one from a website to get started.',
  'brand.colorsCount': '{count} colors',
  'brand.extracting': 'Extracting…',
  'brand.failed': 'Extraction failed',
  'brand.needsInput': 'Needs input',
  'brand.needsInputHint': 'Extraction paused — open the project to finish verification or answer the question.',
  'brand.appliedToChat': 'Using {name}',
  'brand.previewEmpty': 'Select a brand to preview',
  'brand.viewDetails': 'View details',
  'newBrand.title': 'New Brand',
  'newBrand.subtitle': '웹사이트를 붙여넣거나 아래에서 브랜드를 선택하면 색상, 글꼴, 로고를 추출합니다.',
  'newBrand.urlLabel': 'Brand website',
  'newBrand.urlPlaceholder': 'yourcompany.com',
  'newBrand.extract': 'Extract brand',
  'newBrand.cancel': 'Cancel',
  'newBrand.close': 'Close',
  'newBrand.stage1': 'Fetching the site & measuring its design',
  'newBrand.stage2': 'Building a brand preview',
  'newBrand.stage3': 'Deriving & registering the design system',
  'newBrand.measured': '{colors} colors · {fonts} fonts · {logos} logos',
  'newBrand.done': 'Brand ready',
  'brandDetail.identity': 'Identity',
  'brandDetail.designLanguage': 'Design Language',
  'brandDetail.colors': 'Colors',
  'brandDetail.fonts': 'Fonts',
  'brandDetail.tone': 'Tone',
  'brandDetail.aesthetic': 'Aesthetic',
  'brandDetail.tagline': 'Tagline',
  'brandDetail.voice': 'Voice',
  'brandDetail.useInChat': 'Use in new chat',
  'brandDetail.delete': 'Delete brand',
  'brandDetail.back': '브랜드 키트',
  'brandDetail.refining': 'Refining this brand…',
  'brandDetail.notFound': 'Brand not found.',
  'brandDetail.logo': 'Logo',
  'brandDetail.typography': 'Typography',
  'brandDetail.palette': 'Palette',
  'brandDetail.voiceTone': 'Voice & tone',
  'brandDetail.imageryLayout': 'Imagery & layout',
  'brandDetail.images': 'Images',
  'brandDetail.designSystem': 'Design system',
  'brandDetail.brandAssets': 'Brand assets',
  'brandDetail.openProject': 'Open project',
  'brandDetail.themeLight': 'Light',
  'brandDetail.themeDark': 'Dark',
  'brandDetail.subjects': 'Subjects',
  'brandDetail.treatment': 'Treatment',
  'brandDetail.useLabel': 'Use',
  'brandDetail.avoidLabel': 'Avoid',
  'brandDetail.layoutPosture': 'Layout posture',
  'brandDetail.deleteConfirm': 'Delete "{name}"? This removes the brand and its design system.',
  'brandDetail.viewMore': 'Show all {count}',
  'brandDetail.viewLess': 'Show less',
  'settings.resetOnboarding': 'Reset onboarding',
  'settings.resetOnboardingDesc': 'Replay the first-run setup, including brand extraction.',
  'settings.resetOnboardingButton': 'Reset',
  'onboarding.brandTitle': 'Extract your brand kit',
  'onboarding.brandSubtitle': 'Paste a website and we\'ll turn its brand signals into a reusable brand kit for future work.',
  'onboarding.brandSkip': 'Skip for now',
  'onboarding.brandDone': 'Brand kit extracted',
  'onboarding.buildTitle': '한 번 만들어 어디서나 활용',
  'onboarding.buildBody': 'Open Design은 브랜드를 재사용 가능한 디자인 시스템으로 만들고, 이후 만드는 모든 결과물을 브랜드에 맞게 일관되게 유지합니다.',
  'onboarding.buildBenefitMemoryTitle': 'One brand memory',
  'onboarding.buildBenefitMemoryBody': 'Colors, type, spacing, components, and voice become a DESIGN.md your agents can reuse.',
  'onboarding.buildBenefitAlignedTitle': 'Every output stays aligned',
  'onboarding.buildBenefitAlignedBody': 'Prototype, slide, PDF, dashboard, and marketing work all pull from the same rules.',
  'onboarding.buildBenefitSourcesTitle': 'Start from what you have',
  'onboarding.buildBenefitSourcesBody': 'Use a GitHub repo, website, existing DESIGN.md, screenshots, fonts, or Figma files.',
  'onboarding.buildPreviewLabel': 'Brand system',
  'onboarding.buildStart': '디자인 시스템 만들기',
  'onboarding.buildHome': '홈으로 이동',
  'dsCreate.referenceLabel': 'Copy from existing design system',
  'dsCreate.referenceLoading': 'Loading DESIGN.md...',
  'dsCreate.referenceLoadFailed': 'Could not load that design system.',
  'dsCreate.heroShowGuideAria': 'Show design system guide',
  'dsCreate.heroHideGuideAria': 'Hide design system guide',
  'dsCreate.heroShowGuideTitle': 'Show guide',
  'dsCreate.heroHideGuideTitle': 'Hide guide',
  'dsCreate.heroGuide': 'Guide',
  'dsCreate.missingSourceError': 'Add a website, DESIGN.md, description, file, Figma source, or notes to create a design system.',
  'dsCreate.continueToGeneration': 'Continue to generation',
  'dsCreate.embeddedTitle': 'Generate from your material',
  'dsCreate.embeddedBody': 'Start with a website or brand reference, then add any source files you already have.',
  'dsCreate.sourceSectionTitle': 'Extract from GitHub, websites, or source material',
  'dsCreate.sourceSectionBody': 'Start with a GitHub repo, website, DESIGN.md, or files that show your style. Open Design first creates a usable system quickly, then AI can refine it inside the project.',
  'dsCreate.githubWebsiteLabel': 'GitHub or website',
  'dsCreate.add': 'Add',
  'dsCreate.startFromBrand': 'Start from a brand',
  'dsCreate.brandPickerSubtitle': 'Search hundreds of brands — pick one and we\'ll add its site as a style reference.',
  'dsCreate.brandPickerQuickPicks': 'Popular brands — click to add',
  'dsCreate.addedSourceLinks': 'Added source links',
  'dsCreate.openSourceLabel': 'Open {label}',
  'dsCreate.removeSourceLabel': 'Remove {label}',
  'dsCreate.addFiles': 'Add files',
  'dsCreate.describeBrand': 'Describe brand',
  'dsCreate.optional': 'optional',
  'dsCreate.describeBrandHelp': 'Brand voice, intro and product context. Used in the fast pass and AI refinement.',
  'dsCreate.companyPlaceholder': 'e.g. Mission Impastabowl: fast-casual pasta restaurant with kiosk, mobile app and website',
  'dsCreate.pasteDesignMd': 'Paste DESIGN.md',
  'dsCreate.pasteDesignMdHelp': 'Paste a DESIGN.md to create directly from tokens, rationale and component guidance.',
  'dsCreate.reference': 'Reference',
  'dsCreate.designMdViewMode': 'DESIGN.md view mode',
  'dsCreate.advancedToggle': 'Advanced — repo, local code, Figma',
  'dsCreate.githubRepo': 'GitHub repo',
  'dsCreate.localCodeLabel': 'Link local code',
  'dsCreate.localCodeHelper': 'Use a folder or selected files from this computer.',
  'dsCreate.localCodePrompt': 'Drag a folder here or browse',
  'dsCreate.uploadFigLabel': 'Upload .fig',
  'dsCreate.uploadFigHelper': 'Decoded on your machine into real tokens, components & assets — no Figma account.',
  'dsCreate.uploadFigPrompt': 'Drop .fig here or browse',
  'dsCreate.figmaUrl': 'Figma URL',
  'dsCreate.figmaPlaceholder': 'https://figma.com/design/… or /file/…',
  'dsCreate.addedFigmaUrls': 'Added Figma URLs',
  'dsCreate.savedFigmaHelp': 'Saved as a Figma design source. The agent uses it as the canonical reference; export a .fig above for a full offline decode.',
  'dsCreate.notes': 'Notes',
  'dsCreate.notesPlaceholder': 'e.g. We use a warm, earthy color palette with rounded corners. Our brand voice is playful but professional...',
  'dsCreate.back': 'Back',
  'dsCreate.generate': 'Generate',
  'dsCreate.libraryPickerTitle': 'Select from library',
  'dsCreate.libraryPickerConfirm': 'Add to assets',
  'dsCreate.designMdPreviewKicker': 'DESIGN SYSTEM',
  'dsCreate.designMdPreviewTitle': 'DESIGN.md preview',
  'dsCreate.componentKit': 'component kit',
  'dsCreate.defaultTheme': 'default theme',
  'dsCreate.componentKitTitle': '{name} — component kit',
  'dsCreate.designMdGeneratedDescription': 'Generated from pasted DESIGN.md tokens, rationale and component guidance.',
  'dsCreate.previewButtons': 'Buttons',
  'dsCreate.previewButtonsHelp': 'Five types across three sizes.',
  'dsCreate.buttonPrimary': 'Primary',
  'dsCreate.buttonDashed': 'Dashed',
  'dsCreate.buttonText': 'Text',
  'dsCreate.buttonLink': 'Link',
  'dsCreate.sizeSmall': 'Small',
  'dsCreate.sizeMedium': 'Medium',
  'dsCreate.sizeLarge': 'Large',
  'dsCreate.previewTypeScale': 'Type scale',
  'dsCreate.extractedTokens': 'Extracted DESIGN.md tokens',
  'brandPicker.heading': '좋아하는 브랜드로 시작하세요',
  'brandPicker.subtext': '브랜드를 클릭하면 해당 웹사이트에서 바로 브랜드 키트를 추출합니다.',
  'brandPicker.quickPicksLabel': '인기 브랜드 — 클릭하여 추출',
  'brandPicker.searchPlaceholder': '브랜드 검색…',
  'brandPicker.allCategories': '전체',
  'brandPicker.extractAction': '추출',
  'brandPicker.showMore': '더 보기',
  'brandPicker.opening': '추출을 시작하는 중 — {brand} 여는 중…',
  'ds.kitVisualize': '시각화',
  'ds.kitEdit': '편집',
  'ds.kitSource': '소스',
  'ds.saveDesignMd': 'DESIGN.md 저장',
  'ds.saving': '저장 중…',
  'ds.copyDesignMd': 'DESIGN.md 복사',
  'ds.editDesignMd': 'DESIGN.md 편집',
  'ds.openDesignMd': 'DESIGN.md 열기',
  'ds.copyDesignMdModule': '{module} 섹션 복사',
  'ds.editDesignMdModule': '{module} 섹션 편집',
  'ds.openDesignMdModule': '{module} 섹션 열기',
  'ds.uploadMd': 'MD 업로드',
  'ds.uploadFont': '글꼴 파일 추가',
  'ds.pasteImage': '이미지 붙여넣기',
  'ds.refresh': '새로고침',
  'ds.download': '다운로드',
  'ds.importFolder': '폴더 가져오기',
  'ds.reset': '초기화',
  'ds.editingDesignMdHint': '이 Markdown을 편집하면 렌더링된 키트 모듈이 업데이트됩니다.',
  'ds.editingModuleHint': '{module} 모듈만 편집 중입니다.',
  'ds.manualEditModuleHint': 'Edit {module} here. Hover this section to reveal controls.',
  'ds.saveModule': '모듈 저장',
  'ds.uploadLogo': '로고 업로드',
  'ds.uploadImage': '이미지 업로드',
  'ds.uploading': '업로드 중…',
  'ds.moduleEmptyLogo': '아직 로고 없음',
  'ds.moduleEmptyFonts': '캡처된 글꼴이 없습니다.',
  'ds.actionDone': '완료',
  'ds.actionFailed': '문제가 발생했습니다. 다시 시도하세요.',
  'ds.uploadDone': '업로드됨',
  'ds.uploadFailed': '업로드에 실패했습니다. 다시 시도하세요.',
  'ds.deleteLogo': '로고 삭제',
  'ds.deleteImage': '{caption} 삭제',
  'ds.deleteProjectConfirm': '“{title}”을(를) 삭제할까요? 이 디자인 시스템과 해당 프로젝트가 이 기기에서 영구적으로 제거됩니다.',
  'ds.deleteProjectAction': '{title} 삭제',
  'ds.editColor': '{name} 편집',
  'ds.colorLabel': '색상',
  'ds.hexLabel': 'Hex',
  'ds.hexValueLabel': 'Hex 값',
  'ds.saveColor': '색상 저장',
  'ds.invalidHexColor': '#FF6A3D 같은 올바른 Hex 색상을 입력하세요.',
  'ds.colorSaveFailed': '이 색상을 저장할 수 없습니다.',
  'ds.colorResetFailed': '이 색상을 초기화할 수 없습니다.',
  'ds.designMdSectionLabel': '{module} DESIGN.md 섹션',
  'ds.kitErrorTitle': '이 보기에서 문제가 발생했습니다.',
  'ds.kitErrorRetry': '다시 로드',
  'ds.shortcutsLabel': '키보드 단축키',
  'ds.shortcutsHint': '단축키: E 편집 · C 복사 · U 업로드 · R 새로고침 · ⌫ 로고 삭제',
  'ds.moduleEmptyImages': '아직 이미지 없음',
  'ds.noOriginalColor': 'No original color is available for this swatch.',
  'ds.manifestReadFailed': 'Unable to read _ds_manifest.json.',
  'ds.reviewCollapseSection': 'Collapse {title}',
  'ds.reviewExpandSection': 'Expand {title}',
  'ds.reviewNeedsReview': 'Needs review',
  'ds.reviewLooksGood': 'Looks good',
  'ds.reviewActionsLabel': '{title} review',
  'ds.reviewNeedsWorkEllipsis': 'Needs work...',
  'ds.reviewEditFile': 'Edit {file}',
  'ds.reviewFeedbackLabel': 'Tell the agent what to change',
  'ds.reviewFeedbackPlaceholder': 'e.g. tighten spacing in {title}, regenerate this preview...',
  'ds.reviewChangedAfterFeedback': 'This section changed after your feedback. Review it again before publishing.',
  'ds.reviewChangedDuringRun': 'This section changed during the latest run. Review it before publishing.',
  'ds.reviewLastFeedback': 'Last feedback',
  'ds.previewGenerating': 'Generating preview...',
  'ds.creatingProjectTitle': 'Creating your design system...',
  'ds.creatingProjectSubtitle': 'Keep this tab open. You can come back in a few minutes.',
  'ds.generationProgressLabel': 'Design system generation progress {progress}%',
  'ds.publishRepoRequiredTitle': 'Finish importing your GitHub repo before you can publish.',
  'ds.publishDesignSystem': 'Publish design system',
  'ds.unpublishDesignSystem': 'Unpublish design system',
  'ds.published': 'Published',
  'ds.publish': 'Publish',
  'ds.extractionRunningTitle': 'Extracting design system',
  'ds.extractionCompleteTitle': 'Extraction complete',
  'ds.extractionRunningBody': 'Open Design is updating this system in place.',
  'ds.extractionCompleteBody': 'All extracted modules are shown below; empty sections are intentionally blank.',
  'ds.publishCardPublished': 'Your team\'s new projects can use this design system as context by default.',
  'ds.publishCardDraft': 'Your design system is ready, but your feedback will improve it. Publish it when it is ready to use in future projects.',
  'ds.useSystemTitle': 'Use this system',
  'ds.useSystemBody': 'Start a new design that inherits this system\'s colors, type, and components - kept on-brand automatically.',
  'ds.createNewDesign': 'Create new design',
  'ds.openSourceContext': 'Open source context',
  'ds.manifestNeedsAttention': 'Design manifest needs attention',
  'ds.openManifest': 'Open manifest',
  'ds.workspacePreparing': 'Preparing the design system workspace.',
  'ds.workspaceLoadingLabel': 'Design system workspace is loading',
  'ds.sectionQueued': 'Queued',
  'ds.sectionReviewUpdatedFiles': 'Updated files need review',
  'ds.reviewNeedsWork': 'Needs work',
  'ds.sectionRequiredFileMissing': 'Required file missing: {file}',
  'ds.sectionNoFilesYet': 'No files yet',
  'ds.generationSourceTitle': 'Source context',
  'ds.generationSourceDetail': 'Reading linked source context and repository evidence.',
  'ds.generationGuidanceTitle': 'Brand guidance',
  'ds.generationGuidanceDetail': 'Writing DESIGN.md guidance and voice.',
  'ds.generationTokensTitle': 'Design tokens',
  'ds.generationTokensDetail': 'Extracting colors, type, and spacing tokens.',
  'ds.generationPreviewsTitle': 'Preview cards',
  'ds.generationPreviewsDetail': 'Rendering reviewable preview cards.',
  'ds.generationUiKitTitle': 'UI kit',
  'ds.generationUiKitDetail': 'Creating reusable components and patterns.',
  'ds.generationAssetsTitle': 'Brand assets',
  'ds.generationAssetsDetail': 'Collecting logos, fonts, images, and icons.',
  'ds.phaseQueuedTypography': 'Typography queued',
  'ds.phaseQueuedTokens': 'Tokens queued',
  'ds.phaseQueuedSpacing': 'Spacing queued',
  'ds.phaseQueuedUiKit': 'UI kit queued',
  'ds.phaseQueuedAssets': 'Assets queued',
  'ds.phaseReadingTypography': 'Reading typography',
  'ds.phaseReadingTokens': 'Reading tokens',
  'ds.phaseReadingSpacing': 'Reading spacing',
  'ds.phaseReadingUiKit': 'Reading UI kit',
  'ds.phaseReadingAssets': 'Reading assets',
  'ds.phaseWritingTypography': 'Writing typography',
  'ds.phaseWritingTokens': 'Writing tokens',
  'ds.phaseWritingSpacing': 'Writing spacing',
  'ds.phaseBuildingUiKit': 'Building UI kit',
  'ds.phaseUpdatingAssets': 'Updating assets',
  'ds.phaseNeedsAttention': 'Needs attention',
  'ds.phaseUpdated': 'Updated',
  'ds.sectionActivityFromTodo': '{phase}: {todo}',
  'ds.sectionActivityReadFiles': 'Read {files}',
  'ds.sectionActivityPhaseFiles': '{phase}: {files}',
  'ds.sectionRunningReadingContext': 'Reading context for {title}.',
  'ds.sectionRunningNow': '{phase} now.',
  'ds.reviewLastReviewed': 'Last reviewed {time}',
  'ds.agentFeedbackQueued': 'Agent feedback queued',
  'ds.agentFeedbackSent': 'Agent feedback sent',
  'ds.agentFeedbackSentAt': 'Agent feedback sent {time}',
  'ds.agentFeedbackFailedWithError': 'Agent feedback failed: {error}',
  'ds.agentFeedbackFailed': 'Agent feedback failed',
  'ds.agentFeedbackUnknown': 'Agent feedback status unknown',
  'ds.repoConnectBannerTitle': 'Connect your repo to pull aspects of your design system',
  'ds.repoConnectCardTitle': 'Connect your repo',
  'ds.repoConnectPendingBody': 'Checking your GitHub connection...',
  'ds.repoConnectPendingButton': 'Checking GitHub...',
  'ds.repoConnectedTitle': 'GitHub is connected',
  'ds.repoConnectedBody': 'Re-import this repo to pull its files into your design system.',
  'ds.repoImportButton': 'Import repo',
  'ds.repoConnectBannerBody': 'Connect GitHub so Open Design can read your repository and pull colors, type, and components into this design system.',
  'ds.repoConnectCardBody': 'Pull colors, type, and components from your repository into this design system.',
  'ds.repoConnectButton': 'Connect GitHub',
  'newproj.startFromLabel': '시작 방식',
  'newproj.startBlank': '빈 화면',
  'newproj.startBlankHint': '처음부터 만들기',
  'workspace.pages': '페이지',
  'workspace.allProjectFiles': '프로젝트 전체 파일',
  'workspace.newBlankPage': '새 빈 페이지',
  'workspace.noPagesYet': '아직 페이지가 없습니다',
  'workspace.pageCreateFailed': '페이지를 만들지 못했습니다.',
  'workspace.pageCreatorTitle': '페이지 만들기',
  'workspace.pageCreatorSearch': '템플릿 검색',
  'workspace.pageCreatorCategoryAll': '모든 장면',
  'workspace.pageCreatorEmpty': '검색과 일치하는 페이지 유형이 없습니다.',
  'workspace.pageCreatorPreview': '미리보기',
  'workspace.pageCreatorUse': '사용',
  'fileViewer.presentInTabDeckHint': '발표자 노트를 팝업 창에 표시',
  'fileViewer.presentEscHint': 'Esc 키를 눌러 종료',
  'fileViewer.presenterPause': '일시정지',
  'fileViewer.presenterResume': '재개',
  'fileViewer.presenterPrevious': '이전',
  'fileViewer.presenterNext': '다음',
  'questions.uploadingFiles': '파일 업로드 중…',
  'questions.uploadNeedsProject': '파일 업로드에는 활성 프로젝트가 필요합니다.',
  'questions.uploadPartialFailed': '{uploaded}개 파일을 업로드했지만 {failed}개가 실패했습니다.',
  'questions.uploadFailed': '{failed}개 파일 업로드에 실패했습니다.',
};
